<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get("shared.employees") }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get("shared.dashboard") }}</span>
        </li>
        <li>
          <span>{{ $ml.get("shared.employees") }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-3">
          <div class="input-group" style="margin-bottom:7px;">
            <input @keyup.enter="getEmployeesFromCardNoFast(searchText)" type="text"
              :placeholder="$ml.get('employees.searchEmployeeInList')" v-model="searchText" class="form-control"
              autocomplete="false" />
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary">
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
          <div class="box box-primary">
            <div class="box-header with-border">
              <i class="fa fa-user"></i>
              <h3 class="box-title">
                <span>{{ $ml.get("employees.employeeList") }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#modal-filtre">
                  <i class="fa fa-filter"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div v-show="employeeList.length > 0" class="table-responsive no-padding"
                style="max-height:945px;overflow:auto;">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th @click="setOrderEmp(1)" style="cursor:pointer;min-width:75px;">
                        <strong>
                          {{ $ml.get('employees.registrationNumberInfo') }}
                          <i v-show="orderEmpList == 1" class="fa fa-sort-numeric-asc"></i>
                          <i v-show="orderEmpList == 2" class="fa fa-sort-numeric-desc"></i>
                        </strong>
                      </th>
                      <th @click="setOrderEmp(2)" style="cursor:pointer;">
                        <strong>
                          {{ $ml.get('employees.nameSurname') }}
                          <i v-show="orderEmpList == 3" class="fa fa-sort-alpha-asc"></i>
                          <i v-show="orderEmpList == 4" class="fa fa-sort-alpha-desc"></i>
                        </strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="employee.id == employee1.id ? 'bg-primary' : ''" style="cursor:pointer;"
                      @click="getEmployee(employee1.id)" v-for="employee1 in filtered" :key="employee1.id">
                      <td>{{ employee1.sicilNo }}</td>
                      <td>
                        {{ employee1.name }}
                        <span v-show="employee1.title">({{ employee1.title }})</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="employeeList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get("employees.employeeSearchNotFound") }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingEmployee">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get("employees.employeeInfo") }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button @click="newEmployee()" type="button" class="btn btn-sm btn-warning">
                  <i class="fa fa-user-plus"></i>
                  {{ $ml.get("employees.newEmployee") }}
                </button>
                <button v-show="isNewEmployee && employee.isActive != false && authControl == 0" type="button"
                  class="btn btn-sm btn-success" style="margin: 5px; width:120px;" data-toggle="modal"
                  data-target="#modal-kaydet">
                  <i class="fa fa-check"></i>
                  {{ $ml.get('employees.saveEmployee') }}
                </button>
                <button v-show="!isNewEmployee && employee.isActive != false && authControl == 0" type="button"
                  class="btn btn-sm btn-success" style="margin: 5px; width:120px;" data-toggle="modal"
                  data-target="#modal-guncelle">
                  <i class="fa fa-refresh"></i>
                  {{ $ml.get('employees.updateEmployee') }}
                </button>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-3">
                  <div class="box box-primary">
                    <div class="box-body box-profile">
                      <img class="profile-user-img img-responsive"
                        :src="(this.employee.image == null && this.tempUrl == null) || (this.employee.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.employee.image || this.tempUrl"
                        style="width:100%;" />
                      <div class="text-center">
                        <a href="#" v-show="this.tempUrl || this.employee.image" @click="removeImage()"
                          class="text-red mt-1">
                          <i class="fa fa-remove"></i>
                          {{ $ml.get('employees.removePhoto') }}
                        </a>
                      </div>
                      <hr />
                      <my-upload field="img" @crop-success="cropSuccess" langType="tr" v-model="showImageDialog"
                        :width="300" :height="300" url="/images" :params="params" :headers="headers"
                        img-format="png"></my-upload>
                      <button type="button" @click="toggleShow()" class="btn btn-primary btn-sm" style="width:100%">
                        <i class="fa fa-upload"></i>
                        {{ $ml.get('employees.selectPhoto') }}
                      </button>
                      <hr />
                      <h3 class="profile-username text-center">
                        <span v-show="employee.name != ''">{{ employee.name }}</span>
                        <span v-show="employee.isActive == false" class="badge label-danger">{{
                          $ml.get('employees.deletedRecord') }}</span>
                      </h3>
                      <p class="text-muted text-center">
                        <span v-show="employee.title != ''">{{ employee.title }}</span>
                      </p>
                      <p class="text-muted text-center">
                        <span v-show="employee.departmentId != null">{{ getDepartmentFromId(employee.departmentId)
                        }}</span>
                      </p>
                      <hr v-show="employee.departmentId != null" />
                      <div v-show="modules.dormitory" class="row text-center" style="margin-top:10px">
                        <div class="col-sm-12">
                          <b>
                            <span>{{ $ml.get('employees.recordType') }}</span>
                          </b>
                        </div>
                        <div class="col-sm-12">
                          <select @change="changeRecordType($event)" class="form-control text-center" style>
                            <option :selected="!employee.isStudent" value="1">{{ $ml.get('employees.employee') }}
                            </option>
                            <option :selected="employee.isStudent" value="2">{{ $ml.get('employees.student') }}</option>
                          </select>
                        </div>
                        <hr />
                      </div>
                      <div v-show="modules.dormitory && employee.isStudent" class="row text-center"
                        style="margin-top:10px;">
                        <div class="col-sm-12">
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="employee.isStayInDormitory"
                                @change="employee.isStayInDormitory == true ? employee.isStayInDormitory = false : employee.isStayInDormitory = true"
                                type="checkbox" />
                              <span
                                v-text="employee.isStayInDormitory ? $ml.get('employees.doesStayInTheDormitory') : $ml.get('employees.doesNotStayInTheDormitory')"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                      <div v-show="modules.diningHall" class="row text-center" style="margin-top:10px;">
                        <div class="col-sm-12">
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="employee.foodClaim"
                                @change="employee.foodClaim == true ? employee.foodClaim = false : employee.foodClaim = true"
                                type="checkbox" />
                              <span>{{ $ml.get("employees.foodClaim") }}</span>
                            </label>
                          </span>
                        </div>
                      </div>
                      <!--<div v-show="(employee.id && employee.isVisitor) || !employee.id" class="row text-center" style="margin-top:10px;">
                        <div class="col-sm-12">
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input
                                :checked="employee.isVisitor"
                                @change="employee.isVisitor==true ? employee.isVisitor=false : employee.isVisitor=true"
                                type="checkbox"
                              />
                              <span>{{$ml.get('employees.isVisitorCard')}}</span>
                            </label>
                          </span>
                        </div>
                      </div>-->
                      <div class="row" style="margin-top:10px;">
                        <div class="col-sm-12 text-center">
                          <b>
                            <span>{{ $ml.get('employees.registrationNumber') }}</span>
                          </b>
                        </div>
                        <div class="col-sm-12 text-center">
                          <a>
                            <span v-show="employee.sicilNo == ''">-</span>
                            <span v-show="employee.sicilNo != ''">{{ employee.sicilNo }}</span>
                          </a>
                        </div>
                      </div>
                      <div class="row" style="margin-top:10px;">
                        <div class="col-sm-12 text-center">
                          <b>
                            <span v-show="!employee.isStudent">{{ $ml.get('employees.dateOfStartWork') }}</span>
                            <span v-show="employee.isStudent">{{ $ml.get('employees.dateOfStart') }}</span>
                          </b>
                        </div>
                        <div class="col-sm-12 text-center">
                          <a>
                            <span v-show="employee.startDate == null">-</span>
                            <span v-show="employee.startDate != ''">{{ employee.startDate |
                              toDateFormatGet("gg.aa.yyyy") }}</span>
                          </a>
                        </div>
                      </div>
                      <div class="row" style="margin-top:10px;">
                        <div class="col-sm-12 text-center">
                          <b>
                            <span v-show="!employee.isStudent">{{ $ml.get('employees.dateOfEndWork') }}</span>
                            <span v-show="employee.isStudent">{{ $ml.get('employees.dateOfEnd') }}</span>
                          </b>
                        </div>
                        <div class="col-sm-12 text-center">
                          <a>
                            <span v-show="employee.endDate == null">-</span>
                            <span v-show="employee.endDate != '' || employee.endDate != null">{{ employee.endDate |
                              toDateFormatGet("gg.aa.yyyy") }}</span>
                          </a>
                        </div>
                      </div>

                      <div v-show="modules.dormitory && employee.isStudent && employee.isStayInDormitory" class="row"
                        style="margin-top:10px;">
                        <div class="col-sm-12 text-center">
                          <b>
                            <span>{{ $ml.get('employees.roomInformation') }}</span>
                          </b>
                        </div>
                        <div :class="employee.roomId ? 'col-sm-12 text-center' : 'col-sm-12 text-center'"
                          style="margin-left:10px;">
                          <a v-show="employee.roomId == 0 || employee.roomId == null">-</a>
                          <a v-show="employee.roomId != 0 && employee.roomId != null">
                            <i class="fa fa-building"></i>
                            : {{ employee.areaName }}
                            <br />
                            <i class="fa fa-th"></i>
                            : {{ employee.floorName }}
                            <br />
                            <i class="fa fa-home"></i>
                            : {{ employee.roomName }}
                            <br />
                          </a>
                        </div>
                      </div>
                      <hr />
                      <div class="row">
                        <div class="col-sm-12 text-center">
                          <div class="justify-between-content text-center">
                            <img style="width:30px; margin:5px;"
                              :title="employee.hasPassword ? $ml.get('employees.passwordExist') : $ml.get('employees.passwordNotExist')"
                              :src="employee.hasPassword ? '/src/assets/password-true.png' : '/src/assets/password-false.png'" />
                            <img style="width:30px; margin:5px;"
                              :title="employee.hasCard ? $ml.get('employees.cardNumberExist') : $ml.get('employees.cardNumberNotExist')"
                              :src="employee.hasCard ? '/src/assets/card-true.png' : '/src/assets/card-false.png'" />
                            <img style="width:30px; margin:5px;"
                              :title="employee.hasFinger ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')"
                              :src="employee.hasFinger ? '/src/assets/fingerprint-true.png' : '/src/assets/fingerprint-false.png'" />
                            <img style="width:30px; margin:5px;"
                              :title="employee.hasFace ? $ml.get('employees.faceTemplateExist') : $ml.get('employees.faceTemplateNotExist')"
                              :src="employee.hasFace ? '/src/assets/face-true.png' : '/src/assets/face-false.png'" />
                          </div>
                        </div>
                      </div>
                      <div class="row" style="margin-top:5px;">
                        <div class="col-sm-12 text-center">
                          <button :disabled="isNewEmployee || authControl == 1" class="btn btn-success btn-sm"
                            style="width:100%;" @click="selectGetFingerFromUsb()">
                            <i class="fa fa-hand-o-up"></i>
                            {{ $ml.get('employees.fingerPrintInformation') }}
                          </button>
                        </div>
                      </div>
                      <hr />
                      <div class="row">
                        <div class="col-sm-12 text-center">
                          <button :disabled="isNewEmployee || authControl == 1" v-show="employee.isActive != false"
                            type="button" class="btn btn-sm btn-danger" data-toggle="modal"
                            data-target="#modal-istencikis">
                            <i class="fa fa-sign-out"></i>
                            {{ $ml.get('employees.setLeaveDate') }}
                          </button>
                        </div>
                        <div class="col-sm-12 text-center" style="margin-top:10px;">
                          <button @click="removeLeaveEmployee()" :disabled="isNewEmployee || authControl == 1"
                            v-show="employee.endDate != null" type="button" class="btn btn-sm btn-warning">
                            <i class="fa fa-sign-in"></i>
                            <span v-show="!employee.isStudent">{{ $ml.get('employees.backToWork') }}</span>
                            <span v-show="employee.isStudent">{{ $ml.get('employees.reActivate') }}</span>
                          </button>
                        </div>
                        <div class="col-sm-12 text-center" style="margin-top:10px;">
                          <button v-show="!isNewEmployee && employee.isActive != false && authControl == 0"
                            type="button" value="Sil" class="btn btn-sm btn-danger" style="margin: 5px; width:120px;"
                            data-toggle="modal" data-target="#modal-sil">
                            <i class="fa fa-user-times"></i>
                            {{ $ml.get('employees.deleteEmployee') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li class="active">
                        <a href="#temel-bilgiler" data-toggle="tab" aria-expanded="true">
                          <span
                            v-text="employee.isStudent ? $ml.get('employees.studentInformation') : $ml.get('employees.generalInformation')"></span>
                        </a>
                      </li>
                      <li>
                        <a href="#gruplamalar" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.extraFields') }}</a>
                      </li>
                      <li>
                        <a href="#mobil-gecis" data-toggle="tab" aria-expanded="true">{{ $ml.get('employees.mobileApp')
                        }}</a>
                      </li>
                      <li v-show="!employee.isVisitor">
                        <a href="#diger-bilgileri" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.otherInformation') }}</a>
                      </li>
                      <li>
                        <a href="#yetkiler" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.accessAuthorities') }}</a>
                      </li>
                      <li>
                        <a href="#hareketler" data-toggle="tab" aria-expanded="true">{{ $ml.get('employees.movements')
                        }}</a>
                      </li>
                      <li v-show="!employee.isVisitor">
                        <a href="#izinler" data-toggle="tab" aria-expanded="true">{{ $ml.get('employees.allowences')
                        }}</a>
                      </li>
                      <li v-show="modules.payroll && !employee.isVisitor">
                        <a href="#puantaj" data-toggle="tab" aria-expanded="true">{{ $ml.get('employees.payroll') }}</a>
                      </li>
                      <li v-show="modules.annualPermit && !employee.isVisitor">
                        <a href="#yillik-izin" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.annualPermit') }}</a>
                      </li>
                      <li v-show="!employee.isVisitor && !employee.isStudent">
                        <a href="#salary" data-toggle="tab" aria-expanded="true">{{ $ml.get('employees.salary')
                        }}</a>
                      </li>
                      <li v-show="!employee.isVisitor">
                        <a href="#odemeler" data-toggle="tab" aria-expanded="true">{{ $ml.get('employees.payments')
                        }}</a>
                      </li>
                      <li>
                        <a href="#gorev-yerleri" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.workPlaces') }}</a>
                      </li>
                      <li>
                        <a href="#documents" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.documents') }}</a>
                      </li>
                      <li>
                        <a href="#inventories" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.assignedInventory') }}</a>
                      </li>
                      <li>
                        <a href="#islem-gecmisi" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.employeeLogs') }}</a>
                      </li>
                      <li>
                        <a href="#kart-baski" data-toggle="tab" aria-expanded="true">{{
                          $ml.get('employees.cardPrinting') }}</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="temel-bilgiler">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.registrationNumberInfo') }}</label>
                              <div class="input-group">
                                <input v-model="employee.sicilNo" type="text" class="form-control" autocomplete="off" />
                                <span class="input-group-btn">
                                  <button @click="getNewSicilveTerminalNo()" class="btn btn-primary">
                                    <i class="fa fa-refresh"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6" v-show="!employee.isVisitor">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.citizenshipNumber') }}</label>
                              <input v-model="employee.identityNo" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label v-show="employee.isVisitor">{{ $ml.get('visitorCards.cardName') }}</label>
                              <label v-show="!employee.isVisitor">{{ $ml.get('employees.nameSurname') }}</label>
                              <input v-model="employee.name" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.department') }}</label>
                              <div class="input-group">
                                <label id="selectedNode" @click="selectNode()"
                                  v-show="employee.departmentId != null && employee.departmentId != 0"
                                  class="form-control tdb-box">{{ getDepartmentFromId(employee.departmentId) }}</label>
                                <label v-show="employee.departmentId == null || employee.departmentId == 0"
                                  class="form-control">{{ $ml.get('general.notSelected') }}</label>
                                <div class="input-group-btn">
                                  <button class="btn btn-primary" data-toggle="modal" data-target="#select-department">
                                    <i class="fa fa-search"></i>
                                  </button>
                                  <button v-show="employee.departmentId != null && employee.departmentId != ''"
                                    class="btn btn-danger" @click="employee.departmentId = null">
                                    <i class="fa fa-remove"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6 col-md-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.title') }}</label>
                              <input v-model="employee.title" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.dateofBirth') }}</label>
                              <input type="date" class="form-control" v-model="employee.birthDayDate" />
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <div class="form-group" style="margin-bottom:5px;">
                              <label>{{ $ml.get('employees.status') }}</label>
                              <div :class="authControl == 0 ? 'input-group' : 'form-group'">
                                <select @change="changeStatus($event)" class="form-control">
                                  <option :selected="employee.statuId == null" value>{{ $ml.get('general.select') }}
                                  </option>
                                  <option v-for="statu in statuList" :key="statu.id" :value="statu.id"
                                    :selected="statu.id == employee.statuId">{{ statu.name }}</option>
                                </select>
                                <span class="input-group-btn" v-show="authControl == 0">
                                  <button data-toggle="modal" data-target="#modal-statu" class="btn btn-primary">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <div class="form-group">
                              <label>
                                <span
                                  v-text="employee.isStudent ? $ml.get('employees.dateOfStart') : $ml.get('employees.dateOfStartWorkInfo')"></span>
                              </label>
                              <input type="date" class="form-control" v-model="employee.startDate" />
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <div class="form-group" style="margin-bottom:5px;">
                              <label>{{ $ml.get('employees.state') }}</label>
                              <div :class="authControl == 0 ? 'input-group' : 'form-group'">
                                <select @change="changeStates($event)" class="form-control">
                                  <option :selected="employee.stateId == null" value>{{ $ml.get('general.select') }}
                                  </option>
                                  <option v-for="state in stateList" :key="state.id" :value="state.id"
                                    :selected="state.id == employee.stateId">{{ state.name }}</option>
                                </select>
                                <span class="input-group-btn" v-show="authControl == 0">
                                  <button data-toggle="modal" data-target="#modal-durum" class="btn btn-primary">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <div class="form-group" style="margin-bottom:5px;">
                              <label>{{ $ml.get('employees.stateNote') }}</label>
                              <input v-model="employee.stateNote" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div v-show="modules.smsOrMail && employee.isStudent" class="col-sm-6 col-md-6">
                            <div class="form-group" style="margin-bottom:5px;">
                              <label>{{ $ml.get('employees.activateSmsSystem') }}</label>
                              <span class="form-control checkbox">
                                <label style="margin-left:20px;">
                                  <input :checked="employee.isSmsSend"
                                    @change="employee.isSmsSend == true ? employee.isSmsSend = false : employee.isSmsSend = true"
                                    type="checkbox" />
                                  {{ $ml.get('general.active') }}
                                </label>
                              </span>
                            </div>
                          </div>
                          <div v-show="modules.smsOrMail && employee.isStudent" class="col-sm-6 col-md-6">
                            <div class="form-group" style="margin-bottom:5px;">
                              <label>{{ $ml.get('employees.smsSendPhone') }}</label>
                              <input v-model="employee.parentPhone" type="tel" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-sm-6 form-group">
                            <label>{{ $ml.get('employees.deviceEmployeeNumber') }}</label>
                            <label v-if="modules.isDisabledTerminalNo" class="form-control"
                              style="margin-bottom:0px;">{{ employee.terminalNo }}</label>
                            <div v-if="!modules.isDisabledTerminalNo" class="input-group">
                              <input v-model="employee.terminalNo" type="text" class="form-control" />
                              <span class="input-group-btn">
                                <button @click="getNewSicilveTerminalNo()" class="btn btn-primary">
                                  <i class="fa fa-refresh"></i>
                                </button>
                              </span>
                            </div>
                          </div>
                          <div class="col-sm-6 form-group">
                            <label>{{ $ml.get('employees.deviceStatus') }}</label>
                            <select @change="changeTerminalStatu($event)" class="form-control">
                              <option :selected="employee.terminalStatu == 0" :value="0">User</option>
                              <option :selected="employee.terminalStatu == 3" :value="3">Admin</option>
                            </select>
                          </div>
                          <div class="col-sm-6 form-group">
                            <label>{{ $ml.get('employees.devicePassword') }}</label>
                            <input v-model="employee.terminalPassword" type="text" class="form-control"
                              autocomplete="off" />
                          </div>
                          <div class="col-sm-6 form-group">
                            <label>{{ $ml.get('employees.deviceCardNo') }}</label>
                            <input v-model="employee.cardNo" type="text" class="form-control" autocomplete="off" />
                          </div>
                          <div class="col-sm-6 form-group" v-show="modules.timezone">
                            <label>Timezone</label>
                            <input v-model="employee.tzCode" type="text" class="form-control" autocomplete="off" />
                          </div>
                          <div class="col-sm-6 form-group" v-show="modules.licencePlateRecognition && modules.plate">
                            <label>{{ $ml.get('employees.plateNo') }}</label>
                            <input v-model="employee.plateNo" type="text" class="form-control" autocomplete="off" />
                          </div>
                          <div class="col-sm-6 form-group" v-show="modules.licencePlateRecognition && modules.hgs">
                            <label>{{ $ml.get('employees.hgsNo') }}</label>
                            <input v-model="employee.hgsNo" type="text" class="form-control" autocomplete="off" />
                          </div>
                        </div>
                        <div class="row" style="margin-top:10px;" v-show="modules.memberManagement">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.validityStartDate') }}</label>
                              <input v-model="employee.validityStartDate" type="date" class="form-control" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.validityEndDate') }}</label>
                              <input v-model="employee.validityEndDate" type="date" class="form-control" />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div class="row">
                          <div v-show="!employee.isStudent" :class="!modules.diningHall ? 'col-sm-12' : 'col-sm-6'">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.workPlan') }}</label>
                              <select @change="changeWorkGroups($event)" class="form-control"
                                style="margin-bottom:5px;">
                                <option :selected="employee.workGroupId == null" value>{{ $ml.get('general.select') }}
                                </option>
                                <option v-for="workGroup in periodWorkGroupList" :key="workGroup.id"
                                  :value="workGroup.id" :selected="workGroup.id == employee.workGroupId">
                                  {{ workGroup.name }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6" v-show="modules.diningHall">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.foodGroup') }}</label>
                              <select @change="changeFoodGroup($event)" class="form-control" style="margin-bottom:5px;">
                                <option :selected="employee.foodGroupId == 0" :value="0">{{ $ml.get('general.select') }}
                                </option>
                                <option v-for="foodGroup in foodGroupList" :key="foodGroup.id"
                                  :selected="employee.foodGroupId == foodGroup.id" :value="foodGroup.id">
                                  {{ foodGroup.name }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label v-show="modules.customFieldName == ''">{{ $ml.get('employees.documentNo')
                              }}</label>
                              <label v-show="modules.customFieldName != ''">{{ modules.customFieldName }}</label>
                              <input v-model="employee.documentNo" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                          <div v-show="!employee.isStudent" class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.overtimeStatus') }}</label>
                              <span class="form-control checkbox">
                                <label style="margin-left:20px;">
                                  <input :checked="employee.overWorkStatus"
                                    @change="employee.overWorkStatus == true ? employee.overWorkStatus = false : employee.overWorkStatus = true"
                                    type="checkbox" />
                                  {{ $ml.get('employees.takesOvertime') }}
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-show="employee.isStudent" class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.motherName') }}</label>
                              <input v-model="employee.motherName" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.motherPhone') }}</label>
                              <input v-model="employee.motherPhone" type="tel" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.fatherName') }}</label>
                              <input v-model="employee.fatherName" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.fatherPhone') }}</label>
                              <input v-model="employee.fatherPhone" type="tel" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--GENEL BİLGİLER SONU-->
                      <div class="tab-pane" id="gruplamalar">
                        <div class="box box-primary">
                          <div class="box-header with-border">
                            <h3 class="box-title">
                              <span>{{ $ml.get('employees.extraFields') }}</span>
                            </h3>
                            <div class="box-tools">
                              <div class="pull-right">
                                <button :disabled="isNewEmployee || authControl == 1"
                                  v-show="employee.isActive != false" @click="newExtraField()"
                                  class="btn btn-warning btn-sm">
                                  <i class="fa fa-plus"></i>
                                  {{ $ml.get('employees.createExtraField') }}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="box-body" style="color:black;">
                            <div class="row">
                              <div class="col-sm-4" style="margin-bottom:10px;">
                                <div class="input-group">
                                  <span class="input-group-addon">{{ $ml.get('employees.keyExtraField') }}</span>
                                  <select @change="changeExtraFieldKey($event)" class="form-control">
                                    <option :selected="extraFieldKey == null" value>{{ $ml.get('general.notSelected') }}
                                    </option>
                                    <option v-for="ef in extraFieldList" :key="ef.id" :value="ef.id"
                                      :selected="ef.id == extraFieldKey">{{ ef.name }}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-sm-4">
                                <div class="form-group">
                                  <div class="input-group">
                                    <span class="input-group-addon">{{ $ml.get('employees.valueExtraField') }}</span>
                                    <input v-model="extraFieldValue" type="text" class="form-control" />
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-3" style="margin-bottom:10px;">
                                <button :disabled="isNewEmployee || authControl == 1"
                                  v-show="employee.isActive != false" @click="saveExtraField()" class="btn btn-success"
                                  style="width:100%;">
                                  <i class="fa fa-check"></i>
                                  {{ $ml.get('employees.saveExtraField') }}
                                </button>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-12">
                                <div v-show="employeeExtraFieldList.length > 0" class="table-responsive no-padding"
                                  style="max-height:550px; overflow:auto;">
                                  <table class="table table-hover">
                                    <tbody>
                                      <tr v-for="(employeeExtraField, index) in employeeExtraFieldList" :key="index">
                                        <td>{{ getExtraFieldNameFromKey(employeeExtraField.key) }}</td>
                                        <td>{{ employeeExtraField.value }}</td>
                                        <td style="width:40px;">
                                          <button v-show="employee.isActive != false"
                                            @click="selectExtraField(employeeExtraField.id, employeeExtraField.value, employeeExtraField.key)"
                                            class="btn btn-primary btn-sm">
                                            <i class="fa fa-search"></i>
                                          </button>
                                        </td>
                                        <td style="width:40px;">
                                          <button v-show="employee.isActive != false"
                                            @click="deleteExtraField(employeeExtraField.id)"
                                            class="btn btn-danger btn-sm">
                                            <i class="fa fa-trash"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div v-show="employeeExtraFieldList.length == 0" class="callout callout-info">
                                  <i class="fa fa-info-circle"></i>
                                  {{ $ml.get('employees.extraFieldNotRecord') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--GRUPLAMALAR SONU-->
                      <div class="tab-pane" id="mobil-gecis" v-show="modules.mobileApp && !employee.isVisitor">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.isMobileAppUser') }}</label>
                              <span class="form-control checkbox">
                                <label style="margin-left:20px;">
                                  <input :checked="employee.isMobileUser"
                                    @change="employee.isMobileUser == true ? employee.isMobileUser = false : employee.isMobileUser = true"
                                    type="checkbox" />
                                  {{ $ml.get('employees.isMobileAppUser') }}
                                </label>
                              </span>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.qrReaderMode') }}</label>
                              <select class="form-control">
                                <option value="0">{{ $ml.get('employees.qrReaderModeAll') }}</option>
                                <option value="1">{{ $ml.get('employees.qrReaderModeOnlyQRCreate') }}</option>
                                <option value="2">{{ $ml.get('employees.qrReaderModeOnlyQRRead') }}</option>
                                <option value="3">{{ $ml.get('employees.qrReaderModeOnlyWithButton') }}</option>
                                <option value="4">{{ $ml.get('employees.qrReaderModeQRCreateAndRead') }}</option>
                                <option value="5">{{ $ml.get('employees.qrReaderModeQRReadAndButton') }}</option>
                                <option value="6">{{ $ml.get('employees.qrReaderModeQRCreateAndButton') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.mobileNumber') }}</label>
                              <input v-model="employee.mobilePhone" type="tel" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.mobileAppPassword') }}</label>
                              <input :disabled="!employee.isMobileUser" v-model="employee.mobilePassword"
                                type="password" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.mobileBrand') }}</label>
                              <label class="form-control" v-if="employee.mobileUuid"><i class="fa fa-link"></i> <span
                                  v-text="employee.mobileBrand ? employee.mobileBrand : $ml.get('employees.unknown')"></span></label>
                              <label class="form-control" v-else>{{ $ml.get('employees.notPaired') }}</label>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <button v-if="authControl == 0" class="btn btn-danger" @click="removePhonePair()"
                              :disabled="!employee.isMobileUser || !employee.mobileUuid"
                              style="width:100%; margin-top:20px;"><i class="fa fa-ban"></i> {{
                                $ml.get('employees.resetPairing') }}</button>
                          </div>
                        </div>
                      </div>
                      <!--MOBİL GEÇİŞ SONU-->
                      <div class="tab-pane" id="diger-bilgileri" v-show="!employee.isVisitor">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.email') }}</label>
                              <input v-model="employee.mail" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.mobileNumber') }}</label>
                              <input v-model="employee.mobilePhone" type="tel" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.address') }}</label>
                              <input v-model="employee.address" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.internal') }}</label>
                              <input v-model="employee.internalPhone" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.homePhone') }}</label>
                              <input v-model="employee.homePhone" type="tel" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.gender') }}</label>
                              <select @change="changeGender($event)" class="form-control">
                                <option :selected="employee.gender == 0" value="0">{{ $ml.get('general.select') }}
                                </option>
                                <option :selected="employee.gender == 1" value="1">{{ $ml.get('employees.male') }}
                                </option>
                                <option :selected="employee.gender == 2" value="2">{{ $ml.get('employees.female') }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.educationStatus') }}</label>
                              <select @change="changeEducationStatus($event)" class="form-control">
                                <option :selected="employee.educationStatus == 0" value="0">
                                  {{ $ml.get('general.select') }}</option>
                                <option :selected="employee.educationStatus == 1" value="1">
                                  {{ $ml.get('employees.primarySchool') }}</option>
                                <option :selected="employee.educationStatus == 2" value="2">
                                  {{ $ml.get('employees.highSchool') }}</option>
                                <option :selected="employee.educationStatus == 3" value="3">
                                  {{ $ml.get('employees.associateDegree') }}</option>
                                <option :selected="employee.educationStatus == 4" value="4">
                                  {{ $ml.get('employees.bachelorDegree') }}</option>
                                <option :selected="employee.educationStatus == 5" value="5">
                                  {{ $ml.get('employees.postGraduate') }}</option>
                                <option :selected="employee.educationStatus == 6" value="6">
                                  {{ $ml.get('employees.doctorate') }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.militaryStatus') }}</label>
                              <select @change="changeMilitaryStatus($event)" class="form-control">
                                <option :selected="employee.militaryStatus == 0" value="0">{{ $ml.get('general.select')
                                }}
                                </option>
                                <option :selected="employee.militaryStatus == 1" value="1">{{ $ml.get('employees.done')
                                }}
                                </option>
                                <option :selected="employee.militaryStatus == 2" value="2">
                                  {{ $ml.get('employees.exempt') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.smokingStatus') }}</label>
                              <select @change="changeSmokeStatus($event)" class="form-control">
                                <option :selected="employee.smokeStatus == 0" value="0">{{ $ml.get('general.select') }}
                                </option>
                                <option :selected="employee.smokeStatus == 1" value="1">{{ $ml.get('employees.smoking')
                                }}
                                </option>
                                <option :selected="employee.smokeStatus == 2" value="2">
                                  {{ $ml.get('employees.notSmoking') }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.maritalStatus') }}</label>
                              <select @change="changeMaritalStatus($event)" class="form-control">
                                <option :selected="employee.maritalStatus == 0" value="0">{{ $ml.get('general.select')
                                }}
                                </option>
                                <option :selected="employee.maritalStatus == 1" value="1">
                                  {{ $ml.get('employees.single') }}</option>
                                <option :selected="employee.maritalStatus == 2" value="2">
                                  {{ $ml.get('employees.married') }}</option>
                                <option :selected="employee.maritalStatus == 3" value="2">{{ $ml.get('employees.widow')
                                }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.drivingLicence') }}</label>
                              <input v-model="employee.drivingLicence" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.foreignLanguage') }}</label>
                              <input v-model="employee.foreignLanguage" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.bloodType') }}</label>
                              <input v-model="employee.bloodType" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.height') }}</label>
                              <input v-model="employee.height" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.weight') }}</label>
                              <input v-model="employee.weight" type="text" class="form-control" autocomplete="off" />
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.disabledPercent') }}</label>
                              <input v-model="employee.disabledPercent" type="text" class="form-control"
                                autocomplete="off" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.authorizedPerson1') }}</label>
                              <div class="input-group">
                                <label v-text="getEmpNameFromId(employee.authorizedPerson1)" class="form-control" />
                                <span class="input-group-btn">
                                  <button @click="selectAP = 1" data-toggle="modal" data-target="#modal-kisi-sec"
                                    type="button" class="btn btn-primary">
                                    <i class="fa fa-search"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.authorizedPerson2') }}</label>
                              <div class="input-group">
                                <label v-text="getEmpNameFromId(employee.authorizedPerson2)" class="form-control" />
                                <span class="input-group-btn">
                                  <button @click="selectAP = 2" type="button" data-toggle="modal"
                                    data-target="#modal-kisi-sec" class="btn btn-primary">
                                    <i class="fa fa-search"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.note1') }}</label>
                              <textarea v-model="employee.note1" rows="2" cols="20" class="form-control"
                                autocomplete="off"></textarea>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.note2') }}</label>
                              <textarea v-model="employee.note2" rows="2" cols="20" class="form-control"
                                autocomplete="off"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--DİĞER BİLGİLERİ SONU-->
                      <div class="tab-pane" id="yetkiler">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>{{ $ml.get('employees.accessAuthoritiesInfo') }}</label>
                              <select @change="changeAccessGroups($event)" class="form-control"
                                style="margin-bottom:5px;">
                                <option :selected="employee.accessGroupId == null" value>{{ $ml.get('general.select') }}
                                </option>
                                <option v-for="acc in accessGroupList" :key="acc.id" :value="acc.id"
                                  :selected="acc.id == employee.accessGroupId">{{ acc.name }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <button :disabled="isNewEmployee || authControl == 1" v-show="employee.isActive != false"
                              @click="sendUserToDevices()" class="btn btn-sm btn-primary">
                              <i class="fa fa-refresh"></i>
                              {{ $ml.get('employees.sendPersontoDevices') }}
                            </button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="box-header">
                              <h4 class="box-title">{{ $ml.get('employees.deviceList') }}</h4>
                              <div class="pull-right box-tools">
                                <!--<button
                                  @click="checkReaders()"
                                  class="btn btn-sm btn-primary "
                                >
                                  <span v-show="!isCheck">{{$ml.get('general.selectAll')}}</span>
                                  <span v-show="isCheck">{{$ml.get('general.removeAll')}}</span>
                                </button>-->
                              </div>
                            </div>
                            <div v-show="readerList.length > 0" class="table-responsive no-padding"
                              :style="windowACHeightSize">
                              <table class="table table-hover">
                                <tbody>
                                  <tr v-for="reader in activeReaderList" :key="reader.id">
                                    <td style="font-size:18px;">
                                      <i v-if="reader.check" class="fa fa-check-circle text-success"></i>
                                      <i v-else class="fa fa-times-circle text-danger"></i>
                                    </td>
                                    <td>{{ reader.ipAddress }}</td>
                                    <td>{{ reader.readerNo }} - {{ reader.name }}</td>
                                    <td class="checkbox">
                                      <div v-if="employee.isActive != false && !isNewEmployee" class="pull-right">
                                        <button type="button" class="btn btn-link dropdown-toggle"
                                          data-toggle="dropdown" aria-expanded="false">
                                          <span class="fa fa-ellipsis-v"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                          <li>
                                            <a href="#" @click="sendUserToDevice(reader.readerId)">{{
                                              $ml.get('employees.sendToReader') }}</a>
                                          </li>
                                          <li>
                                            <a href="#" @click="selectGetFingerFromTerminal(reader.readerId)">{{
                                              $ml.get('employees.getFingerprint') }}</a>
                                          </li>
                                          <li>
                                            <a href="#" @click="SendGetFaceCommand(reader.readerId)">{{
                                              $ml.get('employees.getFaceTemplate') }}</a>
                                          </li>
                                          <li>
                                            <a href="#" @click="GetUserDataFromDevice(reader.readerId)">{{
                                              $ml.get('employees.getUserData') }}</a>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div v-show="readerList.length == 0" class="callout callout-info">
                              <i class="fa fa-info-circle"></i>
                              {{ $ml.get('employees.deviceNotRecord') }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--YETKİLER SONU-->
                      <div class="tab-pane" id="hareketler">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.movements') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button v-show="inOutList.length > 0 && authControl == 0"
                                      @click="exportToPDFHareketler()" type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-if="employee.isActive != false && modules.saveMovementLog" type="button"
                                      data-toggle="modal" data-target="#modal-hareket-ekle" @click="newInOut()"
                                      class="btn btn-warning btn-sm">
                                      <i class="fa fa-plus"></i>
                                      {{ $ml.get('employees.newMovement') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row">
                                  <div class="col-sm-6" style="margin-bottom:5px">
                                    <div class="input-group">
                                      <div class="input-group-addon">
                                        <span>
                                          <i class="fa fa-map-marker"></i>
                                        </span>
                                      </div>
                                      <select @change="changeInOutListDoorType($event)" class="form-control">
                                        <option :selected="inOut.inOutListDoorType == 4" value="4">
                                          {{ $ml.get('employees.allDoors') }}</option>
                                        <option :selected="inOut.inOutListDoorType == 0" value="0">
                                          {{ $ml.get('employees.access') }}</option>
                                        <option :selected="inOut.inOutListDoorType == 1" value="1">
                                          {{ $ml.get('employees.pdks') }}</option>
                                        <option :selected="inOut.inOutListDoorType == 2" value="2">
                                          {{ $ml.get('employees.diningHall') }}</option>
                                        <option :selected="inOut.inOutListDoorType == 3" value="3">
                                          {{ $ml.get('employees.licencePlateRecognition') }}</option>
                                        <option :selected="inOut.inOutListDoorType == 5" value="5">
                                          {{ $ml.get('employees.dormitoryDevice') }}</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-sm-6 text-center" style="margin-bottom:5px">
                                    <button type="button" @click="changeInOutListType(0)"
                                      :class="inOut.inOutListType == 0 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'">
                                      <i class="fa fa-square text-blue"></i>
                                      {{ $ml.get('employees.all') }}
                                    </button>
                                    <button type="button" @click="changeInOutListType(1)"
                                      :class="inOut.inOutListType == 1 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'">
                                      <i class="fa fa-square text-green"></i>
                                      {{ $ml.get('employees.active') }}
                                    </button>
                                    <button type="button" @click="changeInOutListType(2)"
                                      :class="inOut.inOutListType == 2 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm'">
                                      <i class="fa fa-square text-red"></i>
                                      {{ $ml.get('employees.passive') }}
                                    </button>
                                  </div>
                                </div>
                                <div class="row" style="margin-top:5px">
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:10px">
                                    <div class="form-group">
                                      <label>{{ $ml.get('employees.startDateMovements') }}</label>
                                      <input v-model="inOut.inOutStartDate" type="datetime-local"
                                        class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:5px;">
                                    <div class="form-group">
                                      <label>{{ $ml.get('employees.endDateMovements') }}</label>
                                      <input v-model="inOut.inOutEndDate" type="datetime-local" class="form-control" />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12" style="margin-bottom:10px; text-align:center">
                                    <button :disabled="isLoadingInOuts" @click="getInOuts()" type="button"
                                      class="btn btn-primary btn-sm" style="width:90%">
                                      <i class="fa fa-search"></i>
                                      {{ $ml.get('employees.searchMovements') }}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printHareketler" v-show="inOutList.length > 0"
                                    class="table-responsive no-padding" style="max-height:500px;owerflow:auto;">
                                    <div align="center">
                                      <span v-show="inOutList.length > 0">{{ employee.sicilNo }} - {{ employee.name }}
                                        ({{ this.inOut.inOutStartDate | toDateFormatGet("gg.aa.yyyy ss:dd") }} -
                                        {{ this.inOut.inOutEndDate | toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:130px">{{ $ml.get('employees.timeMovement') }}</th>
                                          <th>{{ $ml.get('employees.deviceMovement') }}</th>
                                          <th>{{ $ml.get('employees.statusMovement') }}</th>
                                          <th style="width:30px"></th>
                                          <th style="width:100px"></th>
                                        </tr>
                                        <tr v-for="inOut2 in inOutFiltered" :key="inOut2.id">
                                          <td>{{ inOut2.date | toDateFormatGet("gg.aa.yyyy ss:dd") }}</td>
                                          <td>
                                            <span v-show="inOut2.readerId != 0">{{ inOut2.readerName }}</span>
                                            <span v-show="inOut2.readerId == 0">{{ $ml.get('employees.manuelMovement')
                                            }}</span>
                                          </td>
                                          <td>
                                            <span v-show="inOut2.inOrOut != 2" class="label btn-success">{{
                                              $ml.get('employees.entryMovement') }}</span>
                                            <span v-show="inOut2.inOrOut == 2" class="label btn-danger">{{
                                              $ml.get('employees.exitMovement') }}</span>
                                          </td>
                                          <td>
                                            <span v-show="!inOut2.isActive" class="badge">{{
                                              $ml.get('employees.passive') }}</span>
                                          </td>
                                          <td>
                                            <button
                                              v-show="employee.isActive != false && authControl == 0 && inOut2.positionX != '' && inOut2.positionY != '' && inOut2.positionX && inOut2.positionY"
                                              type="button" class="btn btn-xs btn-primary" data-toggle="modal"
                                              data-target="#modal-konum" @click="selectInOut(inOut2.id)">
                                              <i class="fa fa-eye"></i>
                                            </button>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-primary" data-toggle="modal"
                                              data-target="#modal-hareket-ekle" @click="selectInOut(inOut2.id)">
                                              <i class="fa fa-edit"></i>
                                            </button>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-danger"
                                              @click="deleteInOut(inOut2.id)">
                                              <i class="fa fa-close"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="inOutList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('employees.movementNotRecord') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingInOuts">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--HAREKETLER SONU-->
                      <div class="tab-pane" id="izinler" v-show="!employee.isVisitor">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.allowences') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button v-show="allowenceForEmployeeList.length > 0 && authControl == 0"
                                      @click="exportToPDFIzinler()" type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false" type="button" data-toggle="modal"
                                      data-target="#modal-izin-sil" class="btn btn-danger btn-sm">
                                      <i class="fa fa-remove"></i>
                                      {{ $ml.get('employees.removeAllowence') }}
                                    </button>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false" type="button" @click="newAllowence()"
                                      data-toggle="modal" data-target="#modal-izin-ekle" class="btn btn-warning btn-sm">
                                      <i class="fa fa-plus"></i>
                                      {{ $ml.get('employees.newAllowence') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row" style="margin-top:5px">
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:10px">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.startDateAllowences') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="allowence.searchStartDate" type="datetime-local"
                                        class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:5px;">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.endDateAllowences') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="allowence.searchEndDate" type="datetime-local"
                                        class="form-control" />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12" style="margin-bottom:10px; text-align:center">
                                    <button type="button" :disabled="isLoadingAllowence"
                                      @click="getAllowenceForEmployee()" class="btn btn-primary btn-sm"
                                      style="width:90%">
                                      <i class="fa fa-search"></i>
                                      {{ $ml.get('employees.searchAllowences') }}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printIzinler" v-show="allowenceForEmployeeList.length > 0"
                                    class="table-responsive no-padding" style="max-height:550px; owerflow:auto;">
                                    <div align="center">
                                      <span v-show="allowenceForEmployeeList.length > 0">{{ employee.sicilNo }} -
                                        {{ employee.name }} ({{ this.allowence.searchStartDate |
                                          toDateFormatGet("gg.aa.yyyy ss:dd") }} - {{ this.allowence.searchEndDate |
                                          toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:130px;">{{ $ml.get('employees.startAllowence') }}</th>
                                          <th style="width:130px;">{{ $ml.get('employees.endAllowence') }}</th>
                                          <th style="width:60px;">{{ $ml.get('employees.codeAllowence') }}</th>
                                          <th>{{ $ml.get('employees.nameAllowence') }}</th>
                                          <th style="width:100px"></th>
                                        </tr>
                                        <tr v-for="allowence2 in allowenceForEmployeeList" :key="allowence2.id">
                                          <td>{{ allowence2.startDate | toDateFormatGet("gg.aa.yyyy ss:dd") }}</td>
                                          <td>{{ allowence2.endDate | toDateFormatGet("gg.aa.yyyy ss:dd") }}</td>
                                          <td>
                                            <span class="label btn-primary">{{ allowence2.shortCode }}</span>
                                          </td>
                                          <td>{{ allowence2.name }}</td>
                                          <td>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-primary" data-toggle="modal"
                                              data-target="#modal-izin-ekle" @click="selectAllowence(allowence2.id)">
                                              <i class="fa fa-edit"></i>
                                            </button>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-danger"
                                              @click="deleteAllowence(allowence2.id)">
                                              <i class="fa fa-close"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="allowenceForEmployeeList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('employees.allowenceNotRecord') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingAllowence">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--İZİNLER SONU-->
                      <div class="tab-pane" id="puantaj" v-show="!employee.isVisitor">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.payroll') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button v-show="EmpPayrollList.length > 0 && authControl == 0"
                                      @click="exportToPDFPuantaj()" type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                    <button v-show="employee.isActive != false" :disabled="isNewEmployee"
                                      @click="getCalculatePayrolls()" type="button" class="btn btn-warning btn-sm">
                                      <i class="fa fa-refresh"></i>
                                      {{ $ml.get('employees.recalculate') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row" style="margin-top:5px">
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:10px">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.startDatePayrolls') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="searchPayrollStartDate" type="datetime-local"
                                        class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:5px;">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.endDatePayrolls') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="searchPayrollEndDate" type="datetime-local"
                                        class="form-control" />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12" style="margin-bottom:10px; text-align:center">
                                    <button :disabled="isLoadingPayrolls" @click="getEmpPayrolls()" type="button"
                                      class="btn btn-primary btn-sm" style="width:90%">
                                      <i class="fa fa-search"></i>
                                      {{ $ml.get('employees.searchPayrolls') }}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printPuantaj" v-show="EmpPayrollList.length > 0"
                                    class="table-responsive no-padding" style="max-height:500px;owerflow:auto;">
                                    <div align="center">
                                      <span v-show="EmpPayrollList.length > 0">{{ employee.sicilNo }} - {{ employee.name
                                      }}
                                        ({{ this.searchPayrollStartDate | toDateFormatGet("gg.aa.yyyy ss:dd") }} -
                                        {{ this.searchPayrollEndDate | toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:90px;">{{ $ml.get('employees.datePayroll') }}</th>
                                          <th>{{ $ml.get('employees.workPlanPayroll') }}</th>
                                          <th style="width:70px;text-align:center">{{ $ml.get('employees.firstEntry') }}
                                          </th>
                                          <th style="width:80px;text-align:center">{{ $ml.get('employees.lastExit') }}
                                          </th>
                                          <th style="text-align:center">{{ $ml.get('employees.calculatedOvertime') }}
                                          </th>
                                          <th style="text-align:center">{{ $ml.get('employees.confirmedOvertime') }}
                                          </th>
                                          <th style="width:100px;"></th>
                                        </tr>
                                        <tr v-for="(empPayroll, index) in EmpPayrollList" :key="index">
                                          <td>{{ empPayroll.date }}</td>
                                          <td>
                                            <a href @click="changePayroll(empPayroll)" data-target="#changePayroll"
                                              data-toggle="modal">{{ empPayroll.workPlan }}</a>
                                          </td>
                                          <td style="text-align:center">{{ empPayroll.firstEntry }}</td>
                                          <td style="text-align:center">{{ empPayroll.lastOut }}</td>
                                          <td style="text-align:center">{{ empPayroll.calculatedOverTime }}</td>
                                          <td style="text-align:center">{{ empPayroll.confirmedOverTime }}</td>
                                          <td style="text-align:right;white-space: nowrap;">
                                            <button
                                              @click="getDailyPayrollDetails(empPayroll.date, empPayroll.workPlan)"
                                              data-toggle="modal" data-target="#puantaj-detay" type="button"
                                              class="btn btn-xs btn-primary">
                                              <i class="fa fa-eye"></i>
                                            </button>
                                            <button v-show="authControl == 0" :disabled="empPayroll.overTimeId == 0"
                                              @click="getDailyPayrollDetails(empPayroll.date, empPayroll.workPlan)"
                                              data-toggle="modal" data-target="#modal-confirm-overtime"
                                              :title="$ml.get('employees.confirmTheCalculated')" type="button"
                                              class="btn btn-xs btn-success">
                                              <i class="fa fa-check"></i>
                                            </button>
                                            <button v-show="authControl == 0" :disabled="empPayroll.overTimeId == 0"
                                              @click="deleteOverTime(empPayroll.overTimeId)" data-toggle="tooltip"
                                              data-placement="bottom" :title="$ml.get('employees.deleteTheConfirmed')"
                                              type="button" class="btn btn-xs btn-danger">
                                              <i class="fa fa-close"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="EmpPayrollList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('employees.payrollNotRecord') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingPayrolls">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--PUANTAJ SONU-->
                      <div class="tab-pane" id="yillik-izin" v-show="!employee.isVisitor">
                        <div class="row">
                          <div class="form-group col-sm-12">
                            <label>{{ $ml.get('employees.annualPermitGroups') }}</label>
                            <select @change="changeAnnualPermit($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="employee.annualPermitId == 0" value="0">{{ $ml.get('general.select') }}
                              </option>
                              <option v-for="annualPermit in annualPermitList" :key="annualPermit.id"
                                :value="annualPermit.id" :selected="annualPermit.id == employee.annualPermitId">
                                {{ annualPermit.name }}</option>
                            </select>
                          </div>
                          <div class="form-group col-sm-4">
                            <label>{{ $ml.get('employees.seniority') }}</label>
                            <input type="number" class="form-control" min="0"
                              v-model="employee.annualPermitSeniority" />
                          </div>
                          <div class="form-group col-sm-4">
                            <label>{{ $ml.get('employees.transfer') }}</label>
                            <input type="number" class="form-control" min="0" v-model="employee.annualPermitTransfer" />
                          </div>
                          <div class="form-group col-sm-4">
                            <label>{{ $ml.get('employees.remaining') }}</label>
                            <label class="form-control">{{ employee.annualPermitRemain }}</label>
                          </div>
                          <div class="col-sm-6">
                            <h4>{{ $ml.get('employees.deservedAnnualPermits') }} : {{ employee.annualPermitClaim }}</h4>
                            <div v-show="annualPermitClaimsDateList.length > 0" class="table-responsive no-padding"
                              style="max-height:550px; owerflow:auto;">
                              <table class="table table-hover">
                                <tbody>
                                  <tr>
                                    <th>{{ $ml.get('employees.deservedDate') }}</th>
                                    <th>{{ $ml.get('employees.deservedDay') }}</th>
                                  </tr>
                                  <tr v-for="(aPCD, index) in annualPermitClaimsDateList" :key="index">
                                    <td>{{ aPCD.tarih2 }}</td>
                                    <td>{{ aPCD.yillikIzin }}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <div v-show="annualPermitClaimsDateList.length == 0" class="callout callout-info">
                                <i class="fa fa-info-circle"></i>
                                {{ $ml.get('employees.annualPermitNotRecord') }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <h4>{{ $ml.get('employees.usedAnnualPermits') }} : {{ employee.annualPermitUsed }}</h4>
                            <div v-show="annualPermitDetailList.length > 0" class="table-responsive no-padding"
                              style="max-height:550px; owerflow:auto;">
                              <table class="table table-hover">
                                <tbody>
                                  <tr>
                                    <th>{{ $ml.get('employees.annualPermitDate') }}</th>
                                    <th>{{ $ml.get('employees.annualPermitName') }}</th>
                                    <th>{{ $ml.get('employees.annualPermitDescription') }}</th>
                                  </tr>
                                  <tr v-for="(aPD, index) in annualPermitDetailList" :key="index">
                                    <td>{{ aPD.izinBaslangic }}</td>
                                    <td>{{ aPD.izinadi }}</td>
                                    <td>{{ aPD.aciklama }}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <div v-show="annualPermitDetailList.length == 0" class="callout callout-info">
                                <i class="fa fa-info-circle"></i>
                                {{ $ml.get('employees.usedAnnualPermitNotRecord') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--YILLIK İZİN SONU-->
                      <div class="tab-pane" id="salary" v-show="!employee.isVisitor && !employee.isStudent">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.salary') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button v-show="paymentForEmployeeList.length > 0 && authControl == 0"
                                      @click="exportToPDFOdemeler()" type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false" type="button" @click="newSalary()"
                                      data-toggle="modal" data-target="#modal-salary" class="btn btn-warning btn-sm">
                                      <i class="fa fa-plus"></i>
                                      {{ $ml.get('employees.newSalary') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printSalary" v-show="salaryForEmployeeList.length > 0"
                                    class="table-responsive no-padding" style="max-height:550px; owerflow:auto;">
                                    <div align="center">
                                      <span v-show="salaryForEmployeeList.length > 0">{{ employee.sicilNo }} -
                                        {{ employee.name }}</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:130px;">{{ $ml.get('employees.salary') }}</th>
                                          <th style="width:150px;">{{ $ml.get('employees.updateTime') }}</th>
                                          <th style="width:100px"></th>
                                        </tr>
                                        <tr v-for="salary in salaryForEmployeeList" :key="salary.id">
                                          <td>{{ salary.salary | toCurrency }}</td>
                                          <td>{{ salary.updateTime | toDateFormatGet("gg.aa.yyyy ss:dd") }}</td>
                                          <td>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-primary" data-toggle="modal"
                                              data-target="#modal-salary" @click="selectSalary(salary)">
                                              <i class="fa fa-edit"></i>
                                            </button>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-danger"
                                              @click="deleteSalary(salary.id)">
                                              <i class="fa fa-close"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="salaryForEmployeeList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('alerts.recordNotFound') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingSalary">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--MAAŞ SONU-->
                      <div class="tab-pane" id="odemeler" v-show="!employee.isVisitor">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.payments') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button :disabled="authControl == 1" type="button" data-toggle="modal"
                                      data-target="#modal-odemeler" class="btn btn-primary btn-sm">
                                      <i class="fa fa-money"></i>
                                      {{ $ml.get('employees.paymentDefinitions') }}
                                    </button>
                                    <button v-show="paymentForEmployeeList.length > 0 && authControl == 0"
                                      @click="exportToPDFOdemeler()" type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false" type="button" @click="newPayment()"
                                      data-toggle="modal" data-target="#modal-odeme-ekle"
                                      class="btn btn-warning btn-sm">
                                      <i class="fa fa-plus"></i>
                                      {{ $ml.get('employees.newPayment') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row" style="margin-top:5px">
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:10px">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.startDatePayments') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="payment.searchStartDate" type="datetime-local"
                                        class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:5px;">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.endDatePayments') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="payment.searchEndDate" type="datetime-local"
                                        class="form-control" />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12" style="margin-bottom:10px; text-align:center">
                                    <button type="button" :disabled="isLoadingPayment" @click="getPaymentForEmployee()"
                                      class="btn btn-primary btn-sm" style="width:90%">
                                      <i class="fa fa-search"></i>
                                      {{ $ml.get('employees.searchPayments') }}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printOdemeler" v-show="paymentForEmployeeList.length > 0"
                                    class="table-responsive no-padding" style="max-height:550px; owerflow:auto;">
                                    <div align="center">
                                      <span v-show="paymentForEmployeeList.length > 0">{{ employee.sicilNo }} -
                                        {{ employee.name }}
                                        ({{ this.payment.searchStartDate | toDateFormatGet("gg.aa.yyyy ss:dd") }} -
                                        {{ this.payment.searchEndDate | toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:130px;">{{ $ml.get('employees.timePayment') }}</th>
                                          <th>{{ $ml.get('employees.namePayment') }}</th>
                                          <th style="width:100px;">{{ $ml.get('employees.amountPayment') }}</th>
                                          <th style="width:150px;">{{ $ml.get('employees.statusPayment') }}</th>
                                          <th style="width:100px"></th>
                                        </tr>
                                        <tr v-for="payment2 in paymentForEmployeeList" :key="payment2.id">
                                          <td>{{ payment2.date | toDateFormatGet("gg.aa.yyyy ss:dd") }}</td>
                                          <td>{{ payment2.paymentName }}</td>
                                          <td>{{ payment2.price | toCurrency }}</td>
                                          <td>
                                            <span v-show="payment2.status == 1">{{ $ml.get('employees.addedSalary')
                                            }}</span>
                                            <span v-show="payment2.status == 2">{{
                                              $ml.get('employees.decreaseFromSalary') }}</span>
                                          </td>
                                          <td>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-primary" data-toggle="modal"
                                              data-target="#modal-odeme-ekle" @click="selectPayment(payment2.id)">
                                              <i class="fa fa-edit"></i>
                                            </button>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-danger"
                                              @click="deletePayment(payment2.id)">
                                              <i class="fa fa-close"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="paymentForEmployeeList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('employees.paymentNotRecord') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingPayment">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--ÖDEMELER SONU-->
                      <div class="tab-pane" id="gorev-yerleri" v-show="!employee.isVisitor">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.workPlaces') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <router-link :disabled="authControl == 1" tag="button" to="/work-place-definitions"
                                      class="btn btn-primary btn-sm">
                                      <i class="fa fa-building"></i>
                                      {{ $ml.get('employees.workPlaceDefinitions') }}
                                    </router-link>
                                    <button v-show="paymentForEmployeeList.length > 0 && authControl == 0"
                                      @click="exportToPDFWorkPlaces()" type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false" type="button" @click="newWorkPlace()"
                                      data-toggle="modal" data-target="#modal-work-place"
                                      class="btn btn-warning btn-sm">
                                      <i class="fa fa-plus"></i>
                                      {{ $ml.get('employees.newWorkPlace') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printWorkPlaces" v-show="workPlaceList.length > 0"
                                    class="table-responsive no-padding" style="max-height:550px; owerflow:auto;">
                                    <div align="center">
                                      <span v-show="workPlaceList.length > 0">{{ employee.sicilNo }} -
                                        {{ employee.name }}</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:130px;">{{ $ml.get('employees.workPlace') }}</th>
                                          <th>{{ $ml.get('employees.workPlaceDescription') }}</th>
                                          <th style="width:100px;">{{ $ml.get('employees.workPlaceStartDate') }}</th>
                                          <th style="width:150px;">{{ $ml.get('employees.workPlaceEndDate') }}</th>
                                          <th style="width:100px"></th>
                                        </tr>
                                        <tr v-for="workPlace in workPlaceList" :key="workPlace.id">
                                          <td>{{ getWorkPlaceFromId(workPlace.workplaceId) }}</td>
                                          <td>{{ workPlace.description }}</td>
                                          <td>{{ workPlace.startDate | toDateFormatGet("gg.aa.yyyy") }}</td>
                                          <td>{{ workPlace.endDate | toDateFormatGet("gg.aa.yyyy") }}</td>
                                          <td>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-primary" data-toggle="modal"
                                              data-target="#modal-work-place" @click="selectWorkPlace(workPlace)">
                                              <i class="fa fa-edit"></i>
                                            </button>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-danger"
                                              @click="deleteWorkPlace(workPlace.id)">
                                              <i class="fa fa-close"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="workPlaceList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('alerts.recordNotFound') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingWorkPlace">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--GÖREV YERLERİ SONU-->
                      <div class="tab-pane" id="inventories">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.assignedInventory') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button v-show="employeeInventoryList.length > 0 && authControl == 0"
                                      @click="exportToPDFInventory()" type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false" type="button" @click="newInventory()"
                                      data-toggle="modal" data-target="#modal-inventory" class="btn btn-warning btn-sm">
                                      <i class="fa fa-plus"></i>
                                      {{ $ml.get('employees.addInventory') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printInventory" v-show="employeeInventoryList.length > 0"
                                    class="table-responsive no-padding" style="max-height:550px;owerflow:auto;">
                                    <div align="center">
                                      <span v-show="employeeInventoryList.length > 0">{{ employee.sicilNo }} - {{
                                        employee.name }}</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:120px;">{{ $ml.get('employees.inventoryName') }}</th>
                                          <th>{{ $ml.get('employees.inventoryQuantity') }}</th>
                                          <th>{{ $ml.get('employees.inventoryDescription') }}</th>
                                          <th>{{ $ml.get('employees.deliveryDate') }}</th>
                                          <th>{{ $ml.get('employees.takenDate') }}</th>
                                          <th></th>
                                        </tr>
                                        <tr v-for="employeeInventory in employeeInventoryList"
                                          :key="employeeInventory.id">
                                          <td>{{ getInventoryFromId(employeeInventory.inventoryId).name }}</td>
                                          <td>{{ employeeInventory.quantity }}</td>
                                          <td>{{ employeeInventory.description }}</td>
                                          <td>{{ employeeInventory.deliveryDate | toDateFormatGet("gg.aa.yyyy ss:dd") }}
                                          </td>
                                          <td>
                                            <span v-show="employeeInventory.takenDate == null">-</span>
                                            <span v-show="employeeInventory.takenDate != null">{{
                                              employeeInventory.takenDate | toDateFormatGet("gg.aa.yyyy ss:dd")
                                            }}</span>
                                          </td>
                                          <td>
                                            <button v-show="employee.isActive != false && authControl == 0"
                                              type="button" class="btn btn-xs btn-primary" data-toggle="modal"
                                              data-target="#modal-inventory-details"
                                              @click="selectInventory(employeeInventory)">
                                              <i class="fa fa-eye"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="employeeInventoryList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('alerts.recordNotFound') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingInventory">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--ZİMMETLER SONU-->
                      <div class="tab-pane" id="documents">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.documents') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <router-link :disabled="authControl == 1" tag="button" to="/document-definitions"
                                      class="btn btn-primary btn-sm">
                                      <i class="fa fa-file-text"></i>
                                      {{ $ml.get('shared.documentDefinitions') }}
                                    </router-link>
                                    <button :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false" type="button" @click="newDocument()"
                                      class="btn btn-warning btn-sm">
                                      <i class="fa fa-plus"></i>
                                      {{ $ml.get('employees.addDocument') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <table class="table table-hover">
                                      <thead>
                                        <tr>
                                          <th>{{ $ml.get('employees.documentType') }}</th>
                                          <th></th>
                                          <th>{{ $ml.get('employees.documentDescription') }}</th>
                                          <th>{{ $ml.get('employees.validityStartDate') }}</th>
                                          <th>{{ $ml.get('employees.validityEndDate') }}</th>
                                          <th></th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="document in documentList" :key="document.id">
                                          <td>{{
                                            getDocumentDefinitionName(document.documentDefinitionId)
                                            }}</td>
                                          <td><span v-show="document.isISGDocument" class="badge label-success"><i
                                                class="fa fa-check-circle"></i> İSG</span></td>
                                          <td>{{ document.description }}</td>
                                          <td>{{ document.starDate | toDateFormatGet('gg.aa.yyyy') }}</td>
                                          <td>{{ document.endDate | toDateFormatGet('gg.aa.yyyy') }}</td>
                                          <td>
                                            <a v-if="document.filePath" :href="document.filePath" target="_blank"
                                              class="btn btn-success btn-sm">
                                              <i class="fa fa-download"></i> Dosya
                                              İndir
                                            </a>
                                          </td>
                                          <td style="min-width:90px;">
                                            <button class="btn btn-primary btn-sm" @click="getDocument(document)">
                                              <i class="fa fa-pencil"></i>
                                            </button>
                                            <button class="btn btn-danger btn-sm" @click="deleteDocument(document.id)">
                                              <i class="fa fa-trash"></i>
                                            </button>
                                          </td>
                                        </tr>
                                        <tr v-if="employee.id != null && documentList.length == 0">
                                          <td colspan="4" class="text-center">
                                            <span>{{ $ml.get('alerts.recordNotFound')
                                              }}</span>
                                          </td>
                                        </tr>
                                        <tr v-if="employee.id == null">
                                          <td colspan="4" class="text-center">
                                            <span>{{ $ml.get('alerts.pleaseSelect')
                                              }}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingInventory">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--EVRAKLAR SONU-->
                      <div class="tab-pane" id="islem-gecmisi">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.employeeLogs') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button v-show="logList.length > 0 && authControl == 0" @click="exportToPDFLogs()"
                                      type="button" class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row" style="margin-top:5px">
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:10px">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.startDateLogs') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="logStartDate" type="datetime-local" class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-lg-6 col-sm-12" style="margin-bottom:5px;">
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{ $ml.get('employees.endDateLogs') }}</span> :
                                        </button>
                                      </div>
                                      <input v-model="logEndDate" type="datetime-local" class="form-control" />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12" style="margin-bottom:10px; text-align:center">
                                    <button :disabled="isNewEmployee && isLoadingLogs" type="button" @click="getLogs()"
                                      class="btn btn-primary btn-sm" style="width:90%">
                                      <i class="fa fa-search"></i>
                                      {{ $ml.get('employees.searchLogs') }}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div id="printLogs" v-show="logList.length > 0" class="table-responsive no-padding"
                                    style="max-height:550px;owerflow:auto;">
                                    <div align="center">
                                      <span v-show="logList.length > 0">{{ employee.sicilNo }} - {{ employee.name }}
                                        ({{ this.logStartDate | toDateFormatGet("gg.aa.yyyy ss:dd") }} - {{
                                          this.logEndDate
                                          | toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th style="width:120px;">{{ $ml.get('employees.timeLog') }}</th>
                                          <th>{{ $ml.get('employees.descriptionLog') }}</th>
                                        </tr>
                                        <tr v-for="log in logList" :key="log.id">
                                          <td>{{ log.date | toDateFormatGet("gg.aa.yyyy ss:dd") }}</td>
                                          <td>{{ log.description }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="logList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('employees.logNotRecord') }}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingLogs">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--İŞLEM GEÇMİŞİ SONU-->
                      <div class="tab-pane" id="kart-baski">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{ $ml.get('employees.cardPrinting') }}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button v-show="authControl == 0" @click="exportToPDFCard()" type="button"
                                      class="btn btn-danger btn-sm">
                                      <i class="fa fa-share"></i>
                                      {{ $ml.get('general.exportToPdfOrPrint') }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row">
                                  <div class="col-sm-12" style="margin-bottom:10px;">
                                    <div class="form-group">
                                      <label>Baskı Tipi</label>
                                      <div class="input-group">
                                        <div class="btn-group text-center">
                                          <button @click="isDoubleSidedPrint = false"
                                            :class="!isDoubleSidedPrint ? 'btn btn-primary' : 'btn btn-default'">
                                            <i class="fa fa-id-card-o"></i> Tek Yüze Baskı
                                          </button>
                                          <button @click="isDoubleSidedPrint = true"
                                            :class="isDoubleSidedPrint ? 'btn btn-primary' : 'btn btn-default'">
                                            <i class="fa fa-id-card"></i> Çift Yüze Baskı
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label>Ön Yüz - {{ $ml.get('employees.selectTemplate') }}</label>
                                      <select @change="changeCardDesign($event)" class="form-control">
                                        <option value="0">{{ $ml.get('general.select') }}</option>
                                        <option v-for="cardDesign in cardDesignList" :key="cardDesign.id"
                                          :value="cardDesign.id">{{ cardDesign.name }}</option>
                                      </select>
                                    </div>
                                    <div v-if="isDoubleSidedPrint" class="form-group">
                                      <label>Arka Yüz - {{ $ml.get('employees.selectTemplate') }}</label>
                                      <select @change="changeCardDesign2($event)" class="form-control">
                                        <option value="0">{{ $ml.get('general.select') }}</option>
                                        <option v-for="cardDesign in cardDesignList" :key="cardDesign.id"
                                          :value="cardDesign.id">{{ cardDesign.name }}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="row text-center">
                                  <div class="col-sm-12" style="margin-bottom:10px;">
                                    <div id="printCards">
                                      <div id="printCard">
                                        <div
                                          :style="'width: 347px;height: 221px;border-radius: 10px;display: inline-block;position: relative;background-color:' + cardDesign.backgroundColor + ';background-image:url(' + cardDesign.backgroundImage + ');background-size:cover;'">
                                          <img v-for="item1 in cardImageItems" :key="item1.id"
                                            :src="employee.image ? employee.image : '/src/assets/default-user.png'"
                                            :style="imageItemStyle(item1)" />
                                          <span v-for="item2 in cardLabelItems" :key="item2.id"
                                            :style="itemStyle(item2)">{{ item2.text }}</span>
                                          <span v-for="item3 in cardValueItems" :key="item3.id"
                                            :style="itemStyle(item3)">{{ getValueTitle(item3.value) }}</span>
                                        </div>
                                      </div>
                                      <div v-if="isDoubleSidedPrint" id="printCard2">
                                        <div
                                          :style="'width: 347px;height: 221px;border-radius: 10px;display: inline-block;position: relative;background-color:' + cardDesign2.backgroundColor + ';background-image:url(' + cardDesign2.backgroundImage + ');background-size:cover;'">
                                          <img v-for="item1 in cardImageItems2" :key="item1.id"
                                            :src="employee.image ? employee.image : '/src/assets/default-user.png'"
                                            :style="imageItemStyle(item1)" />
                                          <span v-for="item2 in cardLabelItems2" :key="item2.id"
                                            :style="itemStyle(item2)">{{ item2.text }}</span>
                                          <span v-for="item3 in cardValueItems2" :key="item3.id"
                                            :style="itemStyle(item3)">{{ getValueTitle(item3.value) }}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-12">
                                    <button @click="exportToPDFCard()" class="btn btn-danger" style="width:100%;">{{
                                      $ml.get('general.print') }}</button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--KART BASKI SONU-->
                    </div>
                  </div>
                  <!-- NAV TABS END -->
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingLogs">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button v-show="isNewEmployee && employee.isActive != false && authControl == 0" type="button"
                  class="btn btn-sm btn-success" style="margin: 5px; width:120px;" data-toggle="modal"
                  data-target="#modal-kaydet">
                  <i class="fa fa-check"></i>
                  {{ $ml.get('employees.saveEmployee') }}
                </button>
                <button v-show="!isNewEmployee && employee.isActive != false && authControl == 0" type="button"
                  class="btn btn-sm btn-success" style="margin: 5px; width:120px;" data-toggle="modal"
                  data-target="#modal-guncelle">
                  <i class="fa fa-refresh"></i>
                  {{ $ml.get('employees.updateEmployee') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-xl fade" id="modal-kisi-sec">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.selectEmployee') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <input v-model="searchText2" class="form-control"
                    :placeholder="$ml.get('employees.searchFromNameSurname')" />
                </div>
                <div class="col-sm-12">
                  <div v-show="allEmployeeFilteredList.length > 0" class="table-responsive no-padding"
                    style="max-height:500px;owerflow:auto;">
                    <table class="table table-hover">
                      <tbody>
                        <tr>
                          <th>{{ $ml.get('employees.employeeList') }}</th>
                        </tr>
                        <tr v-for="employee3 in allEmployeeFilteredList" :key="employee3.id">
                          <td>
                            {{ employee3.name }}
                            <span v-if="employee3.title != ''">- {{ employee3.title }}</span>
                          </td>
                          <button @click="selectAuthorizedEmployee(employee3.id)" data-dismiss="modal" type="button"
                            class="btn btn-primary btn-sm">
                            <i class="fa fa-check"></i>
                          </button>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="allEmployeeFilteredList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{ $ml.get('employees.employeeSearchNotFound') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.updateEmployee') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.employee.name }}</span>
                <span v-show="this.employee.title != ''">- {{ this.employee.title }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('employees.isContinueUpdateEmployee') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveEmployee()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('employees.updateEmployee') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.saveEmployee') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.employee.name }}</p>
              <span>{{ $ml.get('employees.isContinueSaveEmployee') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveEmployee()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('employees.saveEmployee') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.deleteEmployee') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.employee.name }}</span>
                <span v-show="this.employee.title != ''">- {{ this.employee.title }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('employees.isContinueDeleteEmployee') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteEmployee()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-user-times"></i>
                <span>{{ $ml.get('employees.deleteEmployee') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-istencikis">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.setLeaveDate') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.employee.name }}</span>
                <span v-show="this.employee.title != ''">- {{ this.employee.title }}</span>
              </div>
              <p>
                <span>{{ $ml.get('employees.setLeaveDateInfo') }}</span>
              </p>
              <input type="date" style="color:black;" class="form-control" v-model="employee.endDate" />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="setLeaveEmployee()" class="btn btn-default" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL GECERLİLİK KALDIR START-->
      <div class="modal modal-danger fade" id="modalRemoveValidity">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.removeValidityDate') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.employee.name }}</span>
                <span v-show="this.employee.title != ''">- {{ this.employee.title }}</span>
                <span>{{ $ml.get('employees.validityEndDate') }} : {{ this.employee.validityEndDate |
                  toDateFormatGet("gg.aa.yyyy") }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('employees.isContinueRemoveValidityDate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="validityDateRemove()" class="btn btn-danger">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.remove') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL GECERLİLİK KALDIR END -->
      <!-- /.MODAL GEÇERLİLİK TARİHİ OLUŞTUR START-->
      <div class="modal modal-warning fade" id="modalCreateValidity">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.createValidityDate') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.employee.name }}</span>
                <span v-show="this.employee.title != ''">- {{ this.employee.title }}</span>
              </div>
              <p>
                <span>{{ $ml.get('employees.createValidityDateDescription') }}</span>
              </p>
              <input type="date" style="color:black;" class="form-control" v-model="employee.validityEndDate" />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal"
                @click="employee.validityEndDate = null;">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="validityDateCreate()" class="btn btn-default">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL GEÇERLİLİK TARİHİ OLUŞTUR END -->
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="changePayroll">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.updateWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6" style="color:black; padding:0px 10px;">
                  <div v-show="allowenceList.length > 0" class="table-responsive no-padding"
                    style="max-height:450px; owerflow:auto;background-color:#fff;">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="(allowence, index) in allowenceList" :key="index">
                          <td>{{ allowence.name }}</td>
                          <td>
                            <button @click="setChangePayroll(allowence.id, true)" data-dismiss="modal"
                              class="btn btn-primary btn-sm" type="button" style="width:100%;">{{
                                $ml.get('general.select') }}</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-show="allowenceList.length == 0" class="callout callout-info">
                      <i class="fa fa-info-circle"></i>
                      {{ $ml.get('employees.updateAllowenceNotRecord') }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" style="color:black; padding:0px 10px;">
                  <div v-show="workGroupList.length > 0" class="table-responsive no-padding"
                    style="max-height:450px; owerflow:auto;background-color:#fff;">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="(workGroup, index) in workGroupList" :key="index">
                          <td>{{ workGroup.name }}</td>
                          <td>
                            <button @click="setChangePayroll(workGroup.id, false)" data-dismiss="modal"
                              class="btn btn-primary btn-sm" type="button" style="width:100%;">{{
                                $ml.get('general.select') }}</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-show="workGroupList.length == 0" class="callout callout-info">
                      <i class="fa fa-info-circle"></i>
                      {{ $ml.get('employees.updateWorkPlanNotRecord') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="modal-filtre">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterEmployees') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" @keyup.enter="getEmployeesFromCardNo()">
                    <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                    <input v-model="filters.nameOrCardNumber" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                    <input v-model="filters.identityNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterCitizenshipNumber')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                    <input v-model="filters.sicilOrTerminalNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterTitle') }}</span>
                    <select @change="changeFilterTitles($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.title == ''" value>{{ $ml.get('general.select') }}</option>
                      <option v-for="title in titleList" :key="title.name" :value="title.name"
                        :selected="title.name == filters.title">{{ title.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterStatus') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList
                      }}</label>
                      <label v-show="checkedStatusList == ''" class="form-control">{{ $ml.get('general.notSelected')
                      }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStatusList != ''" class="btn btn-danger" @click="clearFilterStatus()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <span v-if="modules.customFieldName == ''">{{ $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                    <span v-else>{{ modules.customFieldName + ' / ' + $ml.get('filters.filterDocumentNoOrEmail')
                    }}</span>
                    <input v-model="filters.documentNoOrMail" type="text" class="form-control input-sm"
                      :placeholder="modules.customFieldName != '' ? modules.customFieldName + ' / ' + $ml.get('filters.filterDocumentNoOrEmail') : $ml.get('filters.filterDocumentNoOrEmail')"
                      style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group" v-show="modules.licencePlateRecognition">
                    <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                    <input v-model="filters.plateNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterPlateNo')" style="margin-bottom:5px;" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterDepartments') }}</label>
                    <div class="input-group">
                      <label v-show="checkedDepartmentList != ''" class="form-control tdb-box">{{ checkedDepartmentList
                      }}</label>
                      <label v-show="checkedDepartmentList == ''" class="form-control">{{ $ml.get('general.notSelected')
                      }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-department">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                          @click="clearFilterDepartments()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedAccessGroupList != ''" class="form-control tdb-box">{{
                        checkedAccessGroupList }}</label>
                      <label v-show="checkedAccessGroupList == ''" class="form-control">{{
                        $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                          @click="clearFilterAccessGroup()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                    <div class="input-group">
                      <label v-show="checkedWorkGroupList != ''" class="form-control tdb-box">{{ checkedWorkGroupList
                      }}</label>
                      <label v-show="checkedWorkGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                      }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-workplan">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                          @click="clearFilterWorkPlans()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-show="modules.diningHall">
                    <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedFoodGroupList != ''" class="form-control tdb-box">{{ checkedFoodGroupList
                      }}</label>
                      <label v-show="checkedFoodGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                      }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-diningHall">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                          @click="clearFilterFoodGroups()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterState') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList }}</label>
                      <label v-show="checkedStateList == ''" class="form-control">{{ $ml.get('general.notSelected')
                      }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStateList != ''" class="btn btn-danger" @click="clearFilterStates()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm-6">
                      <span>{{ $ml.get('filters.filterDeleted') }}</span>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="filters.isActive"
                            @change="filters.isActive == true ? filters.isActive = false : filters.isActive = true"
                            type="checkbox" />
                          {{ $ml.get('filters.filterNotShow') }}
                        </label>
                      </span>
                    </div>
                    <!--<div class="form-group col-sm-6">
                      <span>{{$ml.get('filters.filterVisitorCards')}}</span>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input
                            :checked="filters.isVisitor"
                            @change="filters.isVisitor==true ? filters.isVisitor=false : filters.isVisitor=true"
                            type="checkbox"
                          />
                          {{$ml.get('filters.filterShow')}}
                        </label>
                      </span>
                    </div>-->
                  </div>
                </div>
              </div>
              <div class="callout callout-info" style="margin-top:10px;">
                <div class="row">
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField1($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField1key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField1key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField1value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField2($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField2key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField2key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField2value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField3($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField3key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField3key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField3value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField4($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField4key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField4key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField4value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              <i class="fa fa-remove"></i>
              <span>{{ $ml.get('filters.filterCancel') }}</span>
            </button>
            <button @click="filtersClear()" class="btn btn-warning">
              <i class="fa fa-trash-o"></i>
              <span>{{ $ml.get('filters.filterClear') }}</span>
            </button>
            <button @click="getEmployees()" class="btn btn-success" data-dismiss="modal">
              <i class="fa fa-search"></i>
              <span>{{ $ml.get('filters.filterApply') }}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--HAREKET EKLE MODAL -->
      <div class="modal modal-primary fade" id="modal-hareket-ekle" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-show="isNewInOut">{{ $ml.get('employees.addMovement') }}</span>
                <span v-show="!isNewInOut">{{ $ml.get('employees.editMovement') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.timeMovement') }}</label>
                  <input v-model="inOut.inOutAdd" type="datetime-local" class="form-control" />
                </div>
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.typeMovement') }}</label>
                  <select @change="changeInOutType($event)" class="form-control">
                    <option value="0" :selected="inOut.inOutType == 0">{{ $ml.get('general.notSelected') }}</option>
                    <option value="1" :selected="inOut.inOutType == 1">{{ $ml.get('employees.entryMovement') }}</option>
                    <option value="2" :selected="inOut.inOutType == 2">{{ $ml.get('employees.exitMovement') }}</option>
                  </select>
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.readerMovement') }}</label>
                  <select @change="changeInOutDoor($event)" class="form-control">
                    <option value="0" :selected="inOut.inOutType == 0">{{ $ml.get('general.notSelected') }}</option>
                    <option v-for="door in activeMovementReaderList" :key="door.readerId" :value="door.readerId"
                      :selected="door.readerId == inOut.readerId">{{ door.name }}</option>
                  </select>
                </div>
                <div v-show="modules.payroll" class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.includePassivesMovement') }}</label>
                  <span class="form-control checkbox">
                    <label style="margin-left:20px;">
                      <input :checked="includePassiveMovements"
                        @change="includePassiveMovements == true ? includePassiveMovements = false : includePassiveMovements = true"
                        type="checkbox" />
                      {{ $ml.get('employees.includePassivesMovement') }}
                    </label>
                  </span>
                </div>
                <div v-show="modules.payroll" class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.confirmedOvertimeNotDeleted') }}</label>
                  <span class="form-control checkbox">
                    <label style="margin-left:20px;">
                      <input :checked="doNotDeleteOvertimes"
                        @change="doNotDeleteOvertimes == true ? doNotDeleteOvertimes = false : doNotDeleteOvertimes = true"
                        type="checkbox" />
                      {{ $ml.get('employees.confirmedOvertimeNotDeleted') }}
                    </label>
                  </span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="isNewInOut" type="button" @click="addInOut()" class="btn btn-outline"
                data-dismiss="modal">{{ $ml.get('general.save') }}</button>
              <button v-show="!isNewInOut" type="button" @click="updateInOut()" class="btn btn-outline"
                data-dismiss="modal">{{ $ml.get('general.update') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--HAREKET EKLE MODAL END -->
      <!--MAAŞ MODAL -->
      <div class="modal modal-primary fade" id="modal-salary" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-show="!salary.id">{{ $ml.get('employees.addSalary') }}</span>
                <span v-show="salary.id">{{ $ml.get('employees.editSalary') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.salary') }}</label>
                  <input v-model="salary.salary" type="number" class="form-control" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="!salary.id" type="button" @click="addSalary()" class="btn btn-outline">{{
                $ml.get('general.save') }}</button>
              <button v-show="salary.id" type="button" @click="updateSalary()" class="btn btn-outline">{{
                $ml.get('general.update') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--MAAŞ MODAL END -->
      <!--ÖDEME EKLE MODAL -->
      <div class="modal modal-primary fade" id="modal-odeme-ekle" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-show="isNewPayment">{{ $ml.get('employees.addPayment') }}</span>
                <span v-show="!isNewPayment">{{ $ml.get('employees.editPayment') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.timePayment') }}</label>
                  <input v-model="payment.date" type="datetime-local" class="form-control" />
                </div>
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.amountPayment') }}</label>
                  <input v-model="payment.price" type="text" class="form-control" />
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.typePayment') }}</label>
                  <select @change="changePaymentForEmployee($event)" class="form-control">
                    <option value="0" :selected="payment.salaryId == 0">{{ $ml.get('general.notSelected') }}</option>
                    <option v-for="payment2 in paymentDefinitionList" :key="payment2.id" :value="payment2.id"
                      :selected="payment2.id == payment.salaryId">{{ payment2.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="isNewPayment" type="button" @click="addPayment()" class="btn btn-outline">{{
                $ml.get('general.save') }}</button>
              <button v-show="!isNewPayment" type="button" @click="updatePayment()" class="btn btn-outline">{{
                $ml.get('general.update') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÖDEME EKLE MODAL END -->
      <!--GÖREV YERİ EKLE MODAL -->
      <div class="modal modal-primary fade" id="modal-work-place" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-show="isNewWorkPlace">{{ $ml.get('employees.addWorkplace') }}</span>
                <span v-show="!isNewWorkPlace">{{ $ml.get('employees.editWorkplace') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.workPlaceStartDate') }}</label>
                  <input v-model="workPlace.startDate" type="date" class="form-control" />
                </div>
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('employees.workPlaceEndDate') }}</label>
                  <input v-model="workPlace.endDate" type="date" class="form-control" />
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.descriptionWorkPlace') }}</label>
                  <input v-model="workPlace.description" type="text" class="form-control" />
                </div>
                <div class="form-group col-sm-12">
                  <label>{{ $ml.get('employees.workPlace') }}</label>
                  <select @change="changeWorkPlaceForEmployee($event)" class="form-control">
                    <option value="0" :selected="workPlace.workplaceId == 0">{{ $ml.get('general.notSelected') }}
                    </option>
                    <option v-for="workPlace2 in workPlaceDefinitionList" :key="workPlace2.id" :value="workPlace2.id"
                      :selected="workPlace2.id == workPlace.workplaceId">{{ workPlace2.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="isNewWorkPlace" type="button" @click="addWorkPlace()" class="btn btn-outline">{{
                $ml.get('general.save') }}</button>
              <button v-show="!isNewWorkPlace" type="button" @click="updateWorkPlace()" class="btn btn-outline">{{
                $ml.get('general.update') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GÖREV YERİ EKLE MODAL END -->
      <!-- EVRAK EKLE MODAL-->
      <div class="modal fade" id="modal-document">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-if="!document.id">{{ $ml.get('employees.addDocument') }}</span>
                <span v-if="document.id">{{ $ml.get('employees.editDocument') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <label>{{ $ml.get('employees.documentType') }}</label>
                  <select class="form-control" v-model="document.documentDefinitionId">
                    <option :selected="document.documentDefinitionId == null" :value="null">{{
                      $ml.get('general.notSelected') }}</option>
                    <option v-for="definition in documentDefinitionList" :key="definition.id"
                      :selected="definition.id == document.documentDefinitionId" :value="definition.id">{{
                        definition.name }}</option>
                  </select>
                </div>
                <div class="col-sm-12" style="margin-top:10px;">
                  <label>{{ $ml.get('employees.documentDescription') }}</label>
                  <input type="text" v-model="document.description" class="form-control" />
                </div>
                <div v-show="!document.id" class="col-sm-12" style="margin-top:10px;">
                  <label>{{ $ml.get('employees.documentFile') }}</label><span class="text-muted" style="font-style:italic;font-size:12px;font-weight: normal;margin-left:10px;">(.zip, .pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg)</span>
                  <input type="file" ref="file" id="fileName" class="form-control"
                    accept=".zip, .pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg" />
                </div>
                <div class="col-sm-12" style="margin-top:10px;">
                  <label>{{ $ml.get('employees.isgDocument') }}</label><span class="text-muted" style="font-style:italic;font-size:12px;font-weight: normal;margin-left:10px;">İSG belgelerinde tarih alanları zorunludur.</span>
                  <span class="form-control checkbox">
                    <label style="margin-left:20px;">
                      <input :checked="document.isISGDocument"
                        @change="document.isISGDocument == true ? document.isISGDocument = false : document.isISGDocument = true"
                        type="checkbox" />
                      <span>{{ $ml.get('employees.isgDocument') }}</span>
                    </label>
                  </span>
                </div>
                <div class="col-sm-6" style="margin-top:10px;">
                  <label>{{ $ml.get('employees.validityStartDate') }}</label>
                  <input type="date" v-model="document.starDate" class="form-control" />
                </div>
                <div class="col-sm-6" style="margin-top:10px;">
                  <label>{{ $ml.get('employees.validityEndDate') }}</label>
                  <input type="date" v-model="document.endDate" class="form-control" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveDocument()" class="btn btn-success">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.EVRAK EKLE MODAL END -->
      <!--İZİN EKLE MODAL -->
      <div class="modal modal-primary fade" id="modal-izin-ekle" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <div class="overlay" style="float:right; font-size:18px; margin-right:15px;" id="load"
                :hidden="!isLoadingAllowenceModal">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <h4 class="modal-title">
                <span v-show="isNewAllowence">{{ $ml.get('employees.addAllowence') }}</span>
                <span v-show="!isNewAllowence">{{ $ml.get('employees.editAllowence') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-4">
                  <div v-show="isNewAllowence" class="table-responsive" style="height:350px; overflow:auto;">
                    <h4>{{ $ml.get('employees.validDays') }}</h4>
                    <table class="table table-hover" style="background-color:#fff; color:black;">
                      <tbody>
                        <tr v-for="day in dayList" :key="day.value">
                          <td class="checkbox">
                            <label style="margin-left:30px">
                              <input type="checkbox" name="check" :checked="day.check"
                                @change="day.check == true ? day.check = false : day.check = true" />
                              {{ day.name }}
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div v-show="isNewAllowence" class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.typeAllowence') }}</label>
                    <select @change="changeAllowenceType($event)" class="form-control">
                      <option :selected="allowence.allowenceType == 0" value="0">{{ $ml.get('employees.dailyAllowence')
                      }}
                      </option>
                      <option :selected="allowence.allowenceType == 1" value="1">
                        {{ $ml.get('employees.hourlyAllowence') }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.startTimeAllowence') }}</label>
                    <input v-model="allowence.startDate" @change="changeAllowenceStartTime()" type="datetime-local"
                      class="form-control" />
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.endTimeAllowence') }}</label>
                    <input v-model="allowence.endDate" type="datetime-local" class="form-control" />
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.allowence') }}</label>
                    <select @change="changeAllowence($event)" class="form-control">
                      <option v-for="allowence3 in allowenceList" :key="allowence3.id"
                        :selected="allowence3.id == allowence.allowenceId" :value="allowence3.id">
                        {{ allowence3.shortCode }} - {{ allowence3.name }}</option>
                    </select>
                  </div>
                  <div v-show="allowence.allowenceType == 1 && isNewAllowence" class="form-group col-sm-6">
                    <label>{{ $ml.get('employees.totalTimeAllowence') }}</label>
                    <input type="time" class="form-control" v-model="allowence.allowenceTime" />
                  </div>
                  <div v-show="allowence.allowenceType == 1 && isNewAllowence" class="form-group col-sm-6">
                    <label>{{ $ml.get('employees.missingHourAllowence') }}</label>
                    <input type="time" class="form-control" v-model="allowence.missingTime"
                      @change="changeEqualMissingTime()" />
                  </div>
                  <div v-show="allowence.allowenceType == 1 && isNewAllowence" class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.isEqualTheMissingTime') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="allowence.equalTheMissingTime" @change="changeCheckEqualMissingTime()"
                          type="checkbox" />
                        {{ $ml.get('employees.equalTheMissingTime') }}
                      </label>
                    </span>
                  </div>
                  <div v-show="allowence.allowenceType == 0 && isNewAllowence" class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.doesApplyHolidays') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="allowence.holidayPass"
                          @change="allowence.holidayPass == true ? allowence.holidayPass = false : allowence.holidayPass = true"
                          type="checkbox" />
                        {{ $ml.get('employees.applyHolidays') }}
                      </label>
                    </span>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.descriptionAllowence') }}</label>
                    <input v-model="allowence.description" type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="isNewAllowence" type="button" @click="addAllowence()" class="btn btn-outline"
                data-dismiss="modal">{{ $ml.get('general.save') }}</button>
              <button v-show="!isNewAllowence" type="button" @click="updateAllowence()" class="btn btn-outline"
                data-dismiss="modal">{{ $ml.get('general.update') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--İZİN EKLE MODAL END -->
      <!--İZİN EKLE MODAL -->
      <div class="modal modal-danger fade" id="modal-izin-sil" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <div class="overlay" style="float:right; font-size:18px; margin-right:15px;" id="load"
                :hidden="!isLoadingAllowenceModal">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.removeAllowence') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <label class="form-control">{{ $ml.get('employees.startDateAllowences') }}</label>
                  <input v-model="startDateRemoveAllowence" class="form-control" type="datetime-local" />
                </div>
                <div class="col-sm-6">
                  <label class="form-control">{{ $ml.get('employees.endDateAllowences') }}</label>
                  <input v-model="endDateRemoveAllowence" class="form-control" type="datetime-local" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button type="button" @click="batchDeleteAllowence()" class="btn btn-outline">{{
                $ml.get('employees.removeAllowenceInSelectedDates') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--İZİN EKLE MODAL END -->
      <!--DURUM MODAL -->
      <div class="modal modal-primary fade" id="modal-durum" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.states') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{ $ml.get('employees.stateList') }}</h4>
                      <div class="pull-right box-tools">
                        <button @click="newState()" class="btn btn-sm btn-warning">{{ $ml.get('employees.newState')
                        }}</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="stateList.length > 0" class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="state in stateList" :key="state.id">
                              <td>{{ state.name }}</td>
                              <td>
                                <button @click="selectState(state.id, state.name, state.status)"
                                  class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="stateList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('employees.stateNotRecord') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>{{ $ml.get('employees.stateName') }}</label>
                    <input v-model="selectedStateName" type="text" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('employees.enableToLeaveDate') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="selectedStateStatus"
                          @change="selectedStateStatus == true ? selectedStateStatus = false : selectedStateStatus = true"
                          type="checkbox" />
                        {{ $ml.get('employees.enableToLeaveDate') }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="!isNewState" type="button" @click="deleteState()" class="btn btn-outline btn-danger">
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
              <button type="button" @click="saveState()" class="btn btn-outline btn-success">
                <span v-show="isNewState">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewState">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM MODAL END -->
      <!--STATU MODAL -->
      <div class="modal modal-primary fade" id="modal-statu" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.statusTitle') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{ $ml.get('employees.statusList') }}</h4>
                      <div class="pull-right box-tools">
                        <button @click="newStatu()" class="btn btn-sm btn-warning">{{ $ml.get('employees.newStatus')
                        }}</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="statuList.length > 0" class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="statu in statuList" :key="statu.id">
                              <td>{{ statu.name }}</td>
                              <td>
                                <button @click="selectStatu(statu.id, statu.name)" class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="statuList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('employees.statusNotRecord') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>{{ $ml.get('employees.statusName') }}</label>
                    <input v-model="selectedStatuName" type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="!isNewStatu" type="button" @click="deleteStatu()" class="btn btn-outline btn-danger">
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
              <button type="button" @click="saveStatu()" class="btn btn-outline btn-success">
                <span v-show="isNewStatu">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewStatu">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU MODAL END -->
      <!--ÖDEME TANIMLARI MODAL -->
      <div class="modal modal-primary fade" id="modal-odemeler" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.payments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{ $ml.get('employees.paymentDefinitions') }}</h4>
                      <div class="pull-right box-tools">
                        <button @click="newPaymentDefinition()" class="btn btn-sm btn-warning">{{
                          $ml.get('employees.newPayment') }}</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="paymentDefinitionList.length > 0" class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="paymentDef in paymentDefinitionList" :key="paymentDef.id">
                              <td>{{ paymentDef.name }}</td>
                              <td>
                                <button
                                  @click="selectPaymentDefinition(paymentDef.id, paymentDef.name, paymentDef.status)"
                                  class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="paymentDefinitionList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('employees.paymentNotRecord') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>{{ $ml.get('employees.namePayment') }}</label>
                    <input v-model="paymentDefinition.name" type="text" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('employees.effectOnSalary') }}</label>
                    <select @change="changePaymentDefinitionStatus($event)" class="form-control">
                      <option :selected="paymentDefinition.status == 1" value="1">{{ $ml.get('employees.addedSalary') }}
                      </option>
                      <option :selected="paymentDefinition.status == 2" value="2">
                        {{ $ml.get('employees.decreaseFromSalary') }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="!isNewPaymentDefinition" type="button" @click="deletePaymentDefinition()"
                class="btn btn-outline btn-danger">
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
              <button type="button" @click="savePaymentDefinition()" class="btn btn-outline btn-success">
                <span v-show="isNewPaymentDefinition">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewPaymentDefinition">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÖDEME TANIMLARI MODAL END -->
      <!--DEPARTMAN MODAL -->
      <div class="modal modal-primary fade" id="select-department" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.selectDepartment') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div v-show="departmentList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <div id="treeview"></div>
              </div>
              <div v-show="departmentList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('employees.departmentNotRecord') }}
              </div>
            </div>
            <div class="modal-footer">
              <div class="pull-left">
                {{ $ml.get('employees.selectedDepartment') }} :
                <span v-text="employee.departmentId ? getDepartmentFromId(employee.departmentId) : ' - '" />
              </div>
              <button type="button" class="btn btn-outline" data-dismiss="modal">{{ $ml.get('general.confirm')
              }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN MODAL END -->
      <!--FAZLA MESAİ ONAYLAMA MODAL -->
      <div class="modal modal-primary fade" id="modal-confirm-overtime" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.confirmSelectedOvertime') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <span>{{ $ml.get('employees.overtimePlace') }}</span>
                <select @change="changeOvertimePlace($event)" class="form-control">
                  <option :selected="selectedOTPlaceId == null" value>{{ $ml.get('general.notSelected') }}</option>
                  <option :selected="place.id == selectedOTPlaceId" v-for="place in overtimePlaceList" :key="place.id"
                    :value="place.id">{{ place.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <span>{{ $ml.get('employees.overtimeDescription') }}</span>
                <select @change="changeOvertimeDescription($event)" class="form-control">
                  <option :selected="selectedOTDescriptionId == null" value>{{ $ml.get('general.notSelected') }}
                  </option>
                  <option :selected="description.id == selectedOTDescriptionId"
                    v-for="description in overtimeDescriptionList" :key="description.id" :value="description.id">
                    {{ description.name }}</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button @click="confirmOverTime()" type="button" class="btn btn-outline" data-dismiss="modal">{{
                $ml.get('general.confirm') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--FAZLA MESAİ ONAYLAMA MODAL END -->
      <!--PUANTAJ DETAY MODAL -->
      <div class="modal modal-primary fade" id="puantaj-detay" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.dailyPayrollDetail') }} | {{ this.selectedDailyPayrol.date }}</span>
                <span class="pull-right" style="margin-right:15px;">{{ this.selectedDailyPayrol.workGroup }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-4">
                  <div class="box box-primary">
                    <div class="box-header with-border">
                      <h3 class="box-title">
                        <span>{{ $ml.get('employees.payrollDetail') }}</span>
                      </h3>
                    </div>
                    <div class="box-body" style="color:black;">
                      <div v-show="dailyPayrollDetailList.length > 0" class="table-responsive no-padding"
                        style="height:440px;owerflow:auto;">
                        <table class="table table-hover">
                          <tbody>
                            <tr>
                              <th>{{ $ml.get('employees.payrollTime') }}</th>
                              <th>{{ $ml.get('employees.payroll') }}</th>
                            </tr>
                            <tr v-for="(payrollDetail, index) in dailyPayrollDetailList" :key="index">
                              <td>{{ payrollDetail.time }}</td>
                              <td>
                                <span>{{ payrollDetail.payroll }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="dailyPayrollDetailList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('employees.payrollNotRecord') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header with-border">
                      <h3 class="box-title">
                        <span>{{ $ml.get('employees.movementsOT') }}</span>
                      </h3>
                    </div>
                    <div class="box-body" style="color:black;">
                      <div v-show="dailyInOutDetailList.length > 0" class="table-responsive no-padding"
                        style="height:440px;owerflow:auto;">
                        <table class="table table-hover">
                          <tbody>
                            <tr>
                              <th>{{ $ml.get('employees.movementOT') }}</th>
                              <th>{{ $ml.get('employees.statusOT') }}</th>
                              <th></th>
                            </tr>
                            <tr v-for="(inOutDetail, index) in dailyInOutDetailList" :key="index">
                              <td>{{ inOutDetail.date }}</td>
                              <td>
                                <span v-show="inOutDetail.status == 'Giriş'" class="label label-success">{{
                                  $ml.get('employees.entryMovement') }}</span>
                                <span v-show="inOutDetail.status == 'Çıkış'" class="label label-danger">{{
                                  $ml.get('employees.exitMovement') }}</span>
                              </td>
                              <td>
                                <button class="btn btn-xs btn-primary" @click="selectInOut2(inOutDetail)">
                                  <i class="fa fa-edit"></i>
                                </button>
                                <button @click="deleteInOut2(inOutDetail.id)" class="btn btn-xs btn-danger">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="dailyInOutDetailList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('employees.movementNotRecord') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="row">
                    <div class="form-group col-sm-6 text-center">
                      <span>{{ $ml.get('employees.calculatedOvertimeLong') }}</span>
                      <label class="form-control">{{ selectedDailyPayrol.calculatedOverTime }}</label>
                    </div>
                    <div class="form-group col-sm-6 text-center">
                      <span>{{ $ml.get('employees.confirmedOvertimeLong') }}</span>
                      <input :disabled="selectedDailyPayrol.overTimeId == null" type="time" class="form-control"
                        style="color:black;" v-model="selectedDailyPayrol.confirmedOverTime" />
                    </div>
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('employees.overtimePlace') }}</span>
                    <select @change="changeOvertimePlace($event)" class="form-control">
                      <option :selected="selectedOTPlaceId == null" value>{{ $ml.get('general.notSelected') }}</option>
                      <option :selected="place.id == selectedOTPlaceId" v-for="place in overtimePlaceList"
                        :key="place.id" :value="place.id">{{ place.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('employees.overtimeDescription') }}</span>
                    <select @change="changeOvertimeDescription($event)" class="form-control">
                      <option :selected="selectedOTDescriptionId == null" value>{{ $ml.get('general.notSelected') }}
                      </option>
                      <option :selected="description.id == selectedOTDescriptionId"
                        v-for="description in overtimeDescriptionList" :key="description.id" :value="description.id">
                        {{ description.name }}</option>
                    </select>
                  </div>
                  <button :disabled="selectedDailyPayrol.overTimeId == null" type="button"
                    @click="customConfirmOverTime()" class="btn btn-outline btn-sm" style="width:100%;"
                    data-dismiss="modal">{{ $ml.get('general.confirm') }}</button>
                  <hr />
                  <div style="display:flex;">
                    <button type="button" class="btn btn-sm btn-warning" style="width:100%;margin-bottom:5px;"
                      @click="newInOut2()">
                      <i class="fa fa-plus"></i>
                      {{ $ml.get('employees.newMovement') }}
                    </button>
                  </div>
                  <div v-show="isActiveInOut2 == true">
                    <div class="form-group">
                      <label>{{ $ml.get('employees.timeMovement') }}</label>
                      <input v-model="inOut2.inOutAdd" type="datetime-local" class="form-control input-sm" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('employees.readerMovement') }}</label>
                      <select @change="changeInOutDoor2($event)" class="form-control input-sm">
                        <option value="0" :selected="inOut2.inOutType == 0">{{ $ml.get('general.notSelected') }}
                        </option>
                        <option v-for="door in activePDKSReaderList" :key="door.readerId" :value="door.readerId"
                          :selected="door.readerId == inOut2.readerId">{{ door.name }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('employees.typeMovement') }}</label>
                      <select @change="changeInOutType2($event)" class="form-control input-sm">
                        <option value="0" :selected="inOut2.inOutType == 0">{{ $ml.get('general.notSelected') }}
                        </option>
                        <option value="1" :selected="inOut2.inOutType == 1">{{ $ml.get('employees.entryMovement') }}
                        </option>
                        <option value="2" :selected="inOut2.inOutType == 2">{{ $ml.get('employees.exitMovement') }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group">
                      <span class="checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="includePassiveMovements"
                            @change="includePassiveMovements == true ? includePassiveMovements = false : includePassiveMovements = true"
                            type="checkbox" />
                          {{ $ml.get('employees.includePassivesMovement') }}
                        </label>
                      </span>
                    </div>
                    <div class="form-group">
                      <span class="checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="doNotDeleteOvertimes"
                            @change="doNotDeleteOvertimes == true ? doNotDeleteOvertimes = false : doNotDeleteOvertimes = true"
                            type="checkbox" />
                          {{ $ml.get('employees.confirmedOvertimeNotDeleted') }}
                        </label>
                      </span>
                    </div>
                    <button v-show="isNewInOut2" type="button" @click="addInOut2()" class="btn btn-outline"
                      style="width:100%;">{{ $ml.get('general.save') }}</button>
                    <button v-show="!isNewInOut2" type="button" @click="updateInOut2()" class="btn btn-outline"
                      style="width:100%;">{{ $ml.get('general.update') }}</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal"
                @click="isActiveInOut2 = false">{{ $ml.get('general.cancel') }}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--PUANTAJ DETAY MODAL END -->
      <!--PARMAK İZİ MODAL -->
      <div class="modal modal-secondary fade" id="fingerPrintModal" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ employee.name }} - {{ $ml.get('employees.fingerPrintInformation') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div v-show="fpScreen == 0" class="col-sm-12">
                  <div class="callout callout-warning">
                    <i class="fa fa-info-circle"></i>
                    {{ $ml.get('employees.fingerPrintDescription') }}
                  </div>
                </div>
                <div v-show="fpScreen == 1" class="col-sm-12">
                  <div class="callout callout-success">
                    <i class="fa fa-info-circle"></i> Seçilen parmak izi için kayıt başlasın mı?
                    <button class="btn btn-outline" @click="getFP()">Evet</button>
                    <button class="btn btn-outline" @click="clearFP()">Hayır</button>
                  </div>
                </div>
                <div v-show="fpScreen == 2" class="col-sm-12">
                  <div class="callout callout-danger">
                    <i class="fa fa-info-circle"></i> Seçilen parmak izi silinecektir. Devam edilsin mi?
                    <button class="btn btn-outline" @click="deleteFP()">Evet</button>
                    <button class="btn btn-outline" @click="clearFP()">Hayır</button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div style="top:97px;left:10px;" @click="GetOrDeleteFP(1)" :class="getFingerClass(1)"
                    :title="getHasFinger(1) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    1</div>
                  <div style="top:23px;left:77px;" @click="GetOrDeleteFP(2)" :class="getFingerClass(2)"
                    :title="getHasFinger(2) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    2</div>
                  <div style="top:3px;left:150px;" @click="GetOrDeleteFP(3)" :class="getFingerClass(3)"
                    :title="getHasFinger(3) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    3</div>
                  <div style="top:33px;left:240px;" @click="GetOrDeleteFP(4)" :class="getFingerClass(4)"
                    :title="getHasFinger(4) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    4</div>
                  <div style="top:195px;left:310px;" @click="GetOrDeleteFP(5)" :class="getFingerClass(5)"
                    :title="getHasFinger(5) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    5</div>
                  <img src="/src/assets/hand.jpg" style="width:350px;" />
                </div>
                <div class="col-sm-6">
                  <div style="top:195px;left:20px;" @click="GetOrDeleteFP(6)" :class="getFingerClass(6)"
                    :title="getHasFinger(6) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    6</div>
                  <div style="top:33px;left:90px;" @click="GetOrDeleteFP(7)" :class="getFingerClass(7)"
                    :title="getHasFinger(7) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    7</div>
                  <div style="top:3px;left:180px;" @click="GetOrDeleteFP(8)" :class="getFingerClass(8)"
                    :title="getHasFinger(8) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    8</div>
                  <div style="top:23px;left:250px;" @click="GetOrDeleteFP(9)" :class="getFingerClass(9)"
                    :title="getHasFinger(9) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    9</div>
                  <div style="top:97px;left:320px;" @click="GetOrDeleteFP(10)" :class="getFingerClass(10)"
                    :title="getHasFinger(10) ? $ml.get('employees.fingerprintExist') : $ml.get('employees.fingerprintNotExist')">
                    10</div>
                  <img src="/src/assets/hand.jpg"
                    style="width:350px;transform: scaleX(-1);-webkit-transform: scaleX(-1);" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary pull-left" data-dismiss="modal">{{ $ml.get('general.close')
              }}</button>
              <button @click="getEmployee(employee.id)" type="button" class="btn btn-primary">
                <i class="fa fa-refresh"></i>
                {{ $ml.get('general.refreshScreen') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--PARMAK İZİ MODAL END -->
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterDepartments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
              </a>
              <div v-show="sortableDepartmentList.length > 0" class="table-responsive"
                style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="dep.id">
                  <label style="margin-left:20px;">
                    <input :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox" />
                    {{ dep.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                  {{ $ml.get('employees.departmentNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterState') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                  <label style="margin-left:20px;">
                    <input :checked="state.isCheck"
                      @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                    {{ state.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="stateList.length == 0">
                  {{ $ml.get('employees.stateNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterStatus') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                  <label style="margin-left:20px;">
                    <input :checked="status.isCheck"
                      @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true"
                      type="checkbox" />
                    {{ status.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="statuList.length == 0">
                  {{ $ml.get('employees.statusNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                  <label style="margin-left:20px;">
                    <input :checked="acc.isCheck"
                      @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true" type="checkbox" />
                    {{ acc.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                  {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="work in periodWorkGroupList" :key="work.id">
                  <label style="margin-left:20px;">
                    <input :checked="work.isCheck"
                      @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true" type="checkbox" />
                    {{ work.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="periodWorkGroupList.length == 0">
                  {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="foodGroup in foodGroupList" :key="foodGroup.id">
                  <label style="margin-left:20px;">
                    <input :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                      type="checkbox" />
                    {{ foodGroup.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                  {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
      <!--KONUM MODAL -->
      <div class="modal modal-secondary fade" id="modal-konum" style="display: none;">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.location') }}</span>
              </h4>
            </div>
            <div class="modal-body text-center">
              <label class="form-control">Koordinatlar: {{ inOut.positionX }} - {{ inOut.positionY }}</label>
              <a class="btn btn-primary" style="margin-top:10px;" target="_blank"
                :href="'http://maps.google.com/maps?f=q&hl=en&q=' + inOut.positionX + '+N,+' + inOut.positionY + '+E&ie=UTF8&t=k&om=0&ll=' + inOut.positionX + ',' + inOut.positionY + '&spn=0.003022,0.004989&t=k'">
                <i class="fa fa-map-marker"></i> Haritada Görüntüle
              </a>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--KONUM MODAL END -->
      <!--ADD INVENTORY MODAL -->
      <div class="modal modal-secondary fade" id="modal-inventory" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.addInventory') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-4">
                  <h5>{{ $ml.get('inventoryManagement.inventoryList') }}</h5>
                  <hr />
                  <input type="text" :placeholder="$ml.get('general.search')" v-model="searchInventoryText"
                    class="form-control" autocomplete="false" style="margin-bottom:10px;" />
                  <select class="form-control" v-model="selectedInventoryCategory" style="margin-bottom:10px;">
                    <option :value="0">{{ $ml.get('inventoryManagement.allCategories') }}</option>
                    <option v-for="category in inventoryCategoryList" :key="category.id" :value="category.id">{{
                      category.name }}</option>
                  </select>
                  <div v-show="inventoryList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="inventory in inventoryList" :key="inventory.id"
                          @click="employeeInventory.inventoryId = inventory.id" style="cursor:pointer;">
                          <td>
                            <span>{{ inventory.name }}</span><br />
                            <small class="text-muted">{{ inventory.code }}</small>
                          </td>
                          <td style="align-content: center;">
                            <span v-show="employeeInventory.inventoryId === inventory.id" class="badge label-success">{{
                              $ml.get('general.selected') }}</span>
                          </td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="inventoryList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i> {{ $ml.get('alerts.recordNotFound') }}
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="form-group">
                    <label>{{ $ml.get('employees.selectedInventory') }}</label>
                    <label v-show="employeeInventory.inventoryId == null"
                      v-text="getInventoryFromId(employeeInventory.inventoryId).name" class="form-control" />
                    <div class="input-group" v-show="employeeInventory.inventoryId != null">
                      <label v-text="getInventoryFromId(employeeInventory.inventoryId).name" class="form-control" />
                      <span class="input-group-btn" v-show="employeeInventory.inventoryId != null">
                        <button @click="employeeInventory.inventoryId = null" type="button" class="btn btn-danger">
                          <i class="fa fa-trash"></i>
                        </button>
                      </span>
                    </div>
                    <div class="form-group" style="margin-top:10px;">
                      <label>{{ $ml.get('employees.inventoryQuantity') }}</label>
                      <input type="number" v-model="employeeInventory.quantity" min="1" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('employees.deliveryDate') }}</label>
                      <input type="date" v-model="employeeInventory.deliveryDate" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('employees.takenDate') }}</label>
                      <input type="date" v-model="employeeInventory.takenDate" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('employees.inventoryDescription') }}</label>
                      <textarea v-model="employeeInventory.description" class="form-control"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="saveEmployeeInventory()">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.save') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ADD INVENTORY MODAL END -->
      <!--INVENTORY DETAILS MODAL -->
      <div class="modal modal-secondary fade" id="modal-inventory-details" style="display: none;">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ getInventoryFromId(employeeInventory.inventoryId).name }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="box box-primary">
                    <div class="box-body box-profile">
                      <img class="profile-user-img img-responsive"
                        :src="getInventoryFromId(employeeInventory.inventoryId).photoUrl == null ? '/src/assets/default-product.png' : getInventoryFromId(employeeInventory.inventoryId).photoUrl"
                        style="width:100%;" />
                      <hr />
                      <p class="text-center">
                        <span class="text-muted" style="font-size: 12px;">{{
                          getInventoryFromId(employeeInventory.inventoryId).code
                        }}</span><br />
                        <span>{{ getInventoryFromId(employeeInventory.inventoryId).name }}</span><br />
                        <span style="font-style: italic;font-size: 12px;">{{
                          getInventoryCategoryName(getInventoryFromId(employeeInventory.inventoryId).categoryId)
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group" style="margin-bottom:10px;">
                    <label>{{ $ml.get('employees.selectedInventory') }}</label><br />
                    <span>{{ getInventoryFromId(employeeInventory.inventoryId).name }}</span>
                  </div>
                  <div class="form-group" style="margin-bottom:10px;">
                    <label>{{ $ml.get('employees.inventoryQuantity') }}</label><br />
                    <span>{{ employeeInventory.quantity }}</span>
                  </div>
                  <div class="form-group" style="margin-bottom:10px;">
                    <label>{{ $ml.get('employees.deliveryDate') }}</label><br />
                    <span>{{ employeeInventory.deliveryDate | toDateFormatGet("gg.aa.yyyy") }}</span>
                  </div>
                  <div class="form-group" style="margin-bottom:10px;">
                    <label>{{ $ml.get('employees.takenDate') }}</label><br />
                    <span v-show="employee.takenDate == null">-</span>
                    <span v-show="employee.takenDate != null">{{ employeeInventory.takenDate |
                      toDateFormatGet("gg.aa.yyyy") }}</span>
                  </div>
                  <div class="form-group" style="margin-bottom:10px;">
                    <label>{{ $ml.get('employees.inventoryDescription') }}</label><br />
                    <span>{{ employeeInventory.description }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="deleteEmployeeInventory()">
                <i class="fa fa-times"></i>
                {{ $ml.get('general.delete') }}
              </button>
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.close') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ADD INVENTORY MODAL END -->
    </section>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  data() {
    return {
      isLoading: false,
      isLoadingInOuts: false,
      isLoadingAllowence: false,
      isLoadingPayrolls: false,
      isLoadingLogs: false,
      isLoadingEmployee: false,
      isLoadingAllowenceModal: false,
      isLoadingSalary: false,
      isLoadingPayment: false,
      isLoadingWorkPlace: false,
      isLoadingInventory: false,
      windowHeight: window.innerHeight,
      requiredFields: [],
      orderEmpList: 1,
      fpScreen: 0,
      selectedFPIndex: 0,
      textSearchDepartment: "",
      selectedDailyPayrol: {
        date: "",
        workGroup: "",
        movements: [],
        payrolls: [],
        calculatedOverTime: "00:00",
        confirmedOverTime: "00:00",
        overTimeId: null
      },
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        plateNo: "",
        hgsNo: "",
        tzCode: "",
        documentNo: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        validityStartDate: null,
        validityEndDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: null,
        credit: 0,
        remainder: "0",
        isVisitor: false,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        payments: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false,
        roomId: 0,
        roomName: "",
        areaName: "",
        floorName: "",
        fingerIndexes: [],
        isSmsSend: false,
        parentPhone: null,
        isStudent: false,
        isStayInDormitory: false,
        motherName: "",
        motherPhone: "",
        fatherName: "",
        fatherPhone: "",
        isMobileUser: false,
        mobilePassword: "",
        foodClaim: false
      },
      searchInventoryText: "",
      selectedInventoryCategory: 0,
      employeeInventory: {
        id: null,
        employeeId: null,
        inventoryId: null,
        quantity: 0,
        deliveryDate: null,
        takenDate: null,
        description: ""
      },
      employeeInventories: [],
      inventories: [],
      inventoryCategories: [],
      document: {
        id: null,
        documentDefinitionId: null,
        description: "",
        filePath: "",
        isISGDocument: false,
        starDate: null,
        endDate: null,
        isActive: true
      },
      documents: [],
      documentDefinitions: [],
      selectedDoorTypeMovement: 0,
      inOut: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 4,
        inOutType: 0,
        inOutAdd: "",
        readerId: "0",
        positionX: "",
        positionY: "",
        inOutStartDate: null,
        inOutEndDate: null
      },
      isActiveInOut2: false,
      inOut2: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 4,
        inOutType: 0,
        inOutAdd: "",
        readerId: "0"
      },
      salaries: [],
      salary: {
        id: null,
        salary: 0,
        updateTime: null
      },
      payment: {
        id: null,
        searchStartDate: null,
        searchEndDate: null,
        salaryId: null,
        salaryName: "",
        status: 1,
        price: 0,
        date: null
      },
      workPlaceDefinitions: [],
      workPlaceDefinition: {
        id: null,
        name: ""
      },
      workPlaces: [],
      workPlace: {
        id: null,
        employeeId: null,
        workplaceId: null,
        description: "",
        startDate: null,
        endDate: null,
      },
      allowence: {
        id: null,
        searchStartDate: null,
        searchEndDate: null,
        startDate: null,
        endDate: null,
        allowenceType: 0,
        description: "",
        allowenceId: null,
        holidayPass: false,
        allowenceTime: "00:00",
        missingTime: "00:00",
        equalTheMissingTime: true
      },
      days: [
        { value: 1, name: this.$ml.get("general.monday"), check: true },
        { value: 2, name: this.$ml.get("general.tuesday"), check: true },
        { value: 3, name: this.$ml.get("general.wednesday"), check: true },
        { value: 4, name: this.$ml.get("general.thursday"), check: true },
        { value: 5, name: this.$ml.get("general.friday"), check: true },
        { value: 6, name: this.$ml.get("general.saturday"), check: true },
        { value: 7, name: this.$ml.get("general.sunday"), check: true }
      ],
      selectedChangePayroll: {
        isAllowence: false,
        changeDate: "",
        newOperationId: null
      },
      includePassiveMovements: false,
      doNotDeleteOvertimes: true,
      paymentDefinitions: [],
      sortableDepTrees: [],
      selectedFoodType: 1,
      selectedFoodCount: "0",
      isNewPaymentDefinition: true,
      paymentDefinition: {
        id: null,
        name: "",
        status: 1
      },
      isNewState: true,
      selectedStateId: null,
      selectedStateName: "",
      selectedStateStatus: false,
      isNewStatu: true,
      selectedStatuId: null,
      selectedStatuName: "",
      searchPayrollStartDate: null,
      searchPayrollEndDate: null,
      selectAP: 1,
      logStartDate: null,
      logEndDate: null,
      allowences: [],
      startDateRemoveAllowence: null,
      endDateRemoveAllowence: null,
      extrafields: [],
      workGroups: [],
      status: [],
      states: [],
      foodGroups: [],
      titles: [],
      accessGroups: [],
      departments: [],
      employees: [],
      allEmployees: [],
      annualPermits: [],
      visitorCardGroups: [],
      isNewVisitorCardGroup: true,
      selectedVisitorCardGroupId: null,
      selectedVisitorCardGroupName: "",
      selectedVisitorCardGroupDevices: [],
      overtimeDescriptions: [],
      overtimePlaces: [],
      selectedOTDescriptionId: null,
      selectedOTPlaceId: null,
      selectedOverTimeId: null,
      searchText2: "",
      readers: [],
      isCheck: false,
      isCheckDeps: false,
      searchText: "",
      extraFieldKey: "",
      extraFieldValue: "",
      isNewInOut: true,
      isNewInOut2: true,
      isNewExtraField: true,
      isNewEmployee: true,
      isNewAllowence: true,
      isNewPayment: true,
      isNewWorkPlace: true,
      isDoubleSidedPrint: false,
      cardDesigns: [],
      cardDesign: {
        id: null,
        name: "",
        backgroundImage: null,
        backgroundColor: "#ffffff",
        template: {
          items: []
        }
      },
      cardDesign2: {
        id: null,
        name: "",
        backgroundImage: null,
        backgroundColor: "#ffffff",
        template: {
          items: []
        }
      },
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {}
    };
  },
  components: {
    "my-upload": myUpload
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
      });
      return formatter.format(value);
    },
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthKisiler;
    },
    dayList() {
      return this.days;
    },
    inventoryCategoryList() {
      return this.inventoryCategories;
    },
    inventoryList() {
      if (this.searchInventoryText) {
        return this.inventories.filter(item => {
          return this.searchInventoryText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else if (this.selectedInventoryCategory && this.selectedInventoryCategory != 0) {
        return this.inventories.filter(item => item.categoryId == this.selectedInventoryCategory);
      } else {
        return this.inventories;
      }
    },
    employeeInventoryList() {
      return this.employeeInventories;
    },
    documentList() {
      return this.documents;
    },
    documentDefinitionList() {
      return this.documentDefinitions;
    },
    overtimeDescriptionList() {
      return this.overtimeDescriptions;
    },
    overtimePlaceList() {
      return this.overtimePlaces;
    },
    logList() {
      return this.employee.logs;
    },
    dailyPayrollDetailList() {
      return this.selectedDailyPayrol.payrolls;
    },
    dailyInOutDetailList() {
      return this.selectedDailyPayrol.movements;
    },
    readerList() {
      return this.readers.sort((a, b) => {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    salaryForEmployeeList() {
      return this.salaries;
    },
    paymentDefinitionList() {
      return this.paymentDefinitions;
    },
    workPlaceDefinitionList() {
      return this.workPlaceDefinitions;
    },
    workPlaceList() {
      return this.workPlaces;
    },
    activeReaderList() {
      return this.readerList.filter(item => {
        return item.isActive == true;
      });
    },
    activeMovementReaderList() {
      if (this.selectedDoorTypeMovement == 0) {
        return this.readerList.filter(item => {
          return item.isActive == true && item.doorType != 2;
        });
      } else if (this.selectedDoorTypeMovement == 1) {
        return this.readerList.filter(item => {
          return (
            item.isActive == true &&
            item.doorType != 2 &&
            (item.inOrOut == 1 || item.inOrOut == 0)
          );
        });
      } else {
        return this.readerList.filter(item => {
          return (
            item.isActive == true &&
            item.doorType != 2 &&
            (item.inOrOut == 2 || item.inOrOut == 0)
          );
        });
      }
    },
    activePDKSReaderList() {
      return this.readerList.filter(item => {
        return item.isActive == true && item.doorType == 1;
      });
    },
    visitorCardGroupList() {
      return this.visitorCardGroups;
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepTrees.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.sicilNo).localeCompare(
            this.turkishToUpper(b.sicilNo)
          );
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.sicilNo).localeCompare(
            this.turkishToUpper(a.sicilNo)
          );
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.name).localeCompare(
            this.turkishToUpper(b.name)
          );
        });
      } else {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.name).localeCompare(
            this.turkishToUpper(a.name)
          );
        });
      }
    },
    allEmployeeList() {
      return this.allEmployees;
    },
    titleList() {
      return this.titles;
    },
    stateList() {
      return this.states;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList() {
      return this.status;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList() {
      return this.extrafields;
    },
    employeeExtraFieldList() {
      return this.employee.extrafields;
    },
    workGroupList() {
      return this.workGroups;
    },
    periodWorkGroupList() {
      return this.workGroups.filter(item => {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    allowenceList() {
      return this.allowences;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    EmpPayrollList() {
      return this.employee.empPayrolls;
    },
    annualPermitList() {
      return this.annualPermits;
    },
    annualPermitDetailList() {
      return this.employee.annualPermits;
    },
    annualPermitClaimsDateList() {
      return this.employee.annualPermitClaimsDates;
    },
    inOutList() {
      return this.employee.inOuts;
    },
    allowenceForEmployeeList() {
      return this.employee.allowences;
    },
    paymentForEmployeeList() {
      return this.employee.payments;
    },
    allEmployeeFilteredList() {
      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.allEmployeeList.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) ||
                this.turkishToUpper(item.sicilNo).includes(v)
            );
        });
      } else {
        return this.allEmployeeList;
      }
    },
    filtered() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeList.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) ||
                this.turkishToUpper(item.sicilNo).includes(v)
            );
        });
      } else {
        return this.employeeList;
      }
    },
    inOutFiltered() {
      if (this.inOut.inOutListType == 0) {
        if (this.inOut.inOutListDoorType == 4) {
          return this.inOutList;
        } else {
          return this.inOutList.filter(item => {
            return item.doorType == this.inOut.inOutListDoorType;
          });
        }
      }
      if (this.inOut.inOutListType == 1) {
        return this.inOutList.filter(item => {
          if (this.inOut.inOutListDoorType == 4) {
            return item.isActive == true;
          } else {
            return (
              item.isActive == true &&
              item.doorType == this.inOut.inOutListDoorType
            );
          }
        });
      } else if (this.inOut.inOutListType == 2) {
        return this.inOutList.filter(item => {
          if (this.inOut.inOutListDoorType == 4) {
            return item.isActive == false;
          } else {
            return (
              item.isActive == false &&
              item.doorType == this.inOut.inOutListDoorType
            );
          }
        });
      }
    },
    cardDesignList() {
      return this.cardDesigns;
    },
    cardLabelItems() {
      return this.cardDesign.template.items.filter(a => {
        return a.type == 0;
      });
    },
    cardValueItems() {
      return this.cardDesign.template.items.filter(a => {
        return a.type == 1;
      });
    },
    cardImageItems() {
      return this.cardDesign.template.items.filter(a => {
        return a.type == 2;
      });
    },
    cardLabelItems2() {
      return this.cardDesign2.template.items.filter(a => {
        return a.type == 0;
      });
    },
    cardValueItems2() {
      return this.cardDesign2.template.items.filter(a => {
        return a.type == 1;
      });
    },
    cardImageItems2() {
      return this.cardDesign2.template.items.filter(a => {
        return a.type == 2;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowACHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 320;
        return "height:" + height + "px;overflow:auto;";
      } else {
        return "height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    itemStyle(item) {
      return (
        "position:absolute;width:" +
        item.width +
        "px;height:" +
        item.height +
        "px;top:" +
        item.top +
        "px;left:" +
        item.left +
        "px;font-size:" +
        item.fontSize +
        "px;text-align:" +
        item.fontAlign +
        ";" +
        item.fontWeight +
        item.fontItalic +
        ";color:" +
        item.fontColor +
        ";"
      );
    },
    imageItemStyle(item) {
      return (
        "position:absolute;width:" +
        item.width +
        "px;height:" +
        item.height +
        "px;top:" +
        item.top +
        "px;left:" +
        item.left +
        "px;"
      );
    },
    changeCardDesign(event) {
      var a = this.cardDesignList.filter(b => {
        return b.id == event.target.value;
      });
      if (a[0]) {
        this.cardDesign = a[0];
      }
    },
    changeCardDesign2(event) {
      var a = this.cardDesignList.filter(b => {
        return b.id == event.target.value;
      });
      if (a[0]) {
        this.cardDesign2 = a[0];
      }
    },
    getValueTitle(value) {
      if (value == 0) {
        return this.employee.sicilNo;
      } else if (value == 1) {
        return this.employee.identityNo;
      } else if (value == 2) {
        return this.employee.name;
      } else if (value == 3) {
        return this.getDepartmentFromId(this.employee.departmentId);
      } else if (value == 4) {
        return this.employee.title;
      } else if (value == 5) {
        return this.employee.birthDayDate;
      } else if (value == 6) {
        return this.employee.startDate;
      } else if (value == 7) {
        return this.getStatusFromId(this.employee.statuId);
      } else if (value == 8) {
        return this.getStateFromId(this.employee.stateId);
      } else if (value == 9) {
        return this.employee.stateNote;
      } else if (value == 10) {
        return this.employee.terminalNo;
      } else if (value == 11) {
        if (this.employee.terminalStatu == 0) {
          return "User";
        } else {
          return "Admin";
        }
      } else if (value == 12) {
        return this.employee.cardNo;
      } else if (value == 13) {
        return this.employee.plateNo;
      } else if (value == 14) {
        return this.employee.hgsNo;
      } else if (value == 15) {
        return this.getWorkGroupFromId(this.employee.workGroupId);
      } else if (value == 16) {
        return this.employee.documentNo;
      } else if (value == 17) {
        return this.employee.mail;
      } else if (value == 18) {
        return this.employee.address;
      } else if (value == 19) {
        return this.employee.mobilePhone;
      } else if (value == 20) {
        return this.employee.internalPhone;
      } else if (value == 21) {
        return this.employee.homePhone;
      } else if (value == 22) {
        if (this.employee.gender) {
          if (this.employee.gender == 0) {
            return "-";
          } else if (this.employee.gender == 1) {
            return this.$ml.get("employees.male");
          } else if (this.employee.gender == 2) {
            return this.$ml.get("employees.female");
          }
        } else {
          return "-";
        }
      } else if (value == 23) {
        if (this.employee.educationStatus == 0) {
          return "-";
        } else if (this.employee.educationStatus == 1) {
          return this.$ml.get("employees.primarySchool");
        } else if (this.employee.educationStatus == 2) {
          return this.$ml.get("employees.highSchool");
        } else if (this.employee.educationStatus == 3) {
          return this.$ml.get("employees.associateDegree");
        } else if (this.employee.educationStatus == 4) {
          return this.$ml.get("employees.bachelorDegree");
        } else if (this.employee.educationStatus == 5) {
          return this.$ml.get("employees.postGraduate");
        } else if (this.employee.educationStatus == 6) {
          return this.$ml.get("employees.doctorate");
        }
      } else if (value == 24) {
        if (this.employee.militaryStatus == 0) {
          return "-";
        } else if (this.employee.militaryStatus == 1) {
          return this.$ml.get("employees.done");
        } else if (this.employee.militaryStatus == 2) {
          return this.$ml.get("employees.exempt");
        }
      } else if (value == 25) {
        if (this.employee.maritalStatus == 0) {
          return "-";
        } else if (this.employee.maritalStatus == 1) {
          return this.$ml.get("employees.single");
        } else if (this.employee.maritalStatus == 2) {
          return this.$ml.get("employees.married");
        } else if (this.employee.maritalStatus == 3) {
          return this.$ml.get("employees.widow");
        }
      } else if (value == 26) {
        return this.employee.drivingLicence;
      } else if (value == 27) {
        return this.employee.foreignLanguagFe;
      } else if (value == 28) {
        return this.employee.bloodType;
      }
    },
    getFingerClass(fingerIndex) {
      var result = this.employee.fingerIndexes.filter(a => {
        return a == fingerIndex;
      });
      if (result[0]) {
        return "fp-kutu-yesil";
      } else {
        return "fp-kutu-kirmizi";
      }
    },
    getHasFinger(fingerIndex) {
      var result = this.employee.fingerIndexes.filter(a => {
        return a == fingerIndex;
      });
      if (result[0]) {
        return true;
      } else {
        return false;
      }
    },
    changeExtraFieldKey(event) {
      this.extraFieldKey = event.target.value;
    },
    getExtraFieldName(id) {
      var grup = this.extraFieldList.filter(a => {
        return a.id == id;
      });
      if (grup[0]) {
        return grup[0].name;
      } else {
        return "";
      }
    },
    selectedDays() {
      let selectedDays = [];
      let aList = this.days;
      aList.forEach(doc => {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    async exportToPDFCard() {
      this.$htmlToPaper("printCards", {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: ["./vendor/dist/css/cardDesign.css"]
      });
      try {
        const response = await this.$axios
          .post("/EmployeeDetails/EmployeeLog", {
            employeeId: this.employee.id,
            message:
              this.cardDesign.name + " şablonu ile kart baskısı gerçekleşti"
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        if (response.status == 200) {
        } else {
          alertify.error(response.message);
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    exportToPDFInventory() {
      this.$htmlToPaper("printInventory");
    },
    exportToPDFLogs() {
      this.$htmlToPaper("printLogs");
    },
    exportToPDFPuantaj() {
      this.$htmlToPaper("printPuantaj");
    },
    exportToPDFHareketler() {
      this.$htmlToPaper("printHareketler");
    },
    exportToPDFIzinler() {
      this.$htmlToPaper("printIzinler");
    },
    exportToPDFOdemeler() {
      this.$htmlToPaper("printOdemeler");
    },
    toDateFormat(str, format) {
      if(!str || str == ""){
        return str;
      }
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "yyyy-aa-gg ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun + " " + str.getHours() + ":" + str.getMinutes();
      } else if (format == "yyyy-aa-gg") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    selectPaymentDefinition(id, name, status) {
      this.isNewPaymentDefinition = false;
      this.paymentDefinition.id = id;
      this.paymentDefinition.name = name;
      this.paymentDefinition.status = status;
    },
    newPaymentDefinition() {
      this.isNewPaymentDefinition = true;
      this.paymentDefinition.id = null;
      this.paymentDefinition.name = "";
      this.paymentDefinition.status = 1;
    },
    async savePaymentDefinition() {
      if (this.paymentDefinition.name == "") {
        alertify.warning(this.$ml.get("alerts.salaryNameNotBlank"));
        return;
      }
      try {
        let id = this.paymentDefinition.id;
        let name = this.paymentDefinition.name;
        let status = this.paymentDefinition.status;
        if (this.isNewPaymentDefinition == true) {
          const response = await this.$axios
            .post("/Salary", {
              name: name,
              status: status
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newPaymentDefinition();
          this.getPaymentDefinitions();
        } else {
          const response = await this.$axios
            .post("/Salary/" + id, {
              id: id,
              name: name,
              status: status
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newPaymentDefinition();
          this.getPaymentDefinitions();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deletePaymentDefinition() {
      try {
        let id = this.paymentDefinition.id;
        if (id != null) {
          const response = this.$axios
            .delete("/Salary/" + id)
            .then(response => {
              this.getPaymentDefinitions();
              this.newPaymentDefinition();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    selectVisitorCardGroup(id, name, devices) {
      this.isNewVisitorCardGroup = false;
      this.selectedVisitorCardGroupId = id;
      this.selectedVisitorCardGroupDevices = devices;
      this.readers.forEach(device => {
        device.VCGcheck = false;
      });
      if (devices) {
        devices.forEach(item => {
          this.readers.forEach(device => {
            if (item == device.readerId) {
              device.VCGcheck = true;
            }
          });
        });
      }
      this.selectedVisitorCardGroupName = name;
    },
    newVisitorCardGroup() {
      this.isNewVisitorCardGroup = true;
      this.readers.forEach(device => {
        device.VCGcheck = false;
      });
      this.selectedVisitorCardGroupId = null;
      this.selectedVisitorCardGroupDevices = [];
      this.selectedVisitorCardGroupName = "";
    },
    async saveVisitorCardGroup() {
      if (this.selectedVisitorCardGroupName == "") {
        alertify.warning(this.$ml.get("alerts.visitorCardGroupNameNotBlank"));
        return;
      }
      try {
        let id = this.selectedVisitorCardGroupId;
        await this.getCheckReaders();
        let name = this.selectedVisitorCardGroupName;
        let devices = this.selectedVisitorCardGroupDevices;
        if (this.isNewVisitorCardGroup == true) {
          const response = await this.$axios
            .post("/VisitorGroups", {
              name: name,
              devices: devices
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newVisitorCardGroup();
          this.getVisitorCardGroups();
        } else {
          const response = await this.$axios
            .post("/VisitorGroups/" + id, {
              id: id,
              name: name,
              devices: devices
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newVisitorCardGroup();
          this.getVisitorCardGroups();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deleteVisitorCardGroup() {
      try {
        let id = this.selectedVisitorCardGroupId;
        if (id != null) {
          const response = this.$axios
            .delete("/VisitorGroups/" + id)
            .then(response => {
              this.getVisitorCardGroups();
              this.newVisitorCardGroup();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    removePhonePair() {
      try {
        let id = this.employee.id;
        if (id != null) {
          const response = this.$axios
            .delete("/Employees/RemovePhonePair/" + id)
            .then(response => {
              this.getEmployee(id);
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },

    selectStatu(id, name) {
      this.isNewStatu = false;
      this.selectedStatuId = id;
      this.selectedStatuName = name;
    },
    newStatu() {
      this.isNewStatu = true;
      this.selectedStatuId = null;
      this.selectedStatuName = "";
    },
    async saveStatu() {
      if (this.selectedStatuName == "") {
        alertify.warning(this.$ml.get("alerts.statusNameNotBlank"));
        return;
      }
      try {
        let id = this.selectedStatuId;
        let name = this.selectedStatuName;
        if (this.isNewStatu == true) {
          const response = await this.$axios
            .post("/Employees/AddStatus", {
              name: name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newStatu();
          this.getStatus();
        } else {
          const response = await this.$axios
            .post("/Employees/UpdateStatus/" + id, {
              id: id,
              name: name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newStatu();
          this.getStatus();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deleteStatu() {
      try {
        let id = this.selectedStatuId;
        if (id != null) {
          const response = this.$axios
            .delete("/Employees/DeleteStatus/" + id)
            .then(response => {
              this.getStatus();
              this.newStatu();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    selectState(id, name, status) {
      this.isNewState = false;
      this.selectedStateId = id;
      this.selectedStateName = name;
      this.selectedStateStatus = status;
    },
    newState() {
      this.isNewState = true;
      this.selectedStateId = null;
      this.selectedStateName = "";
      this.selectedStateStatus = false;
    },
    async saveState() {
      if (this.selectedStateName == "") {
        alertify.warning(this.$ml.get("alerts.stateNameNotBlank"));
        return;
      }
      try {
        let id = this.selectedStateId;
        let name = this.selectedStateName;
        let status = this.selectedStateStatus;
        if (this.isNewState == true) {
          const response = await this.$axios
            .post("/Employees/AddState", {
              name: name,
              status: status
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newState();
          this.getStates();
        } else {
          const response = await this.$axios
            .post("/Employees/UpdateState/" + id, {
              id: id,
              name: name,
              status: status
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newState();
          this.getStates();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deleteState() {
      try {
        let id = this.selectedStateId;
        if (id != null) {
          const response = this.$axios
            .delete("/Employees/DeleteState/" + id)
            .then(response => {
              this.getStates();
              this.newState();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    validityDateOpenModal() {
      if (this.employee.id) {
        if (this.employee.validityEndDate) {
          //remove
          $("#modalRemoveValidity").modal("show");
        } else {
          //create
          $("#modalCreateValidity").modal("show");
        }
      } else {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
    },
    async validityDateCreate() {
      //create
      var today = new Date();
      var tarih = new Date(this.employee.validityEndDate + " 00:00:00");
      if (tarih <= today) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      } else {
        await this.$axios
          .post("/Employees/SetValidityDate", {
            employeeId: this.employee.id,
            date: this.employee.validityEndDate
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              $("#modalCreateValidity").modal("hide");
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
      }
    },
    async validityDateRemove() {
      //remove
      if (this.employee.validityEndDate) {
        await this.$axios
          .post("/Employees/RemoveValidityDate", {
            employeeId: this.employee.id,
            date: null
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              this.employee.validityEndDate = null;
              $("#modalRemoveValidity").modal("hide");
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
      }
    },
    selectAuthorizedEmployee(id) {
      if (this.selectAP == 1) {
        this.employee.authorizedPerson1 = id;
      } else {
        this.employee.authorizedPerson2 = id;
      }
    },
    changeOvertimePlace(event) {
      this.selectedOTPlaceId = event.target.value;
    },
    changeOvertimeDescription(event) {
      this.selectedOTDescriptionId = event.target.value;
    },
    changePaymentForEmployee(event) {
      this.payment.salaryId = event.target.value;
    },
    changeAllowenceType(event) {
      this.allowence.allowenceType = event.target.value;
    },
    changeCheckEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.equalTheMissingTime = false;
        this.allowence.allowenceTime = "00:00";
      } else {
        this.allowence.equalTheMissingTime = true;
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    changeEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    async changeAllowenceStartTime() {
      if (this.allowence.allowenceType == 1) {
        let ed = this.allowence.endDate.split("T");
        let sd = this.allowence.startDate.split("T");
        this.allowence.endDate = sd[0] + "T" + ed[1];
        let startDate = sd[0] + "T" + sd[1];
        if (
          startDate != null &&
          sd[0] != null &&
          sd[1] != null &&
          startDate > "1900-01-01T00:00"
        ) {
          this.isLoadingAllowenceModal = true;
          let id = this.employee.id;
          const response = await this.$axios.post(
            "/EmployeeDetails/GetMissingHour",
            {
              empId: id,
              date: startDate
            }
          );
          if (response.status == 200) {
            let mT = response.data;
            let mTT = mT.split("T");
            this.allowence.missingTime = mTT[1];
            if (this.allowence.equalTheMissingTime == true) {
              this.allowence.allowenceTime = mTT[1];
            }
          } else if (response.status == 201) {
            this.allowence.missingTime = "00:00";
            this.allowence.allowenceTime = "00:00";
            alertify.warning(this.$ml.get("alerts.selectedDayNotMissingHour"));
          }
          this.isLoadingAllowenceModal = false;
        }
      }
    },
    changeInOutListType(number) {
      this.inOut.inOutListType = number;
    },
    changeInOutListDoorType(event) {
      this.inOut.inOutListDoorType = event.target.value;
    },
    removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.employee.image = null;
    },
    getStatusFromId(id) {
      let aList = this.status;
      let stat = aList.filter(function (statu) {
        return statu.id == id;
      });
      if (stat != "" && stat != null) {
        return stat[0].name;
      } else {
        return null;
      }
    },
    getStateFromId(id) {
      let aList = this.states;
      let stat = aList.filter(function (state) {
        return state.id == id;
      });
      if (stat != "" && stat != null) {
        return stat[0].name;
      } else {
        return null;
      }
    },
    getWorkGroupFromId(id) {
      let aList = this.workGroups;
      let wg = aList.filter(function (workGroup) {
        return workGroup.id == id;
      });
      if (wg != "" && wg != null) {
        return wg[0].name;
      } else {
        return null;
      }
    },
    getWorkPlaceFromId(id) {
      let aList = this.workPlaceDefinitions;
      let wg = aList.filter(function (workPlace) {
        return workPlace.id == id;
      });
      if (wg != "" && wg != null) {
        return wg[0].name;
      } else {
        return "";
      }
    },
    getDepartmentFromId(id) {
      let aList = this.departments;
      let dep = aList.filter(function (department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0].name;
      } else {
        return null;
      }
    },
    getEmpNameFromId(id) {
      let aList = this.allEmployees;
      let emp = aList.filter(function (emp) {
        return emp.id == id;
      });
      if (emp != "" && emp != null) {
        let title = "";
        if (emp[0].title != "") {
          title = " - " + emp[0].title;
        }
        return emp[0].name + title;
      } else {
        return null;
      }
    },
    getExtraFieldNameFromKey(key) {
      let extraField = this.extraFieldList.filter(a => {
        return a.id == key;
      });
      if (extraField[0]) {
        return extraField[0].name;
      } else {
        return "";
      }
    },
    async getLogs() {
      if ((this.logStartDate == null) | (this.logEndDate == null)) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingLogs = true;
        const logs = [];
        var startDate = this.logStartDate;
        var endDate = this.logEndDate;
        let id = this.employee.id;
        const response = await this.$axios.post(
          "/EmployeeDetails/GetOperationLogs",
          {
            id: id,
            startDate: startDate,
            endDate: endDate
          }
        );
        response.data.forEach(doc => {
          logs.push({
            id: doc.id,
            date: doc.date,
            description: doc.description
          });
        });
        this.employee.logs = logs;
        this.isLoadingLogs = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingLogs = false;
      }
    },
    changePaymentDefinitionStatus(event) {
      this.paymentDefinition.status = event.target.value;
    },
    changeAnnualPermit(event) {
      this.employee.annualPermitId = event.target.value;
    },
    changeVisitorCardGroup(event) {
      this.employee.visitorCardGroupId = event.target.value;
    },
    changeTerminalStatu(event) {
      this.employee.terminalStatu = event.target.value;
    },
    changeFoodGroup(event) {
      this.employee.foodGroupId = event.target.value;
    },
    changeInOutDoor(event) {
      this.inOut.readerId = event.target.value;
    },
    changeInOutDoor2(event) {
      this.inOut2.readerId = event.target.value;
    },
    changeInOutType(event) {
      this.inOut.inOutType = event.target.value;
      this.selectedDoorTypeMovement = event.target.value;
    },
    changeInOutType2(event) {
      this.inOut2.inOutType = event.target.value;
      this.selectedDoorTypeMovement = event.target.value;
    },
    changeAllowence(event) {
      this.allowence.allowenceId = event.target.value;
    },
    changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    changeDepartments(event) {
      this.employee.departmentId = event.target.value;
    },
    changeWorkGroups(event) {
      this.employee.workGroupId = event.target.value;
    },
    changeStatus(event) {
      this.employee.statuId = event.target.value;
    },
    changeStates(event) {
      this.employee.stateId = event.target.value;
      let state = this.stateList.filter(a => {
        return a.id == event.target.value;
      });
      if (state[0]) {
        if (state[0].status == true) {
          $("#modal-istencikis").modal("show");
        }
      }
    },
    changeAccessGroups(event) {
      if (event.target.value != null && event.target.value != 0) {
        this.checkListFromAccessGroup(event.target.value);
      }
      this.employee.accessGroupId = event.target.value;
    },
    changeGender(event) {
      this.employee.gender = event.target.value;
    },
    changeEducationStatus(event) {
      this.employee.educationStatus = event.target.value;
    },
    changeMilitaryStatus(event) {
      this.employee.militaryStatus = event.target.value;
    },
    changeSmokeStatus(event) {
      this.employee.smokeStatus = event.target.value;
    },
    changeMaritalStatus(event) {
      this.employee.maritalStatus = event.target.value;
    },
    changeRecordType(event) {
      if (this.modules.dormitory) {
        if (event.target.value == "2") {
          this.employee.isStudent = true;
        } else {
          this.employee.isStudent = false;
          this.employee.isStayInDormitory = false;
        }
      }
    },
    selectFoodType(number, value) {
      this.selectedFoodType = number;
      //this.selectedFoodCount = value;
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.workGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    checkReaders() {
      this.isCheck = !this.isCheck;
      let aList = this.readers;
      aList.forEach(doc => {
        if (doc.check == !this.isCheck) {
          doc.check = this.isCheck;
        }
      });
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (
                  doc.doorType == 0 ||
                  doc.doorType == 1 ||
                  doc.doorType == 2 ||
                  doc.doorType == 3 ||
                  doc.doorType == 5
                ) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    isActive: doc.isActive,
                    doorType: doc.doorType,
                    name: doc.name,
                    inOrOut: doc.inOrOut,
                    check: false,
                    VCGcheck: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("alerts.getReadersError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async updateFoodCredit() {
      if (this.selectedFoodCount == null) {
        alertify.warning(this.$ml.get("alerts.creditNotBlank"));
        return;
      }
      try {
        let employeeId = this.employee.id;
        let credit = this.selectedFoodCount.replace(",", ".");
        let creditType = this.selectedFoodType;
        const response = await this.$axios
          .post("/EmployeeDetails/UpdateCredit", {
            employeeId: employeeId,
            creditType: creditType,
            credit: credit
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        this.selectedFoodCount = 0;
        this.getEmployee(employeeId);
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async getCheckReaders() {
      this.selectedVisitorCardGroupDevices = [];
      await this.readers.forEach(doc => {
        if (doc.VCGcheck == true) {
          this.selectedVisitorCardGroupDevices.push(doc.readerId);
        }
      });
    },
    async sendUserToDevice(deviceId) {
      if (deviceId) {
        this.isLoading = true;
        try {
          var aList = [];
          aList.push(deviceId);
          const response = await this.$axios
            .post("/EmployeeDetails/SendUserToDevices", {
              empId: this.employee.id,
              devices: aList
            })
            .then(response => {
              if (response.status == 200) {
                this.isLoading = false;
                alertify.success(
                  this.$ml.get("alerts.commandSendToReaderSuccessfully")
                );
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.isLoading = false;
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                this.isLoading = false;
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                this.isLoading = false;
                alertify.error(doc.message);
              }
            });
        } catch (error) {
          this.isLoading = false;
          console.error(error);
          alertify.error(error.message);
        }
      }
    },
    async sendUserToDevices() {
      this.isLoading = true;
      try {
        var aList = [];
        await this.readers.filter(doc => {
          if (doc.check == true) {
            aList.push(doc.readerId);
          }
        });
        const response = await this.$axios
          .post("/EmployeeDetails/SendUserToDevices", {
            empId: this.employee.id,
            devices: aList
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.commandSentToDevicesSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    async GetUserDataFromDevice(readerId) {
      this.isLoading = true;
      try {
        let empId = this.employee.id;
        const response = await this.$axios
          .post("/EmployeeDetails/GetUserDataFromDevice", {
            empId: empId,
            readerId: readerId
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.getUserInfoFromTerminalsSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    async SendGetFaceCommand(readerId) {
      this.isLoading = true;
      try {
        let empId = this.employee.id;
        const response = await this.$axios
          .post("/EmployeeDetails/SendGetFaceCommand", {
            empId: empId,
            readerId: readerId
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.getFaceTemplateFromSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    selectGetFingerFromUsb() {
      this.selectedTerminal = null;
      this.fpScreen = 0;
      $("#fingerPrintModal").modal("show");
    },
    selectGetFingerFromTerminal(readerId) {
      this.selectedTerminal = readerId;
      this.fpScreen = 0;
      $("#fingerPrintModal").modal("show");
    },
    async SendGetFingerCommand(readerId, fpIndex) {
      this.isLoading = true;
      try {
        let empId = this.employee.id;
        const response = await this.$axios
          .post("/EmployeeDetails/SendGetFingerCommand", {
            empId: empId,
            readerId: readerId,
            fpIndex: fpIndex
          })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              alertify.success(
                this.$ml.get("alerts.getFingerprintsFromTerminalsSuccessfully")
              );
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.isLoading = false;
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              this.isLoading = false;
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              this.isLoading = false;
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alertify.error(error.message);
      }
    },
    newInOut2() {
      this.isNewInOut2 = true;
      this.isActiveInOut2 = true;
      var docc = this.selectedDailyPayrol.date.split(".");
      this.inOut2.inOutAdd = docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
      this.inOut2.inOutType = 0;
      this.selectedDoorTypeMovement = 0;
      this.inOut2.readerId = "0";
      this.inOut2.inOutId = null;
    },
    selectInOut2(inOutDetail) {
      this.isNewInOut2 = false;
      this.isActiveInOut2 = true;
      this.inOut2.inOutId = inOutDetail.id;
      this.inOut2.inOutType = inOutDetail.inOrOut;
      this.selectedDoorTypeMovement = inOutDetail.inOrOut;
      this.inOut2.inOutAdd = inOutDetail.unFormattedDate;
      this.inOut2.readerId = inOutDetail.readerId;
    },
    async confirmOverTime() {
      try {
        this.selectedDailyPayrol.confirmedOverTime = this.selectedDailyPayrol.calculatedOverTime;
        let id = this.selectedDailyPayrol.overTimeId;
        let calculatedDate =
          "1900-01-01T" + this.selectedDailyPayrol.calculatedOverTime + ":00";
        let confirmedDate =
          "1900-01-01T" +
          this.selectedDailyPayrol.confirmedOverTime.replace("Z", "");
        if (confirmedDate > calculatedDate) {
          alertify.warning(
            this.$ml.get(
              "alerts.confirmedOvertimeCannotBeGreaterThanCalculated"
            )
          );
          return;
        }
        this.isLoadingPayrolls = true;
        const response = await this.$axios
          .post("/EmployeeDetails/CustomConfirmOvertime", {
            id: id,
            confirmedDate: confirmedDate,
            overtimeDescriptionId: this.selectedOTDescriptionId,
            overtimePlaceId: this.selectedOTPlaceId
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              this.isLoadingPayrolls = false;
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        this.getEmpPayrolls();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async customConfirmOverTime() {
      try {
        let id = this.selectedDailyPayrol.overTimeId;
        let calculatedDate =
          "1900-01-01T" + this.selectedDailyPayrol.calculatedOverTime + ":00";
        let confirmedDate =
          "1900-01-01T" +
          this.selectedDailyPayrol.confirmedOverTime.replace("Z", "");
        if (confirmedDate > calculatedDate) {
          alertify.warning(
            this.$ml.get(
              "alerts.confirmedOvertimeCannotBeGreaterThanCalculated"
            )
          );
          return;
        }
        this.isLoadingPayrolls = true;
        const response = await this.$axios
          .post("/EmployeeDetails/CustomConfirmOvertime", {
            id: id,
            confirmedDate: confirmedDate,
            overtimeDescriptionId: this.selectedOTDescriptionId,
            overtimePlaceId: this.selectedOTPlaceId
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              this.isLoadingPayrolls = false;
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        this.getEmpPayrolls();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async getDailyPayrollDetails(tarih, workGroup) {
      try {
        this.selectedDailyPayrol.date = "";
        this.selectedDailyPayrol.movements = [];
        this.selectedDailyPayrol.workGroup = "";
        this.selectedDailyPayrol.payrolls = [];
        this.selectedDailyPayrol.calculatedOverTime = "00:00";
        this.selectedDailyPayrol.confirmedOverTime = "00:00";
        this.selectedDailyPayrol.overTimeId = null;
        this.selectedDailyPayrol.date = tarih;
        this.selectedDailyPayrol.workGroup = workGroup;
        var docc = tarih.split(".");
        this.inOut2.inOutAdd =
          docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
        let empId = this.employee.id;
        const response = await this.$axios
          .post("/EmployeeDetails/GetDailyPayrollDetails", {
            date: tarih,
            empId: empId
          })
          .then(response => {
            if (response.status == 200) {
              if (response.data.overtimes) {
                this.selectedDailyPayrol.calculatedOverTime =
                  response.data.overtimes.calculated;
                this.selectedDailyPayrol.confirmedOverTime =
                  response.data.overtimes.confirmed;
                this.selectedDailyPayrol.confirmedOverTime = response.data
                  .overtimes.confirmed
                  ? this.toDateFormat(
                    response.data.overtimes.confirmed,
                    "ss:dd"
                  )
                  : "";
                this.selectedDailyPayrol.overTimeId =
                  response.data.overtimes.overTimeId;
              }
              response.data.movements.forEach(doc => {
                this.selectedDailyPayrol.movements.push({
                  id: doc.id,
                  unFormattedDate: doc.unFormattedDate,
                  readerId: doc.readerId,
                  inOrOut: doc.inOrOut,
                  date: doc.date,
                  status: doc.status
                });
              });
              response.data.payrolls.forEach(doc => {
                this.selectedDailyPayrol.payrolls.push({
                  time: doc.time,
                  payroll: doc.payroll
                });
              });
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    selectNode() {
      this.isLoading = true;
      let node = document.getElementById("selectedNode").value;
      var depId = this.getDepartmentFromName(node);
      if (depId) {
        this.employee.departmentId = depId;
      }
      //$("#select-department").modal("hide");
      this.isLoading = false;
    },
    getDepartmentFromName(name) {
      let aList = this.departments;
      let dep = aList.filter(function (department) {
        return department.name == name;
      });
      if (dep != "" && dep != null) {
        return dep[0].id;
      } else {
        return null;
      }
    },
    async setTree() {
      let activeUser = await this.$store.getters.getUser;
      let departments = this.departments;
      var root = new TreeNode(
        activeUser.companyName + " (" + this.$ml.get("shared.company") + ")"
      );
      await departments.forEach(doc => {
        if (doc.mainDepartmentId == null) {
          var node = new TreeNode(doc.name);
          root.addChild(node);
          this.addChildDep(node, doc.id);
        }
      });
      var tree = new TreeView(root, "#treeview", {
        leaf_icon: "<i class='fa fa-star'></i>",
        parent_icon: "<i class='fa fa-sitemap'></i>",
        open_icon: "<i class='fa fa-chevron-down'></i>",
        close_icon: "<i class='fa fa-chevron-right'></i>"
      });
    },
    async addChildDep(Tnode, mainDep) {
      let departments = this.departments;
      await departments.forEach(doc => {
        if (doc.mainDepartmentId == mainDep) {
          var node = new TreeNode(doc.name);
          Tnode.addChild(node);
          this.addChildDep(node, doc.id);
        }
      });
    },
    getChildDep(dep) {
      let DepartmentList = this.departments;
      return DepartmentList.filter(function (department) {
        return department.id == dep.mainDepartmentId;
      });
    },
    getMainFind(id) {
      let DepartmentList = this.departments;
      let department = DepartmentList.filter(function (department) {
        return department.id == id;
      });
    },
    getAccessGroupFromId(id) {
      let aList = this.accessGroups;
      let dep = aList.filter(function (accessGroups) {
        return accessGroups.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    async checkListFromAccessGroup(id) {
      let accessGroup = this.getAccessGroupFromId(id);
      let aa = this.readers;
      await aa.forEach(dd => {
        dd.check = false;
      });
      accessGroup.selectedReaders.forEach(secilenReader => {
        this.readers.forEach(doc => {
          if (doc.readerId == secilenReader.id) {
            doc.check = true;
          }
        });
      });
    },
    async getCheckReaderList() {
      let aList = this.readers;
      this.employee.readers = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.employee.readers.push(doc.readerId);
        }
      });
    },
    async setCheckReaderList() {
      let aa = this.readers;
      await aa.forEach(dd => {
        dd.check = false;
      });
      let aList = this.employee.readers;
      await aList.forEach(secilenReader => {
        this.readers.forEach(doc => {
          if (doc.readerId == secilenReader) {
            doc.check = true;
          }
        });
      });
    },
    async getVisitorCardGroups() {
      try {
        const cardGroups = [];
        const response = await this.$axios
          .get("/Visitors/GetVisitorsCardGroup")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                cardGroups.push({
                  id: doc.id,
                  name: doc.name,
                  devices: doc.devices
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.visitorCardGroups = cardGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
      }
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.setTree();
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                status: doc.status,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                shortCode: doc.shortCode,
                isPeriod: doc.isPeriod,
                model: doc.model,
                isCheck: false
              });
              workGroups.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 0;
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    newExtraField() {
      this.isNewExtraField = true;
      this.extraFieldId = null;
      this.extraFieldKey = "";
      this.extraFieldValue = "";
    },
    selectExtraField(id, value, key) {
      if (id == 0) {
        this.newExtraField();
        this.extraFieldKey = key;
      } else {
        this.extraFieldId = id;
        this.extraFieldValue = value;
        this.extraFieldKey = key;
        this.isNewExtraField = false;
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFieldsForEmployee() {
      try {
        let id = this.employee.id;
        const extrafields = [];
        const response = await this.$axios
          .get("/Employees/getExtraFields/" + id)
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                key: doc.key,
                value: doc.value
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.employee.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async deleteExtraField(id) {
      try {
        if (id != 0) {
          const response = await this.$axios
            .delete("/Employees/DeleteExtraField/" + id)
            .then(response => {
              this.getExtraFieldsForEmployee();
              this.newExtraField();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    async saveExtraField() {
      if (this.isNewExtraField) {
        try {
          let extraFieldValue2 = this.extraFieldValue;
          let extraFieldKey2 = this.extraFieldKey;
          let empId = this.employee.id;
          const response = await this.$axios
            .post("/Employees/AddExtraField", {
              key: extraFieldKey2,
              value: extraFieldValue2,
              empId: empId
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                this.getExtraFieldsForEmployee();
                this.newExtraField();
              } else {
                alertify.error(response.message);
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
        }
      } else {
        //GÜNCELLE
        try {
          let extraFieldValue2 = this.extraFieldValue;
          let extraFieldKey2 = this.extraFieldKey;
          let extraFieldId2 = this.extraFieldId;
          let empId = this.employee.id;
          const response = await this.$axios
            .post("/Employees/UpdateExtraField/" + extraFieldId2, {
              key: extraFieldKey2,
              value: extraFieldValue2,
              empId: empId
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                this.getExtraFieldsForEmployee();
                this.newExtraField();
              } else {
                alertify.error(response.message);
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        } catch (error) {
          console.error(error);
          alertify.error(error);
        }
      }
    },
    async getSalaryForEmployee() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      try {
        this.isLoadingSalary = true;
        var salaries = [];
        let selectedUser = this.employee.id;
        const response = await this.$axios
          .get("/Employees/SalariesByEmployeeId/" + selectedUser)
          .then(response => {
            salaries = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.salaries = salaries;
        this.isLoadingSalary = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingSalary = false;
      }
    },
    async getWorkPlaceForEmployee() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      try {
        this.isLoadingWorkPlace = true;
        var workPlaces = [];
        let selectedUser = this.employee.id;
        const response = await this.$axios
          .get("/EmployeeWorkPlace/GetByEmployeeId/" + selectedUser)
          .then(response => {
            workPlaces = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workPlaces = workPlaces;
        this.isLoadingWorkPlace = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingWorkPlace = false;
      }
    },
    async getPaymentForEmployee() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      if (
        (this.payment.searchStartDate == null) |
        (this.payment.searchEndDate == null)
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingPayment = true;
        const payments = [];
        let selectedUser = this.employee.id;
        var startDate = this.payment.searchStartDate;
        var endDate = this.payment.searchEndDate;
        const response = await this.$axios
          .post("/EmployeeDetails/getSalaries", {
            id: selectedUser,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              payments.push({
                id: doc.id,
                salaryId: doc.salaryId,
                salaryName: doc.salaryName,
                price: doc.price,
                date: doc.date,
                status: doc.status
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.employee.payments = payments;
        this.isLoadingPayment = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingPayment = false;
      }
    },
    changeWorkPlaceForEmployee(event) {
      this.workPlace.workplaceId = event.target.value;
    },
    newWorkPlace() {
      this.isNewWorkPlace = true;
      this.workPlace.id = null;
      this.workPlace.workplaceId = null;
      this.workPlace.description = "";
      this.workPlace.startDate = null;
      this.workPlace.endDate = null;
    },
    async selectWorkPlace(workPlace) {
      this.isNewWorkPlace = false;
      this.workPlace.id = workPlace.id;
      this.workPlace.workplaceId = workPlace.workplaceId;
      this.workPlace.description = workPlace.description;
      this.workPlace.startDate = this.toDateFormat(workPlace.startDate, "gg.aa.yyyy");
      this.workPlace.endDate = this.toDateFormat(workPlace.endDate, "gg.aa.yyyy");
    },
    async deleteWorkPlace(id) {
      try {
        this.isLoadingWorkPlace = true;
        if (id != 0) {
          const response = await this.$axios.delete(
            "/EmployeeWorkPlace/" + id
          );
          this.getWorkPlaceForEmployee();
          this.newWorkPlace();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingWorkPlace = false;
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingWorkPlace = false;
      }
    },
    async addWorkPlace() {
      if (this.workPlace.startDate == null || this.workPlace.endDate == null) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingWorkPlace = true;
        let empId = this.employee.id;
        let workPlace = this.workPlace;
        const response = await this.$axios.post("/EmployeeWorkPlace", {
          employeeId: empId,
          workplaceId: workPlace.workplaceId,
          description: workPlace.description,
          startDate: workPlace.startDate + "T00:00",
          endDate: workPlace.endDate + "T23:59"
        });
        if (response.status == 200) {
          $("#modal-work-place").modal("hide");
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          this.isLoadingWorkPlace = false;
        } else {
          alertify.error(response.message);
          this.isLoadingWorkPlace = false;
        }
        this.getWorkPlaceForEmployee();
        this.isLoadingWorkPlace = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingWorkPlace = false;
      }
    },
    async updateWorkPlace() {
      if (this.workPlace.startDate == null || this.workPlace.endDate == null) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingWorkPlace = true;
        let empId = this.employee.id;
        let workPlace = this.workPlace;
        const response = await this.$axios.put(
          "/EmployeeWorkPlace/" + workPlace.id,
          {
            employeeId: empId,
            workplaceId: workPlace.workplaceId,
            description: workPlace.description,
            startDate: workPlace.startDate + "T00:00",
            endDate: workPlace.endDate + "T23:59"
          }
        );
        if (response.status == 200) {
          $("#modal-work-place").modal("hide");
          alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          this.isLoadingWorkPlace = false;
        } else {
          alertify.error(response.message);
          this.isLoadingWorkPlace = false;
        }
        await this.getWorkPlaceForEmployee();
        this.isLoadingWorkPlace = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingWorkPlace = false;
      }
    },
    newSalary() {
      this.salary.id = null;
      this.salary.salary = 0;
      this.salary.updateTime = new Date();
    },
    async selectSalary(salary) {
      this.salary.id = salary.id;
      this.salary.salary = salary.salary;
      this.salary.updateTime = salary.updateTime;
    },
    async deleteSalary(id) {
      try {
        this.isLoadingSalary = true;
        if (id != 0) {
          const response = await this.$axios.delete(
            "/Employees/Salary/" + id
          );
          this.getSalaryForEmployee();
          this.newSalary();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingSalary = false;
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingSalary = false;
      }
    },
    async addSalary() {
      if (this.salary.updateTime == null) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if ($.isNumeric(this.salary.salary) == false || this.salary.salary == 0) {
        alertify.warning(this.$ml.get("alerts.invalidPrice"));
        return;
      }
      try {
        this.isLoadingSalary = true;
        let empId = this.employee.id;
        let salary = this.salary;
        const response = await this.$axios.post("/Employees/Salary", {
          employeeId: empId,
          salary: salary.salary,
          updateTime: salary.updateTime
        });
        if (response.status == 200) {
          $("#modal-salary").modal("hide");
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          this.isLoadingSalary = false;
        } else {
          alertify.error(response.message);
          this.isLoadingSalary = false;
        }
        this.getSalaryForEmployee();
        this.isLoadingSalary = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingSalary = false;
      }
    },
    async updateSalary() {
      if (this.salary.updateTime == null) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (!$.isNumeric(this.salary.salary) || this.salary.salary == 0) {
        alertify.warning(this.$ml.get("alerts.invalidPrice"));
        return;
      }
      try {
        this.isLoadingSalary = true;
        let empId = this.employee.id;
        let salary2 = this.salary;
        const response = await this.$axios.put(
          "/Employees/Salary/" + salary2.id,
          {
            employeeId: empId,
            salary: salary2.salary,
            updateTime: salary2.updateTime
          }
        );
        if (response.status == 200) {
          $("#modal-salary").modal("hide");
          alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          this.isLoadingSalary = false;
        } else {
          alertify.error(response.message);
          this.isLoadingSalary = false;
        }
        await this.getSalaryForEmployee();
        this.isLoadingSalary = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingSalary = false;
      }
    },
    newPayment() {
      this.isNewPayment = true;
      this.payment.id = null;
      this.payment.salaryId = null;
      this.payment.salaryName = "";
      this.payment.status = 1;
      this.payment.price = 0;
      this.payment.date = null;
    },
    async selectPayment(id) {
      this.isNewPayment = false;
      let aList = this.employee.payments;
      let log = aList.filter(function (doc) {
        return doc.id == id;
      });
      this.payment.id = id;
      this.payment.salaryId = log[0].salaryId;
      this.payment.salaryName = log[0].salaryName;
      this.payment.status = log[0].status;
      this.payment.price = log[0].price;
      this.payment.date = log[0].date;
    },
    async deletePayment(id) {
      try {
        this.isLoadingPayment = true;
        if (id != 0) {
          const response = await this.$axios.delete(
            "/EmployeeDetails/deletePayment/" + id
          );
          this.getPaymentForEmployee();
          this.newPayment();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingPayment = false;
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingPayment = false;
      }
    },
    async addPayment() {
      if (this.payment.date == null) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if ($.isNumeric(this.payment.price) == false || this.payment.price == 0) {
        alertify.warning(this.$ml.get("alerts.invalidPrice"));
        return;
      }
      if (this.payment.salaryId == 0 || this.payment.salaryId == null) {
        alertify.warning(this.$ml.get("alerts.invalidSalaryType"));
        return;
      }
      try {
        this.isLoadingPayment = true;
        let empId = this.employee.id;
        let payment2 = this.payment;
        const response = await this.$axios.post("/EmployeeDetails/AddSalary", {
          empId: empId,
          salaryId: payment2.salaryId,
          price: payment2.price,
          date: payment2.date
        });
        if (response.status == 200) {
          $("#modal-odeme-ekle").modal("hide");
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          this.isLoadingPayment = false;
        } else {
          alertify.error(response.message);
          this.isLoadingPayment = false;
        }
        this.getPaymentForEmployee();
        this.isLoadingPayment = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingPayment = false;
      }
    },
    async updatePayment() {
      if (this.payment.date == null) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (!$.isNumeric(this.payment.price) || this.payment.price == 0) {
        alertify.warning(this.$ml.get("alerts.invalidPrice"));
        return;
      }
      if (this.payment.salaryId == 0 || this.payment.salaryId == null) {
        alertify.warning(this.$ml.get("alerts.invalidSalaryType"));
        return;
      }
      try {
        this.isLoadingPayment = true;
        let empId = this.employee.id;
        let payment2 = this.payment;
        const response = await this.$axios.post(
          "/EmployeeDetails/UpdateSalary/",
          {
            id: payment2.id,
            empId: empId,
            salaryId: payment2.salaryId,
            price: payment2.price,
            date: payment2.date
          }
        );
        if (response.status == 200) {
          $("#modal-odeme-ekle").modal("hide");
          alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          this.isLoadingPayment = false;
        } else {
          alertify.error(response.message);
          this.isLoadingPayment = false;
        }
        await this.getPaymentForEmployee();
        this.isLoadingPayment = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingPayment = false;
      }
    },
    async batchDeleteAllowence() {
      if (
        this.startDateRemoveAllowence == null &&
        this.endDateRemoveAllowence == null &&
        this.startDateRemoveAllowence >= this.endDateRemoveAllowence
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingAllowence = true;
        const response = await this.$axios.post(
          "EmployeeDetails/BatchAllowenceDelete",
          {
            empId: this.employee.id,
            startDate: this.startDateRemoveAllowence,
            endDate: this.endDateRemoveAllowence
          }
        );
        this.getAllowenceForEmployee();
        this.newAllowence();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        $("#modal-izin-sil").modal("hide");
        this.isLoadingAllowence = false;
      } catch (error) {
        $("#modal-izin-sil").modal("hide");
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingAllowence = false;
      }
    },
    async getAllowenceForEmployee() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      if (
        (this.allowence.searchStartDate == null) |
        (this.allowence.searchEndDate == null)
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingAllowence = true;
        const allowences = [];
        let selectedUser = this.employee.id;
        var startDate = this.allowence.searchStartDate;
        var endDate = this.allowence.searchEndDate;
        const response = await this.$axios
          .post("/EmployeeDetails/GetAllowences", {
            id: selectedUser,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                startDate: doc.startDate,
                endDate: doc.endDate,
                allowenceId: doc.allowenceId,
                description: doc.description,
                shortCode: doc.shortCode,
                name: doc.name,
                r: doc.r,
                g: doc.g,
                b: doc.b
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.employee.allowences = allowences;
        this.isLoadingAllowence = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingAllowence = false;
      }
    },
    newAllowence() {
      this.isNewAllowence = true;
      this.allowence.id = null;
      if (this.allowenceList[0]) {
        this.allowence.allowenceId = this.allowenceList[0].id;
      }
      this.allowence.description = "";
      this.allowence.allowenceType = 0;
      this.allowence.holidayPass = false;
      this.allowence.allowenceTime = "00:00";
      this.allowence.missingTime = "00:00";
      this.allowence.equalTheMissingTime = true;
    },
    async selectAllowence(id) {
      this.isNewAllowence = false;
      let aList = this.employee.allowences;
      let log = aList.filter(function (doc) {
        return doc.id == id;
      });
      this.allowence.id = id;
      this.allowence.allowenceId = log[0].allowenceId;
      this.allowence.startDate = log[0].startDate;
      this.allowence.endDate = log[0].endDate;
      this.allowence.description = log[0].description;
    },
    async deleteAllowence(id) {
      try {
        this.isLoadingAllowence = true;
        if (id != 0) {
          const response = await this.$axios.delete(
            "/EmployeeDetails/DeleteAllowence/" + id
          );
          this.getAllowenceForEmployee();
          this.newAllowence();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingAllowence = false;
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingAllowence = false;
      }
    },
    async addAllowence() {
      if ((this.allowence.startDate == "") | this.allowence.endDate) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (!this.allowence.allowenceId) {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
        return;
      }
      try {
        this.isLoadingAllowence = true;
        let days = await this.selectedDays();
        let empIds = [this.employee.id];
        let allowence2 = this.allowence;
        const response = await this.$axios.post(
          "/BatchOperations/BatchAllowence",
          {
            empIds: empIds,
            days: days,
            allowenceId: allowence2.allowenceId,
            description: allowence2.description,
            holidayPass: allowence2.holidayPass,
            startDate: allowence2.startDate,
            endDate: allowence2.endDate,
            allowenceType: allowence2.allowenceType,
            allowenceTime: allowence2.allowenceTime,
            equalTheMissingTime: allowence2.equalTheMissingTime,
            missingTime: allowence2.missingTime
          }
        );
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        this.getAllowenceForEmployee();
        this.isLoadingAllowence = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingAllowence = false;
      }
    },
    async updateAllowence() {
      if ((this.allowence.startDate == "") | (this.allowence.endDate == "")) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (!this.allowence.allowenceId) {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
        return;
      }
      try {
        this.isLoadingAllowence = true;
        let empId = this.employee.id;
        let allowence2 = this.allowence;
        const response = await this.$axios.post(
          "/EmployeeDetails/UpdateAllowence/" + allowence2.id,
          {
            isActive: true,
            startDate: allowence2.startDate,
            endDate: allowence2.endDate,
            allowenceId: allowence2.allowenceId,
            description: allowence2.description,
            empId: empId
          }
        );
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        await this.getAllowenceForEmployee();
        this.isLoadingAllowence = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingAllowence = false;
      }
    },
    async getInOuts() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      if (
        this.inOut.inOutStartDate == null ||
        this.inOut.inOutEndDate == null ||
        this.inOut.inOutStartDate > this.inOut.inOutEndDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingInOuts = true;
        const inOuts = [];
        let selectedUser = this.employee.id;
        var startDate = this.inOut.inOutStartDate;
        var endDate = this.inOut.inOutEndDate;
        const response = await this.$axios
          .post("/EmployeeDetails/GetEntryExit", {
            id: selectedUser,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              inOuts.push({
                id: doc.id,
                date: doc.date,
                readerName: doc.readerName,
                readerId: doc.readerId,
                doorType: doc.doorType,
                inOrOut: doc.inOrOut,
                positionX: doc.positionX,
                positionY: doc.positionY,
                isActive: doc.isActive
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
        this.employee.inOuts = inOuts;
        this.isLoadingInOuts = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingInOuts = false;
      }
    },
    newInOut() {
      this.isNewInOut = true;
      this.inOut.inOutId = null;
      this.inOut.readerId = "";
      this.inOut.inOutType = 0;
      this.inOut.positionX = "";
      this.inOut.positionY = "";
      this.selectedDoorTypeMovement = 0;
      this.inOut.inOutAdd = "";
    },
    async selectInOut(id) {
      this.isNewInOut = false;
      let aList = this.employee.inOuts;
      let log = aList.filter(function (doc) {
        return doc.id == id;
      });
      this.inOut.inOutId = id;
      this.inOut.inOutType = log[0].inOrOut;
      this.selectedDoorTypeMovement = log[0].inOrOut;
      this.inOut.inOutAdd = log[0].date;
      this.inOut.positionX = log[0].positionX.replace(",", ".");
      this.inOut.positionY = log[0].positionY.replace(",", ".");
      this.inOut.readerId = log[0].readerId;
    },
    async deleteInOut(id) {
      try {
        if (id != 0) {
          const response = await this.$axios
            .delete("/EmployeeDetails/DeleteEntryExit/" + id)
            .then(response => {
              this.getInOuts();
              this.newInOut();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              }
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingInOuts = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingInOuts = false;
                return;
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    async addInOut() {
      if (this.inOut.inOutAdd == "") {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (this.inOut.readerId == "" || this.inOut.readerId == 0) {
        alertify.warning(this.$ml.get("alerts.notSelectedReader"));
        return;
      }
      var date = new Date(this.inOut.inOutAdd);
      var today = new Date();
      if (date > today) {
        alertify.warning(
          this.$ml.get("alerts.cannotCreateMovementInTheFuture")
        );
        return;
      }
      try {
        let empId = this.employee.id;
        let inOurOut = this.inOut.inOutType;
        let inOutAdd = this.inOut.inOutAdd;
        let readerId = this.inOut.readerId;
        const response = await this.$axios
          .post("/EmployeeDetails/AddEntryExit", {
            isActive: true,
            inOrOut: inOurOut,
            date: inOutAdd,
            readerId: readerId,
            includePassiveMovements: this.includePassiveMovements,
            doNotDeleteOvertimes: this.doNotDeleteOvertimes,
            empId: empId
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else if (response.status == 201) {
          alertify.error(this.$ml.get("alerts.checkTheMealTime"));
        } else {
          alertify.error(response.message);
        }
        this.getInOuts();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async updateInOut() {
      if (this.inOut.inOutAdd == "") {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (this.inOut.readerId == "" || this.inOut.readerId == 0) {
        alertify.warning(this.$ml.get("alerts.notSelectedReader"));
        return;
      }
      var date = new Date(this.inOut.inOutAdd);
      var today = new Date();
      if (date > today) {
        alertify.warning(
          this.$ml.get("alerts.cannotCreateMovementInTheFuture")
        );
        return;
      }
      try {
        let empId = this.employee.id;
        let inOurOut = this.inOut.inOutType;
        let inOutAdd = this.inOut.inOutAdd;
        let readerId = this.inOut.readerId;
        const response = await this.$axios.post(
          "/EmployeeDetails/UpdateEntryExit/" + this.inOut.inOutId,
          {
            isActive: true,
            inOrOut: inOurOut,
            date: inOutAdd,
            empId: empId,
            includePassiveMovements: this.includePassiveMovements,
            doNotDeleteOvertimes: this.doNotDeleteOvertimes,
            readerId: readerId
          }
        );
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        this.getInOuts();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async addInOut2() {
      if (this.inOut2.inOutAdd == "") {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (this.inOut2.readerId == "" || this.inOut2.readerId == 0) {
        alertify.warning(this.$ml.get("alerts.notSelectedReader"));
        return;
      }
      var date = new Date(this.inOut2.inOutAdd);
      var today = new Date();
      if (date > today) {
        alertify.warning(
          this.$ml.get("alerts.cannotCreateMovementInTheFuture")
        );
        return;
      }
      try {
        let empId = this.employee.id;
        let inOurOut = this.inOut2.inOutType;
        let inOutAdd = this.inOut2.inOutAdd;
        let readerId = this.inOut2.readerId;
        const response = await this.$axios
          .post("/EmployeeDetails/AddEntryExit", {
            isActive: true,
            inOrOut: inOurOut,
            date: inOutAdd,
            readerId: readerId,
            includePassiveMovements: this.includePassiveMovements,
            doNotDeleteOvertimes: this.doNotDeleteOvertimes,
            empId: empId
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        this.getDailyPayrollDetails(
          this.selectedDailyPayrol.date,
          this.selectedDailyPayrol.workGroup
        );
        this.getEmpPayrolls();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async updateInOut2() {
      if (this.inOut2.inOutAdd == "") {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (this.inOut2.readerId == "" || this.inOut2.readerId == 0) {
        alertify.warning(this.$ml.get("alerts.notSelectedReader"));
        return;
      }
      var date = new Date(this.inOut2.inOutAdd);
      var today = new Date();
      if (date > today) {
        alertify.warning(
          this.$ml.get("alerts.cannotCreateMovementInTheFuture")
        );
        return;
      }
      try {
        let empId = this.employee.id;
        let inOurOut = this.inOut2.inOutType;
        let inOutAdd = this.inOut2.inOutAdd;
        let readerId = this.inOut2.readerId;
        const response = await this.$axios.post(
          "/EmployeeDetails/UpdateEntryExit/" + this.inOut2.inOutId,
          {
            isActive: true,
            inOrOut: inOurOut,
            date: inOutAdd,
            empId: empId,
            readerId: readerId
          }
        );
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        this.getDailyPayrollDetails(
          this.selectedDailyPayrol.date,
          this.selectedDailyPayrol.workGroup
        );
        this.getEmpPayrolls();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async deleteInOut2(id) {
      try {
        if (id != 0) {
          const response = await this.$axios
            .delete("/EmployeeDetails/DeleteEntryExit/" + id)
            .then(response => {
              this.getInOuts();
              this.newInOut();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              }
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingInOuts = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingInOuts = false;
                return;
              }
            });
          this.getDailyPayrollDetails(
            this.selectedDailyPayrol.date,
            this.selectedDailyPayrol.workGroup
          );
          this.getEmpPayrolls();
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    async newEmployee() {
      this.isLoading = true;
      this.isNewEmployee = true;
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      this.employee.startDate = yil + "-" + ay + "-" + gun;
      this.employee.endDate = null;
      this.imageData = null;
      this.tempUrl = null;
      this.selectedFoodType = 1;
      this.selectedFoodCount = 0;
      this.isNewState = true;
      this.selectedStateId = null;
      this.selectedStateName = "";
      this.isNewStatu = true;
      this.selectedStatuId = null;
      this.selectedStatuName = "";
      this.searchPayrollStartDate = null;
      this.searchPayrollEndDate = null;
      this.selectAP = 1;
      this.employee.id = null;
      this.employee.sicilNo = "";
      this.employee.image = null;
      this.employee.name = "";
      this.employee.departmentId = null;
      this.employee.title = "";
      this.employee.identityNo = "";
      this.employee.stateId = 1;
      this.employee.stateNote = "";
      this.employee.terminalNo = null;
      this.employee.statuId = null;
      this.employee.cardNo = "";
      this.employee.terminalStatu = 0;
      this.employee.terminalPassword = "";
      this.employee.plateNo = "";
      this.employee.hgsNo = "";
      this.employee.tzCode = "";
      this.employee.workGroupId = null;
      this.employee.documentNo = "";
      this.employee.overWorkStatus = true;
      this.employee.mail = "";
      this.employee.mobilePhone = "";
      this.employee.birthDayDate = null;
      this.employee.validityStartDate = null;
      this.employee.validityEndDate = null;
      this.employee.address = "";
      this.employee.internalPhone = "";
      this.employee.homePhone = "";
      this.employee.gender = null;
      this.employee.educationStatus = null;
      this.employee.militaryStatus = null;
      this.employee.drivingLicence = "";
      this.employee.smokeStatus = null;
      this.employee.maritalStatus = null;
      this.employee.bloodType = "";
      this.employee.height = null;
      this.employee.weight = null;
      this.employee.disabledPercent = "";
      this.employee.authorizedPerson1 = null;
      this.employee.authorizedPerson2 = null;
      this.employee.note1 = "";
      this.employee.note2 = "";
      this.employee.foreignLanguage = "";
      this.employee.accessGroupId = null;
      this.employee.readers = [];
      this.employee.foodGroupId = null;
      this.employee.credit = 0;
      this.employee.remainder = "0";
      this.employee.isVisitor = false;
      this.employee.visitorCardGroupId = null;
      this.employee.isActive = true;
      this.employee.annualPermitId = 0;
      this.employee.annualPermitSeniority = 0;
      this.employee.annualPermitTransfer = 0;
      this.employee.annualPermitClaim = 0;
      this.employee.annualPermitUsed = 0;
      this.employee.annualPermitRemain = 0;
      this.employee.annualPermits = [];
      this.employee.annualPermitClaimsDates = [];
      this.employee.extrafields = [];
      this.employee.inOuts = [];
      this.employee.allowences = [];
      this.employee.logs = [];
      this.employee.hasCard = false;
      this.employee.hasFace = false;
      this.employee.hasFinger = false;
      this.employee.hasPassword = false;
      this.employee.roomId = 0;
      this.employee.roomName = "";
      this.employee.areaName = "";
      this.employee.floorName = "";
      this.employee.fingerIndexes = [];
      this.employee.isSmsSend = false;
      this.employee.parentPhone = null;
      this.employee.isStudent = false;
      this.employee.isStayInDormitory = false;
      this.employee.motherName = "";
      this.employee.motherPhone = "";
      this.employee.fatherName = "";
      this.employee.fatherPhone = "";
      this.employee.isMobileUser = false;
      this.employee.mobilePassword = "";
      this.employee.foodClaim = false;
      await this.getNewSicilveTerminalNo();
      let aa = this.readers;
      await aa.forEach(dd => {
        dd.check = false;
      });
      this.isLoading = false;
    },
    async deleteEmployee() {
      try {
        this.isLoading = true;
        let id = this.employee.id;
        const response = await this.$axios.delete("/Employees/" + id);
        this.getEmployees();
        this.newEmployee();
        alertify.success(response.data.message);
        this.isLoading = false;
      } catch (error) {
        alertify.error(error);
        this.isLoading = false;
      }
    },
    async saveEmployee() {
      if (this.employee.sicilNo == "") {
        alertify.warning(
          this.$ml.get("alerts.employeeRegistrationNumberNotBlank")
        );
        return;
      }
      if (this.employee.name == "") {
        alertify.warning(this.$ml.get("alerts.employeeNameNotBlank"));
        return;
      }
      if (this.employee.terminalNo == "") {
        alertify.warning(this.$ml.get("alerts.employeeDeviceNoNotBlank"));
        return;
      }
      if (this.employee.departmentId == "" || this.employee.departmentId == null) {
        alertify.warning(this.$ml.get("alerts.employeeDepartmentNotBlank"));
        return;
      }
      if (this.employee.startDate == "" || this.employee.startDate == null) {
        alertify.warning(this.$ml.get("alerts.employeeStartDateNotBlank"));
        return;
      }
      if (this.requiredFields.includes("title") && (this.employee.title == "" || this.employee.title == null)) {
        alertify.warning(this.$ml.get("alerts.employeeTitleNotBlank"));
        return;
      }
      if (this.requiredFields.includes("identityNo") && (this.employee.identityNo == "" || this.employee.identityNo == null)) {
        alertify.warning(this.$ml.get("alerts.employeeIdentityNoNotBlank"));
        return;
      }
      if (this.requiredFields.includes("endDate") && (this.employee.endDate == "" || this.employee.endDate == null)) {
        alertify.warning(this.$ml.get("alerts.employeeEndDateNotBlank"));
        return;
      }
      if (this.requiredFields.includes("workGroupId") && (this.employee.workGroupId == "" || this.employee.workGroupId == null)) {
        alertify.warning(this.$ml.get("alerts.employeeWorkGroupIdNotBlank"));
        return;
      }
      if (this.requiredFields.includes("stateId") && (this.employee.stateId == "" || this.employee.stateId == null)) {
        alertify.warning(this.$ml.get("alerts.employeeStateIdNotBlank"));
        return;
      }
      if (this.requiredFields.includes("stateNote") && (this.employee.stateNote == "" || this.employee.stateNote == null)) {
        alertify.warning(this.$ml.get("alerts.employeeStateNoteNotBlank"));
        return;
      }
      if (this.requiredFields.includes("statuId") && (this.employee.statuId == "" || this.employee.statuId == null)) {
        alertify.warning(this.$ml.get("alerts.employeeStatuIdNotBlank"));
        return;
      }
      if (this.requiredFields.includes("cardNo") && (this.employee.cardNo == "" || this.employee.cardNo == null)) {
        alertify.warning(this.$ml.get("alerts.employeeCardNoNotBlank"));
        return;
      }
      if (this.requiredFields.includes("terminalStatu") && (this.employee.terminalStatu == "" || this.employee.terminalStatu == null)) {
        alertify.warning(this.$ml.get("alerts.employeeTerminalStatuNotBlank"));
        return;
      }
      if (this.requiredFields.includes("terminalPassword") && (this.employee.terminalPassword == "" || this.employee.terminalPassword == null)) {
        alertify.warning(this.$ml.get("alerts.employeeTerminalPasswordNotBlank"));
        return;
      }
      if (this.requiredFields.includes("tzCode") && (this.employee.tzCode == "" || this.employee.tzCode == null)) {
        alertify.warning(this.$ml.get("alerts.employeeTzCodeNotBlank"));
        return;
      }
      if (this.requiredFields.includes("plateNo") && (this.employee.plateNo == "" || this.employee.plateNo == null)) {
        alertify.warning(this.$ml.get("alerts.employeePlateNoNotBlank"));
        return;
      }
      if (this.requiredFields.includes("hgsNo") && (this.employee.hgsNo == "" || this.employee.hgsNo == null)) {
        alertify.warning(this.$ml.get("alerts.employeeHgsNoNotBlank"));
        return;
      }
      if (this.requiredFields.includes("documentNo") && (this.employee.documentNo == "" || this.employee.documentNo == null)) {
        alertify.warning(this.$ml.get("alerts.employeeDocumentNoNotBlank"));
        return;
      }
      this.isLoading = true;
      await this.getCheckReaderList();
      if (this.isNewEmployee) {
        try {
          let employee2 = this.employee;
          var id = 0;
          let image = this.imageData;
          const response = await this.$axios
            .post("/Employees", {
              sicilNo: employee2.sicilNo,
              name: employee2.name,
              departmentId: employee2.departmentId,
              title: employee2.title,
              identityNo: employee2.identityNo,
              startDate: employee2.startDate,
              endDate: employee2.endDate,
              stateId: employee2.stateId,
              stateNote: employee2.stateNote,
              terminalNo: employee2.terminalNo,
              statuId: employee2.statuId,
              cardNo: employee2.cardNo,
              terminalStatu: employee2.terminalStatu,
              terminalPassword: employee2.terminalPassword,
              plateNo: employee2.plateNo,
              hgsNo: employee2.hgsNo,
              tzCode: employee2.tzCode,
              workGroupId: employee2.workGroupId,
              documentNo: employee2.documentNo,
              overWorkStatus: employee2.overWorkStatus,
              mail: employee2.mail,
              address: employee2.address,
              mobilePhone: employee2.mobilePhone,
              birthDayDate: employee2.birthDayDate,
              internalPhone: employee2.internalPhone,
              homePhone: employee2.homePhone,
              gender: employee2.gender,
              educationStatus: employee2.educationStatus,
              militaryStatus: employee2.militaryStatus,
              drivingLicence: employee2.drivingLicence,
              smokeStatus: employee2.smokeStatus,
              maritalStatus: employee2.maritalStatus,
              bloodType: employee2.bloodType,
              height: employee2.height,
              weight: employee2.weight,
              disabledPercent: employee2.disabledPercent,
              authorizedPerson1: employee2.authorizedPerson1,
              authorizedPerson2: employee2.authorizedPerson2,
              note1: employee2.note1,
              note2: employee2.note2,
              foreignLanguage: employee2.foreignLanguage,
              accessGroupId: parseInt(employee2.accessGroupId),
              readers: employee2.readers,
              foodGroupId: employee2.foodGroupId,
              credit: employee2.credit,
              remainder: employee2.remainder,
              isVisitor: employee2.isVisitor,
              visitorCardGroupId: employee2.visitorCardGroupId,
              annualPermitId: employee2.annualPermitId,
              annualPermitSeniority: employee2.annualPermitSeniority,
              annualPermitTransfer: employee2.annualPermitTransfer,
              validityStartDate: employee2.validityStartDate,
              validityEndDate: employee2.validityEndDate,
              parentPhone: employee2.parentPhone,
              isSmsSend: employee2.isSmsSend,
              isStudent: employee2.isStudent,
              isStayInDormitory: employee2.isStayInDormitory,
              motherName: employee2.motherName,
              motherPhone: employee2.motherPhone,
              fatherName: employee2.fatherName,
              fatherPhone: employee2.fatherPhone,
              isMobileUser: employee2.isMobileUser,
              mobilePassword: employee2.mobilePassword,
              foodClaim: employee2.foodClaim
            })
            .then(result => {
              if (result.data.id) {
                id = result.data.id;
                if (this.imageData) {
                  const formData = new FormData();
                  formData.append("file", image);
                  const responseImage = this.$axios
                    .post("/Employees/AddEmployeePhoto/" + id, formData)
                    .then(result2 => {
                      alertify.success(
                        this.$ml.get("alerts.savedSuccessfully")
                      );
                      this.getEmployees();
                      this.getEmployee(id);
                      this.isNewEmployee = false;
                      this.isLoading = false;
                    });
                } else {
                  alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                  this.getEmployees();
                  this.getEmployee(id);
                  this.isNewEmployee = false;
                  this.isLoading = false;
                }
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                  return;
                } else if (error.response.status == 400) {
                  console.log(error.response.data.message);
                  alertify.error(error.response.data.message);
                  return;
                }
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingInOuts = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingInOuts = false;
                  return;
                }
              }
            });
          /*id = response.data.id;
          if (id != 0) {
            if (this.imageData) {
              const formData = new FormData();
              formData.append("file", image);
              if (this.imageData != null) {
                const responseImage = await this.$axios.post(
                  "/Employees/AddEmployeePhoto/" + id,
                  formData
                );
              }
            }
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            this.getEmployees();
            this.getEmployee(id);
            this.isNewEmployee = false;
            this.isLoading = false;
          } else {
            alertify.error(response.message);
            this.isLoading = false;
          }*/
        } catch (error) {
          this.isLoading = false;
          console.error(error);
          alertify.error(error);
        }
      } else {
        //GÜNCELLE
        try {
          let employee2 = this.employee;
          let id = employee2.id;
          let image = this.imageData;
          const response = await this.$axios
            .post("/Employees/" + employee2.id, {
              sicilNo: employee2.sicilNo,
              name: employee2.name,
              departmentId: employee2.departmentId,
              title: employee2.title,
              identityNo: employee2.identityNo,
              startDate: employee2.startDate,
              endDate: employee2.endDate,
              stateId: employee2.stateId,
              stateNote: employee2.stateNote,
              terminalNo: employee2.terminalNo,
              statuId: employee2.statuId,
              cardNo: employee2.cardNo,
              terminalStatu: employee2.terminalStatu,
              terminalPassword: employee2.terminalPassword,
              plateNo: employee2.plateNo,
              hgsNo: employee2.hgsNo,
              tzCode: employee2.tzCode,
              workGroupId: employee2.workGroupId,
              documentNo: employee2.documentNo,
              overWorkStatus: employee2.overWorkStatus,
              mail: employee2.mail,
              address: employee2.address,
              mobilePhone: employee2.mobilePhone,
              birthDayDate: employee2.birthDayDate,
              internalPhone: employee2.internalPhone,
              homePhone: employee2.homePhone,
              gender: employee2.gender,
              educationStatus: employee2.educationStatus,
              militaryStatus: employee2.militaryStatus,
              drivingLicence: employee2.drivingLicence,
              smokeStatus: employee2.smokeStatus,
              maritalStatus: employee2.maritalStatus,
              bloodType: employee2.bloodType,
              height: employee2.height,
              weight: employee2.weight,
              disabledPercent: employee2.disabledPercent,
              authorizedPerson1: employee2.authorizedPerson1,
              authorizedPerson2: employee2.authorizedPerson2,
              note1: employee2.note1,
              note2: employee2.note2,
              foreignLanguage: employee2.foreignLanguage,
              accessGroupId: parseInt(employee2.accessGroupId),
              readers: employee2.readers,
              foodGroupId: employee2.foodGroupId,
              credit: employee2.credit,
              remainder: employee2.remainder,
              isVisitor: employee2.isVisitor,
              visitorCardGroupId: employee2.visitorCardGroupId,
              annualPermitId: employee2.annualPermitId,
              annualPermitSeniority: employee2.annualPermitSeniority,
              annualPermitTransfer: employee2.annualPermitTransfer,
              validityStartDate: employee2.validityStartDate,
              validityEndDate: employee2.validityEndDate,
              parentPhone: employee2.parentPhone,
              isSmsSend: employee2.isSmsSend,
              isStudent: employee2.isStudent,
              isStayInDormitory: employee2.isStayInDormitory,
              motherName: employee2.motherName,
              motherPhone: employee2.motherPhone,
              fatherName: employee2.fatherName,
              fatherPhone: employee2.fatherPhone,
              isMobileUser: employee2.isMobileUser,
              mobilePassword: employee2.mobilePassword,
              foodClaim: employee2.foodClaim
            })
            .then(result => {
              if (result.data.id) {
                if (this.imageData) {
                  const formData = new FormData();
                  formData.append("file", image);
                  const responseImage = this.$axios
                    .post("/Employees/AddEmployeePhoto/" + id, formData)
                    .then(result => {
                      alertify.success(
                        this.$ml.get("alerts.updatedSuccessfully")
                      );
                      this.getEmployees();
                      this.getEmployee(id);
                      this.isLoading = false;
                    });
                } else if (this.employee.image == null) {
                  const responseImage = this.$axios
                    .patch("/Employees/RemovePhoto/" + id)
                    .then(result => {
                      alertify.success(
                        this.$ml.get("alerts.updatedSuccessfully")
                      );
                      this.getEmployees();
                      this.getEmployee(id);
                      this.isLoading = false;
                    });
                } else {
                  alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                  this.getEmployees();
                  this.getEmployee(id);
                  this.isLoading = false;
                }
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                  return;
                } else if (error.response.status == 400) {
                  console.log(error.response.data.message);
                  alertify.error(error.response.data.message);
                  return;
                }
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          /*if (id != null) {
            if (this.imageData) {
              const formData = new FormData();
              formData.append("file", image);
              const responseImage = await this.$axios
                .post("/Employees/AddEmployeePhoto/" + id, formData)
                .then(result => {
                  alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                });
            } else if (this.employee.image == null) {
              const responseImage = await this.$axios
                .patch("/Employees/RemovePhoto/" + id)
                .then(result => {
                  alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                });
            }
            this.getEmployees();
            this.getEmployee(id);
          } else {
            this.alertify.error(response.message);
          }*/
        } catch (error) {
          console.error(error);
          alertify.error(error);
        }
      }
      this.isLoading = false;
    },
    async getNewSicilveTerminalNo() {
      const response = await this.$axios
        .get("/Employees/GetDeviceAndSicilNumbers")
        .then(response => {
          this.employee.sicilNo = response.data.sicilNo;
          this.employee.terminalNo = response.data.terminalNo;
        })
        .catch(doc => {
          if (doc.status == 401) {
            this.$store.dispatch("logout");
          } else if (doc.message == "Network Error") {
            alertify.error(this.$ml.get("errors.connectionError"));
          } else {
            alertify.error(doc.message);
          }
        });
    },
    async setLeaveEmployee() {
      try {
        let employeeId = this.employee.id;
        var tarih = new Date();
        if (this.employee.endDate == "") {
          tarih = null;
        } else {
          tarih = new Date(this.employee.endDate);
        }
        const response = await this.$axios
          .post("/Employees/SetLeaveDate", {
            id: employeeId,
            date: tarih,
            state: this.employee.stateId
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
            this.getEmployees();
            this.getEmployee(employeeId);
            this.isNewEmployee = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    async removeLeaveEmployee() {
      try {
        let employeeId = this.employee.id;
        var tarih = new Date();
        if (this.employee.endDate == "") {
          tarih = null;
        } else {
          tarih = new Date(this.employee.endDate);
        }
        const response = await this.$axios
          .post("/Employees/RemoveLeaveDate", {
            id: employeeId
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
            this.getEmployees();
            this.newEmployee();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    async getFP() {
      try {
        await this.$axios
          .post("/USBFPDevice", {
            employeeId: this.employee.id,
            fpIndex: this.selectedFPIndex
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("alerts.getFingerprintFromUsbReader")
              );
              this.getEmployee(this.employee.id);
            } else {
              alertify.error(response.message);
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    async deleteFP() {
      try {
        await this.$axios
          .post("/USBFPDevice/DeleteFp", {
            employeeId: this.employee.id,
            fpIndex: this.selectedFPIndex
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
              this.getEmployee(this.employee.id);
            } else {
              alertify.error(response.message);
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    clearFP() {
      this.fpScreen = 0;
      this.selectedFPIndex = 0;
    },
    async GetOrDeleteFP(fpIndex) {
      this.selectedFPIndex = fpIndex;
      var durum = await this.getHasFinger(fpIndex);
      if (durum) {
        //parmak izi silinecek
        this.fpScreen = 2;
      } else {
        if (!this.selectedTerminal) {
          this.fpScreen = 1;
        } else {
          this.fpScreen = 0;
          this.SendGetFingerCommand(
            this.selectedTerminal,
            this.selectedFPIndex
          );
          $("#fingerPrintModal").modal("hide");
        }
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.inOut.inOutStartDate == null) {
        this.inOut.inOutStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.inOut.inOutEndDate == null) {
        this.inOut.inOutEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.payment.searchStartDate == null) {
        this.payment.searchStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.payment.searchEndDate == null) {
        this.payment.searchEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.allowence.searchStartDate == null) {
        this.allowence.searchStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.allowence.searchEndDate == null) {
        this.allowence.searchEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.allowence.startDate == null || this.allowence.startDate == "") {
        this.allowence.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.allowence.endDate == null) {
        this.allowence.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.searchPayrollStartDate == null) {
        this.searchPayrollStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.searchPayrollEndDate == null) {
        this.searchPayrollEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.logStartDate == null) {
        this.logStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.logEndDate == null) {
        this.logEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.startDateRemoveAllowence == null) {
        this.startDateRemoveAllowence = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDateRemoveAllowence == null) {
        this.endDateRemoveAllowence = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    async getEmployee(id) {
      try {
        this.getDefaultDate();
        this.isLoading = true;
        this.tempUrl = null;
        this.imageData = null;
        const response = await this.$axios
          .get("/Employees/" + id)
          .then(response => {
            this.isNewEmployee = false;
            this.employee.id = id;
            this.employee.sicilNo = response.data.sicilNo;
            this.employee.image = response.data.image;
            this.employee.name = response.data.name;
            this.employee.departmentId = response.data.departmentId;
            this.employee.title = response.data.title;
            this.employee.identityNo = response.data.identityNo;
            this.employee.startDate = this.toDateFormat(
              response.data.startDate,
              "gg.aa.yyyy"
            );
            this.employee.endDate = response.data.endDate
              ? this.toDateFormat(response.data.endDate, "gg.aa.yyyy")
              : null;
            this.employee.stateId = response.data.stateId;
            this.employee.stateNote = response.data.stateNote;
            this.employee.terminalNo = response.data.terminalNo;
            this.employee.statuId = response.data.statuId;
            this.employee.cardNo = response.data.cardNo;
            this.employee.terminalStatu = response.data.terminalStatu;
            this.employee.terminalPassword = response.data.terminalPassword;
            this.employee.plateNo = response.data.plateNo;
            this.employee.hgsNo = response.data.hgsNo;
            this.employee.tzCode = response.data.tzCode;
            this.employee.workGroupId = response.data.workGroupId;
            this.employee.documentNo = response.data.documentNo;
            this.employee.overWorkStatus = response.data.overWorkStatus;
            this.employee.mail = response.data.mail;
            this.employee.mobilePhone = response.data.mobilePhone;
            this.employee.birthDayDate = response.data.birthDayDate
              ? this.toDateFormat(response.data.birthDayDate, "gg.aa.yyyy")
              : null;
            this.employee.validityStartDate = response.data.validityStartDate
              ? this.toDateFormat(response.data.validityStartDate, "gg.aa.yyyy")
              : null;
            this.employee.validityEndDate = response.data.validityEndDate
              ? this.toDateFormat(response.data.validityEndDate, "gg.aa.yyyy")
              : null;
            this.employee.address = response.data.address;
            this.employee.internalPhone = response.data.internalPhone;
            this.employee.homePhone = response.data.homePhone;
            this.employee.gender = response.data.gender;
            this.employee.educationStatus = response.data.educationStatus;
            this.employee.militaryStatus = response.data.militaryStatus;
            this.employee.drivingLicence = response.data.drivingLicence;
            this.employee.smokeStatus = response.data.smokeStatus;
            this.employee.maritalStatus = response.data.maritalStatus;
            this.employee.bloodType = response.data.bloodType;
            this.employee.height = response.data.height;
            this.employee.weight = response.data.weight;
            this.employee.disabledPercent = response.data.disabledPercent;
            this.employee.authorizedPerson1 = response.data.authorizedPerson1;
            this.employee.authorizedPerson2 = response.data.authorizedPerson2;
            this.employee.note1 = response.data.note1;
            this.employee.note2 = response.data.note2;
            this.employee.foreignLanguage = response.data.foreignLanguage;
            this.employee.accessGroupId = response.data.accessGroupId;
            this.employee.readers = response.data.readers;
            this.employee.foodGroupId = response.data.foodGroupId;
            this.employee.credit = response.data.credit;
            this.employee.remainder = response.data.remainder;
            this.employee.isVisitor = response.data.isVisitor;
            this.employee.visitorCardGroupId = response.data.visitorCardGroupId;
            this.employee.isActive = response.data.isActive;
            this.employee.inOuts = [];
            this.employee.allowences = [];
            this.employee.logs = [];
            this.employee.extrafields = [];
            this.employee.empPayrolls = [];
            this.employee.annualPermitId = response.data.annualPermitId;
            this.employee.annualPermitClaim = response.data.annualPermitClaim;
            this.employee.annualPermitUsed = response.data.annualPermitUsed;
            this.employee.annualPermitRemain = response.data.annualPermitRemain;
            this.employee.annualPermits = response.data.annualPermits;
            this.employee.annualPermitClaimsDates =
              response.data.annualPermitClaimsDates;
            this.employee.annualPermitSeniority =
              response.data.annualPermitSeniority;
            this.employee.annualPermitTransfer =
              response.data.annualPermitTransfer;
            this.employee.hasCard = response.data.hasCard;
            this.employee.hasFace = response.data.hasFace;
            this.employee.hasFinger = response.data.hasFinger;
            this.employee.hasPassword = response.data.hasPassword;
            this.employee.isSmsSend = response.data.isSmsSend;
            this.employee.parentPhone = response.data.parentPhone;
            this.employee.isStudent = response.data.isStudent;
            this.employee.isStayInDormitory = response.data.isStayInDormitory;
            this.employee.motherName = response.data.motherName;
            this.employee.motherPhone = response.data.motherPhone;
            this.employee.fatherName = response.data.fatherName;
            this.employee.fatherPhone = response.data.fatherPhone;
            this.employee.roomId = response.data.roomId;
            this.employee.roomName = response.data.roomName;
            this.employee.areaName = response.data.areaName;
            this.employee.floorName = response.data.floorName;
            this.employee.fingerIndexes = response.data.fingerIndexes;
            this.employee.isMobileUser = response.data.isMobileUser;
            this.employee.mobilePassword = response.data.mobilePassword;
            this.employee.mobileBrand = response.data.mobileBrand;
            this.employee.mobileUuid = response.data.mobileUuid;
            this.employee.foodClaim = response.data.foodClaim;
            this.newAllowence();
            this.newInOut();
            this.newExtraField();
            this.clearFP();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        await this.getExtraFieldsForEmployee();
        await this.getWorkPlaceForEmployee();
        await this.getSalaryForEmployee();
        await this.setCheckReaderList();
        await this.getEmployeeInventories();
        await this.getDocuments(0);
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoading = false;
      }
    },
    async getAnnualPermits() {
      try {
        this.isLoading = true;
        const annualPermits = [];
        const response = await this.$axios
          .get("/AnnualPermit")
          .then(response => {
            response.data.forEach(doc => {
              annualPermits.push({
                id: doc.id,
                name: doc.name
              });
            });
            this.annualPermits = annualPermits;
            this.isLoading = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async clearFilterDepartments() {
      this.filters.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.filters.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.filters.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.filters.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.filters.workGroupId = [];
      await this.workGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.filters.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.filters.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.workGroupList;
      this.filters.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.filters.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.filters.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.filters.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.stateId.push(doc.id);
        }
      });
    },
    async getEmployeesFromCardNoFast(data) {
      if (data.length > 9 && $.isNumeric(data) == true) {
        await this.filtersClear();
        this.filters.nameOrCardNumber = data;
        this.filters.isActive = false;
        await this.getEmployees();
        this.searchText = "";
      } else {
        await this.filtersClear();
        this.filters.nameOrCardNumber = data;
        this.filters.isActive = false;
        await this.getEmployees();
      }
    },
    getEmployeesFromCardNo() {
      $("#modal-filtre").modal("hide");
      this.getEmployees();
    },
    async getEmployees() {
      try {
        this.isLoadingEmployee = true;
        await this.getCheckDepartmentList();
        const employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              employees.push({
                id: doc.id,
                name: doc.name,
                sicilNo: doc.sicilNo,
                title: doc.title
              });
            });
            this.filtersClear();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    changePayroll(empPayroll) {
      this.selectedChangePayroll.changeDate = empPayroll.date;
    },
    async setChangePayroll(newOperationId, isAllowence) {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      try {
        this.isLoadingPayrolls = true;
        let employeeId = this.employee.id;
        let selectedChangePayroll2 = this.selectedChangePayroll;
        const response = await this.$axios
          .post("/EmployeeDetails/ChangePayroll", {
            employeeId: employeeId,
            newOperationId: newOperationId,
            changeDate: selectedChangePayroll2.changeDate,
            isAllowence: isAllowence
          })
          .then(response => {
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            this.isLoadingPayrolls = false;
            this.getEmpPayrolls();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingPayrolls = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPayrolls = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingPayrolls = false;
      }
    },
    async getEmpPayrolls() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      if (
        this.searchPayrollStartDate == null ||
        this.searchPayrollEndDate == null ||
        this.searchPayrollStartDate > this.searchPayrollEndDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingPayrolls = true;
        const empPayrolls = [];
        let empId = this.employee.id;
        let startDate = this.searchPayrollStartDate;
        let endDate = this.searchPayrollEndDate;
        const response = await this.$axios
          .post("/EmployeeDetails/GetPayroll", {
            empId: empId,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              empPayrolls.push({
                overTimeId: doc.overTimeId,
                workPlan: doc.workPlan,
                calculatedOverTime: doc.calculatedOverTime,
                confirmedOverTime: doc.confirmedOverTime,
                firstEntry: doc.firstEntry,
                lastOut: doc.lastOut,
                date: doc.date,
                isAllowence: doc.isAllowence
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingPayrolls = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPayrolls = false;
                return;
              }
            }
          });
        this.employee.empPayrolls = empPayrolls;
        this.isLoadingPayrolls = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingPayrolls = false;
      }
    },
    async getCalculatePayrolls() {
      if (this.isNewEmployee && !this.employee.id) {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
      try {
        this.isLoadingPayrolls = true;
        var empId = parseInt(this.employee.id);
        let startDate = this.searchPayrollStartDate;
        let endDate = this.searchPayrollEndDate;
        const response = await this.$axios
          .post("/EmployeeDetails/CalculatePayroll", {
            empId: empId,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("alerts.payrollOfTheEmployeeWasRecalculated")
              );
              this.isLoadingPayrolls = false;
            } else {
              response.statusText + " - " + response.data.message;
              this.isLoadingPayrolls = false;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingPayrolls = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPayrolls = false;
                return;
              }
            }
          });
        await this.getEmpPayrolls();
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAllEmployees() {
      try {
        const allEmployees = [];
        const response = await this.$axios
          .get("/Employees")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                allEmployees.push({
                  id: doc.id,
                  name: doc.name,
                  title: doc.title,
                  isVisitor: doc.isVisitor
                });
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allEmployees = allEmployees;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getPaymentDefinitions() {
      try {
        const paymentDefinitions = [];
        const response = await this.$axios
          .get("/Salary")
          .then(response => {
            response.data.forEach(doc => {
              paymentDefinitions.push({
                id: doc.id,
                name: doc.name,
                status: doc.status
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.paymentDefinitions = paymentDefinitions;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkPlaceDefinitions() {
      try {
        const response = await this.$axios
          .get("/WorkPlaceDefinition/GetAll")
          .then(response => {
            this.workPlaceDefinitions = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getOvertimeDescriptions() {
      try {
        const overtimeDescriptions = [];
        const response = await this.$axios
          .get("/OvertimeDescription")
          .then(response => {
            response.data.forEach(doc => {
              overtimeDescriptions.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.overtimeDescriptions = overtimeDescriptions;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getOvertimePlaces() {
      try {
        const overtimePlaces = [];
        const response = await this.$axios
          .get("/OvertimePlaces")
          .then(response => {
            response.data.forEach(doc => {
              overtimePlaces.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.overtimePlaces = overtimePlaces;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAllowences() {
      try {
        const allowences = [];
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                monthlyPayrollId: doc.monthlyPayrollId,
                dailyPayrollId: doc.dailyPayrollId,
                dayTime: doc.dayTime,
                colorCode: doc.colorCode
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async deleteOverTime(id) {
      try {
        this.isLoadingPayrolls = true;
        const response = await this.$axios
          .delete("/EmployeeDetails/DeleteConfirmOvertime/" + id)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.confirmedOvertimeDeleted"));
            } else {
              response.statusText + " - " + response.data.message;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingPayrolls = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPayrolls = false;
                return;
              }
            }
          });
        await this.getEmpPayrolls();
        this.isLoadingPayrolls = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingPayrolls = false;
      }
    },
    setUserAuthorityFilter(filter) {
      filter.accessGroup
        ? (this.filters.accessGroup = filter.accessGroup)
        : (this.filters.accessGroup = []);
      filter.foodGroup
        ? (this.filters.foodGroup = filter.foodGroup)
        : (this.filters.foodGroup = []);
      filter.workGroupId
        ? (this.filters.workGroupId = filter.workGroupId)
        : (this.filters.workGroupId = []);
      filter.stateId
        ? (this.filters.stateId = filter.stateId)
        : (this.filters.stateId = []);
      filter.statuId
        ? (this.filters.statuId = filter.statuId)
        : (this.filters.statuId = []);
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        this.filters.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(doc => {
        this.filters.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.filters.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.filters.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.filters.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.filters.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    async getCardDesigns() {
      try {
        const cardDesigns = [];
        const response = await this.$axios
          .get("/CardDesign")
          .then(response => {
            response.data.forEach(doc => {
              cardDesigns.push({
                id: doc.id,
                name: doc.name,
                backgroundImage: doc.backgroundImage,
                backgroundColor: doc.backgroundColor,
                template: doc.template
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.cardDesigns = cardDesigns;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    getInventoryFromId(inventoryId) {
      let inventory = {
        name: "",
        categoryId: null,
        code: "",
        fields: [],
        id: null,
        photoUrl: null,
        serialNo: "",
        quantity: 0,
        assignedCount: 0
      };
      this.inventories.forEach(doc => {
        if (doc.id == inventoryId) {
          inventory = { ...doc };
        }
      });
      return inventory;
    },
    getInventoryCategoryName(categoryId) {
      let category = this.inventoryCategories.find(c => c.id === categoryId);
      return category ? category.name : "";
    },
    newInventory() {
      this.employeeInventory = {
        id: null,
        employeeId: this.employee.id,
        inventoryId: null,
        quantity: 1,
        deliveryDate: null,
        takenDate: null,
        description: ""
      };
      this.selectedInventoryCategory = 0;
      this.searchInventoryText = "";
    },
    selectInventory(inventory) {
      this.employeeInventory.id = inventory.id
      this.employeeInventory.inventoryId = inventory.inventoryId;
      this.employeeInventory.quantity = inventory.quantity;
      this.employeeInventory.deliveryDate = inventory.deliveryDate;
      this.employeeInventory.takenDate = inventory.takenDate;
      this.employeeInventory.description = inventory.description;
    },
    async deleteEmployeeInventory() {
      try {
        this.isLoading = true;
        let id = this.employeeInventory.id;
        const response = await this.$axios
          .delete("/EmployeeInventory/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 400) {
                alertify.error("Silmek istenilen demirbaş kişi veya ziyaretçilere zimmet olarak tanımlı.");
              }
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        $("#modal-inventory-details").modal("hide");
        this.getEmployeeInventories();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoading = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoading = false;
      }
    },
    async saveEmployeeInventory() {
      if (this.employeeInventory.inventoryId == null || this.employeeInventory.inventoryId == 0) {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
        return;
      }
      if (this.getInventoryFromId(this.employeeInventory.inventoryId).quantity <= this.getInventoryFromId(this.employeeInventory.inventoryId).assignedCount) {
        alertify.warning("Yetersiz stok! Tüm ürün adetleri zaten kişilere atanmış. Lütfen başka bir ürün seçiniz.");
        return;
      }
      if (this.employeeInventory.quantity == null || this.employeeInventory.quantity <= 0) {
        alertify.warning(this.$ml.get("alerts.pleaseEnterValidQuantity"));
        return;
      }
      if (this.employeeInventory.deliveryDate == null || this.employeeInventory.deliveryDate == "") {
        alertify.warning(this.$ml.get("alerts.pleaseSelectDeliveryDate"));
        return;
      }
      try {
        this.isLoading = true;
        const response = await this.$axios
          .post("/EmployeeInventory", this.employeeInventory)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              $("#modal-inventory").modal("hide");
              this.getEmployeeInventories();
            } else {
              response.statusText + " - " + response.data.message;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getInventoryCategories() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/InventoryCategory/GetAll")
          .then(response => {
            this.inventoryCategories = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getInventories() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/Inventory/Inventories")
          .then(response => {
            this.inventories = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getEmployeeInventories() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/EmployeeInventory/GetAll/" + this.employee.id)
          .then(response => {
            this.employeeInventories = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    newDocument() {
      this.document.id = null;
      this.document.documentDefinitionId = null;
      this.document.description = "";
      this.document.filePath = "";
      this.document.isISGDocument = false,
      this.document.starDate = null;
      this.document.endDate = null;
      this.document.isActive = true;
      $('#modal-document').modal('show');
    },
    getDocument(document) {
      this.document.id = document.id;
      this.document.documentDefinitionId = document.documentDefinitionId;
      this.document.description = document.description;
      this.document.filePath = document.filePath;
      this.document.isISGDocument = document.isISGDocument;
      this.document.starDate = this.toDateFormat(document.starDate, "yyyy-aa-gg");
      this.document.endDate = this.toDateFormat(document.endDate, "yyyy-aa-gg");
      this.document.isActive = document.isActive;
      $('#modal-document').modal('show');
    },
    getDocumentDefinitionName(documentDefinitionId) {
      let definition = this.documentDefinitions.find(
        d => d.id === documentDefinitionId
      );
      return definition ? definition.name : "";
    },
    async deleteDocument(documentId) {
      try {
        this.isLoadingDetail = true;
        let id = documentId;
        const response = await this.$axios
          .delete("/EmployeeDocument/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getDocuments(0);
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },
    async saveDocument() {
      if (this.document.documentDefinitionId == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelectADocumentDefinition'));
        return;
      }
      if(this.document.isISGDocument == true && (this.document.starDate == null || this.document.endDate == null)){
        alertify.warning(this.$ml.get('employees.isgDocumentValidity'));
        return;
      }
      if (this.document.id == null) {
        var fileName = document.getElementById("fileName").value;
        var idxDot = fileName.lastIndexOf(".") + 1;
        var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
        if (extFile == "zip" || extFile == "pdf" || extFile == "doc" || extFile == "docx" || extFile == "xls" || extFile == "xlsx" || extFile == "png" || extFile == "jpg" || extFile == "jpeg") {
          if (this.$refs.file.files[0].size > 29000000) { //29 MB
            alertify.warning(this.$ml.with("29 MB").get("alerts.fileSizeIsTooHigh"));
            this.fileId = null;
            this.$refs.file.value = "";
            return;
          }
          this.isLoadingDetail = true;
          try {
            const formData = new FormData();
            formData.append("file", this.$refs.file.files[0]);
            formData.append("employeeId", this.employee.id);
            formData.append("documentDefinitionId", this.document.documentDefinitionId);
            formData.append("description", this.document.description);
            formData.append("isISGDocument", this.document.isISGDocument);
            if (this.document.starDate) {
              formData.append("starDate", this.document.starDate);
            }
            if (this.document.endDate) {
              formData.append("endDate", this.document.endDate);
            }
            const response = await this.$axios
              .post("/EmployeeDocument", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .catch(error => {
                if (error.response) {
                  if (error.response.status == 401) {
                    this.$store.dispatch("logout");
                  }
                } else {
                  if (
                    error.message == "Network Error" ||
                    error.message == "Error: Network Error"
                  ) {
                    alertify.error(this.$ml.get('errors.connectionError'));
                    this.isLoadingDetail = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    this.isLoadingDetail = false;
                    return;
                  }
                }
              });
            let id = response.data.id;
            if (response.status == 200) {
              $("#modal-document").modal("hide");
              alertify.success(this.$ml.get('alerts.savedSuccessfully'));
            } else {
              alertify.error(response.message);
            }
            this.getDocuments(0);
            this.isLoadingDetail = false;
          } catch (error) {
            console.error(error);
            alertify.error(error.message);
            this.isLoadingDetail = false;
          }
        } else {
          alertify.warning(
            this.$ml.get("alerts.pleaseCheckTheFileFormat")
          );
          return;
        }

      } else {
        //GÜNCELLE
        try {
          let document2 = this.document;
          const response = await this.$axios
            .put("/EmployeeDocument/" + document2.id, {
              employeeId: this.employee.id,
              documentDefinitionId: this.document.documentDefinitionId,
              description: this.document.description,
              isISGDocument: this.document.isISGDocument,
              starDate: this.document.starDate,
              endDate: this.document.endDate
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            $("#modal-document").modal("hide");
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getDocuments(0);
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getDocuments(type) { //0 ALL, 1 ISG, 2 OTHER
      try {
        this.isLoading = true;
        this.documents = [];
        const response = await this.$axios
          .get("/EmployeeDocument/GetByEmployeeId/" + this.employee.id + "?type=" + type)
          .then(response => {
            this.documents = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getDocumentDefinitions() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/DocumentDefinition/GetAll")
          .then(response => {
            this.documentDefinitions = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    this.getDefaultDate();
    if (this.defaultFilters) {
      var filter = this.defaultFilters;
      this.setUserAuthorityFilter(filter);
      this.getEmployees();
    }
    this.getAllEmployees();
    this.getReaders();
    this.getDepartments();
    this.getAccessGroups();
    if (this.modules.diningHall) {
      this.getFoodGroups();
    }
    this.getStatus();
    this.getStates();
    this.getTitles();
    this.getWorkGroups();
    this.getExtraFields();
    if (this.modules.annualPermit) {
      this.getAnnualPermits();
    }
    if (this.modules.payroll) {
      this.getOvertimeDescriptions();
      this.getOvertimePlaces();
    }
    this.getAllowences();
    this.getPaymentDefinitions();
    this.getWorkPlaceDefinitions();
    this.getCardDesigns();
    await this.getInventories();
    await this.getInventoryCategories();
    this.getDocumentDefinitions();
    this.requiredFields = this.$store.getters.getRequiredFields;
    //await this.getVisitorCardGroups();
  }
};
</script>

<style scoped>
.fp-kutu-kirmizi {
  width: 50px;
  height: 50px;
  position: absolute;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  padding-top: 10px;
  background-image: url("/src/assets/fingerprint-false.png");
  background-size: cover;
  z-index: 999;
  color: white;
}

.fp-kutu-yesil {
  width: 50px;
  height: 50px;
  position: absolute;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  padding-top: 10px;
  background-image: url("/src/assets/fingerprint-true.png");
  background-size: cover;
  z-index: 999;
  color: white;
}

.customCard {
  width: 323px;
  height: 204px;
  border-radius: 10px;
  display: inline-block;
  border: #ccc solid 2px;
  position: relative;
}

.table>thead>tr>th, .table>tbody>tr>td, .table>tbody>tr>th{
align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/employees/Employees.vue